import _ from "lodash";
import React from "react";
import moment from "moment";
import { extendMoment } from "moment-range";
import {
  getYearDurationFormat,
  getMonthDurationFormat,
  localSearch,
  getDateArrBetweenDates,
  formatDate,
  isUserTypeStaff,
  isUserTypeStudent,
  isUserTypeParent,
  getStringAutoLinks,
  replaceSlashNWithBRTag,
  getStyleStrippedText,
  getInitials,
} from "Utils";
import { colors } from "Constants";
import {
  QuickTaskFilledIcon,
  DiscussionFilledIcon,
  CreateAssessmentSvg,
} from "SvgComponents";
import { nanoid } from "nanoid";
import { getGoogleScopeOfUser } from "services";
import {
  CalendarStarOutlined,
  CalenderScheduleYearFilled,
  VideoFilled,
} from "@toddle-edu/ds-icons";
import { Acronym } from "@toddle-edu/ds-web";
import { getOrganizationConstantsFromCache } from "modules/CommonGraphqlHelpers";
import { getSettingValue } from "modules/PermissionModule";
import update from "immutability-helper";
import { MY_CALENDAR_CONSTANTS } from "MyCalendar/constants/stringConstants";
import { DATE_TIME_CONSTANTS } from "Constants/dateTimeConstants";
import {
  getIncrementedDate,
  getDecrementedDate,
  checkIsDateBefore,
  checkIsDateAfter,
  getPreviousDayDate,
  getNextDayDate,
  getTodaysDate,
  isDateSameOrBefore,
  isDateSameOrAfter,
  getDateTimeDifference,
  isDateInBetween,
  getDateMomentObject,
  isFutureDateTime,
  checkIsDateSame,
  getStartOfDate,
} from "Utils/DateTimeHelpers";
import {
  STAFF,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_DP,
  PROJECT_TYPE_PERSONAL,
  PROJECT_TYPE_COMMUNITY,
  PROJECT_TYPE_SERVICE_AS_ACTION,
  PROJECT_TYPE_DP_EXTENDED_ESSAY,
  PROJECT_TYPE_DP_TOK_ESSAY,
  PROJECT_TYPE_DP_CAS,
  PROJECT_TYPE_DP_TOK_EXHIBITION,
  PROJECT_SUBTYPE_INTERNAL_ASSESSMENT,
  PROJECT_SUBTYPE_EXTERNAL_ASSESSMENT,
  PROJECT_SUBTYPE_SUBJECT_GROUP_PROJECT,
  PROJECT_SUBTYPE_CORE,
  SUBJECT_TYPE_CAS,
  PROJECT_TYPE_CP_REFLECTIVE_PROJECT,
  PROJECT_TYPE_CP_SERVICE_LEARNING,
  HOLIDAYS_AND_VACATIONS,
  WHOLE_SCHOOL_EVENTS,
  CURRICULUM_TYPE_UBD,
} from "Constants/stringConstants";
import {
  isMasterCalendarV1Enabled,
  isMasterCalendarV2Enabled,
  ALL_PROJECT_TAGS,
  INITIAL_CONTENT_TYPES,
  VIEW_FILTER_MAPPING,
  CALENDAR_TYPES,
  ORGANIZATION_PREFERENCE_KEY_PREFIX,
  CCH_SELECTED_CURRICULUMPROGRAM_KEY,
} from "MyCalendar/modules/MyCalendarModule";
import {
  MYP_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
  UBD_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
  MYP_ASSIGNMENT_TYPE_MAPPING,
  VIDEO_MEETING,
  SCHOOL_CALENDAR_EVENT_CREATE_OPTION,
  MYP_PROJECT_DEADLINE_CREATE_OPTION,
  MYP_PROJECT_DEADLINE_CREATE_OPTION_NEW,
  DP_PROJECT_DEADLINE_CREATE_OPTION,
  DP_PROJECT_DEADLINE_CREATE_OPTION_NEW,
  DP_PROJECT_DEADLINE_CREATE_OPTION_STAFF,
  DP_PROJECT_DEADLINE_CREATE_OPTION_STAFF_NEW,
  DP_CP_PROJECT_DEADLINE_CREATE_OPTION,
  DP_CP_PROJECT_DEADLINE_CREATE_OPTION_NEW,
  getClassTagsForCalendar,
  getAssessmentObj,
  getDynamicAssignmentTypeMapping,
} from "ClassRoom/modules/ClassRoomModule";
import { getCourseDetailsFromCache } from "Course/modules/CourseGraphqlHelpers";
import { getShouldShowCourseDisplayName } from "LearningCourses/modules/Utils";
import { getCourseDisplayData } from "LearningCourses/modules/Utils";
import {
  PROJECT_GROUP_TYPE_DP_G4_PROJECT,
  PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT,
} from "Projects/Constants/stringConstants";
import ACLStore from "lib/aclStore";
import { getIsCpCoreEnabled } from "Projects/modules/Utils";
import { ATTENDANCE_GLOBAL_CONSTANTS } from "modules/Services";
import { getUserCoursesFilters } from "Course/modules/CourseModule";
import { getFormattedUserName } from "Utils/GetFormattedUserName";
import { checkIsProjectCoordinator } from "Teacher/routes/Projects/config/constants";
import ACLStorage from "lib/aclService";
import { store } from "store/createStore";
import {
  getChildId,
  getIsParent,
  getIsStaff,
  getOrganizationCurriculumPrograms,
  getSelectedAcademicYearId,
  getSelectedAcademicYear,
} from "modules/CommonSelectors";
import {
  CAN_MANAGE_CALENDAR_EVENTS_AND_MEETINGS_PERMISSION,
  ENABLE_AI_TUTOR,
  CLD3_CAN_MANAGE_CALENDAR_EVENT_TYPES_ACCOUNT_LEVEL_PERMISSION,
  CLD4_CAN_MANAGE_CALENDAR_HOLIDAY_EVENTS_ACCOUNT_LEVEL_PERMISSION,
  CLDC1_CAN_MANAGE_CALENDAR_CLASS_LEVEL_PERMISSION,
  ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION,
  COMBINE_CURRICULUM_HOME_PAGE_PERMISSION,
} from "Constants/permissionConstants";
import { getIsAssessmentTypeConfigurationEnabled } from "Utils/ACLStoreUtils";
import { getUserInfo } from "Utils/UserDetailUtils";
import {
  getIsAdminByRole,
  MODULES,
  hasModuleAdminAccess,
} from "lib/staffPermissionUtils";
import { END_TYPES } from "../components/EventModalV2/context/RepeatEventContext";
import { getProgramListForModule } from "Platform/routes/HomePage/modules/HomePageUtils";
import { HOME_PAGE_FEATURE_CALENDAR } from "Teacher/routes/Courses/components/TeacherCourses/Constants";

export const START_PICKER_START_TIME = "00:00";
export const START_PICKER_END_TIME = "23:30";
export const END_PICKER_START_TIME = "00:30";
export const END_PICKER_END_TIME = "23:59";

export const START_DATE = "START_DATE";
export const END_DATE = "END_DATE";

const colorPool = [
  { backgroundColor: colors.violet500, color: colors.white },
  { backgroundColor: colors.teal500, color: colors.white },
  { backgroundColor: colors.blue400, color: colors.white },
  { backgroundColor: colors.neutral200, color: colors.white },
  { backgroundColor: colors.pink100, color: colors.white },
  { backgroundColor: colors.blue200, color: colors.white },
  { backgroundColor: colors.yellow100, color: colors.white },
  { backgroundColor: colors.teal200, color: colors.white },
  { backgroundColor: colors.teal400, color: colors.white },
  { backgroundColor: colors.salmon60, color: colors.white },
  { backgroundColor: colors.yellow400, color: colors.white },
  { backgroundColor: colors.pink400, color: colors.white },
];

export const EVENT_COLORS = [
  {
    color: "#84eefa",
    textColor: "#333333",
    subTextColor: "var(--text-secondary)",
  },
  {
    color: "#00cae0",
    textColor: "#333333",
    subTextColor: "var(--text-secondary)",
  },
  {
    color: "#ffbfce",
    textColor: "#333333",
    subTextColor: "var(--text-secondary)",
  },
  {
    color: "#ff7d9d",
    textColor: "#333333",
    subTextColor: "var(--text-secondary)",
  },
  {
    color: "#cdc7ff",
    textColor: "#333333",
    subTextColor: "var(--text-secondary)",
  },
  {
    color: "#9591ff",
    textColor: "#333333",
    subTextColor: "var(--text-secondary)",
  },
  {
    color: "#87edd7",
    textColor: "#333333",
    subTextColor: "var(--text-secondary)",
  },
  {
    color: "#16c9a3",
    textColor: "#333333",
    subTextColor: "var(--text-secondary)",
  },
  {
    color: "#ffe28c",
    textColor: "#333333",
    subTextColor: "var(--text-secondary)",
  },
  {
    color: "#ffb200",
    textColor: "#333333",
    subTextColor: "var(--text-secondary)",
  },
  {
    color: "#ffc9b8",
    textColor: "#333333",
    subTextColor: "var(--text-secondary)",
  },
  {
    color: "#ff9c75",
    textColor: "#333333",
    subTextColor: "var(--text-secondary)",
  },
  {
    color: "#ebc2ff",
    textColor: "#333333",
    subTextColor: "var(--text-secondary)",
  },
  {
    color: "#d78dfc",
    textColor: "#333333",
    subTextColor: "var(--text-secondary)",
  },
  {
    color: "#c7e87b",
    textColor: "#333333",
    subTextColor: "var(--text-secondary)",
  },
  {
    color: "#92c223",
    textColor: "#333333",
    subTextColor: "var(--text-secondary)",
  },
  {
    color: "#b26200",
    textColor: "#ffffff",
    subTextColor: "var(--tag-background-neutral-default)",
  },
  {
    color: "#8a064c",
    textColor: "#ffffff",
    subTextColor: "var(--tag-background-neutral-default)",
  },
];

const dsAvatarColors = ["neutral", "violet", "blue", "yellow", "pink", "teal"];

const Moment = extendMoment(moment);

const possibleAllDayEvents = [
  MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT,
  MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT,
  MY_CALENDAR_CONSTANTS.CALENDAR_EVENT_ITEM,
];

export const RECURRING_QUERY_TYPE_MAPPING = {
  EVERY_SCHOOL_DAY: "school_day",
  EVERY_WEEK: "weekly",
  EVERY_TWO_WEEKS: "every_2_weeks",
  MONTHLY_BY_DATE: "monthly_by_date",
  MONTHLY_BY_DAY: "monthly_by_day",
  CUSTOM: "custom",
};

const nonDeadlineProjectGroupTypes = [
  PROJECT_TYPE_SERVICE_AS_ACTION,
  PROJECT_TYPE_DP_CAS,
];

const nonDeadlineDPProjectGroupTypes = [
  PROJECT_TYPE_CP_SERVICE_LEARNING,
  PROJECT_TYPE_DP_CAS,
];

export const getRefetchFunctionForQuery = ({ client, query }) => {
  const currentRoute = window.location.pathname;
  const isCalendarRoute = currentRoute.includes("/my-calendar");
  return () => {
    if (!isCalendarRoute) return;

    try {
      client.refetchQueries({
        include: [query],
      });
    } catch (error) {
      // do nothing As there might be cases when calednar is not in background
    }
  };
};

export const generateDateTimeString = ({ dateString, timeString }) => {
  if (dateString && timeString) {
    return `${dateString}:${timeString}`;
  } else if (dateString) {
    return `${dateString}`;
  } else {
    return null;
  }
};

export const getCalendarParentColorMap = param => {
  const calendarIds = param.calendarIds;
  const colorsInColorPool = colorPool.length;
  return _.reduce(
    calendarIds,
    (result, calendarId, index) => {
      let colorSet = _.head(colorPool);
      if (index >= colorsInColorPool) {
        // repeat color from pool if colorPool exhausted
        colorSet = colorPool[index % colorsInColorPool];
      } else {
        colorSet = colorPool[index];
      }
      result[calendarId] = colorSet;
      return result;
    },
    {}
  );
};

export const getCalendarEventsViewSettingValue = ({
  organizationId,
  currentCurriculumProgramId,
}) => {
  return getSettingValue({
    name: "ShowAssignmentInCalendarBasedOn",
    organizationId,
    currentCurriculumProgramId,
  });
};

const getAssessmentHeaderTitle = ({ assessmentType }) => {
  const isAssessmentTypeConfigurationEnabled = ACLStore.can(
    "FeatureFlag:AssessmentTypeConfiguration"
  );

  if (isAssessmentTypeConfigurationEnabled) {
    // Use getAssessmentObj to get dynamic assessment type mapping
    const assessmentObj = getAssessmentObj({
      assessmentValue: assessmentType,
    });

    if (assessmentObj && assessmentObj.typeLabel) {
      return _.get(assessmentObj, "typeLabel") || "";
    }
  }

  // Fallback to existing logic
  const assessmentObj = _.get(
    MYP_ASSIGNMENT_TYPE_MAPPING,
    `${assessmentType}`,
    null
  );
  if (assessmentObj) {
    return assessmentObj?.typeLabel;
  }
  return "project:assessment";
};

const getAssessmentIcon = ({ assessmentType, isNewCalendarEnabled = true }) => {
  let icon = null;
  let backgroundColor = null;
  let dotColor = null;
  let iconLabel = "";
  const colorKey = isNewCalendarEnabled ? "newColor" : "color";

  switch (assessmentType) {
    case "smt":
      backgroundColor = _.get(
        MYP_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
        `smt.${colorKey}`,
        colors.teal900
      );
      dotColor = _.get(
        MYP_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
        "smt.dotColor",
        colors.teal500
      );
      icon = (
        <Acronym
          background={colors.white}
          size={"xxx-small"}
          color={backgroundColor}
          name={"SA"}
        />
      );
      iconLabel = "S A";
      break;
    case "fmt":
      backgroundColor = _.get(
        MYP_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
        `fmt.${colorKey}`,
        colors.yellow900
      );
      dotColor = _.get(
        MYP_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
        "fmt.dotColor",
        colors.yellow500
      );

      icon = (
        <Acronym
          background={colors.white}
          size={"xxx-small"}
          color={backgroundColor}
          name={"FA"}
        />
      );

      iconLabel = "F A";
      break;
    case "le":
      backgroundColor = _.get(
        MYP_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
        `le.${colorKey}`,
        colors.violet900
      );
      dotColor = _.get(
        MYP_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
        "le.dotColor",
        colors.violet500
      );
      icon = (
        <Acronym
          background={colors.white}
          size={"xxx-small"}
          color={backgroundColor}
          name={"LE"}
        />
      );
      iconLabel = "L E";
      break;
    case "worksheet":
      backgroundColor = _.get(
        MYP_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
        `worksheet.${colorKey}`,
        colors.orange900
      );
      dotColor = _.get(
        MYP_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
        "worksheet.dotColor",
        colors.orange500
      );
      icon = (
        <Acronym
          background={colors.white}
          size={"xxx-small"}
          color={backgroundColor}
          name={"W"}
        />
      );
      iconLabel = "W";
      break;
    case "qt":
      backgroundColor = _.get(
        MYP_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
        `qt.${colorKey}`,
        colors.blue900
      );
      dotColor = _.get(
        MYP_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
        "qt.dotColor",
        colors.blue500
      );
      icon = (
        <Acronym
          background={colors.white}
          size={"xxx-small"}
          color={backgroundColor}
          name={"QT"}
        />
      );
      iconLabel = "Q T";
      break;
    case "pt":
    case "ba":
    case "pri":
      icon = (
        <CreateAssessmentSvg
          fill={colors.white}
          fill1={_.get(
            UBD_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
            "as.color",
            colors.teal900
          )}
        />
      );
      backgroundColor = _.get(
        UBD_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
        `as.${colorKey}`,
        colors.teal900
      );
      dotColor = _.get(
        UBD_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
        "as.dotColor",
        colors.teal500
      );
      break;
    case "ai_tutor":
      backgroundColor = _.get(
        MYP_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
        `ai_tutor.${colorKey}`,
        colors.purple900
      );
      dotColor = _.get(
        MYP_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
        "ai_tutor.dotColor",
        colors.purple500
      );
      icon = (
        <Acronym
          background={colors.white}
          size={"xxx-small"}
          color={backgroundColor}
          name={"AI"}
        />
      );
      iconLabel = "A I";
      break;
    default:
      backgroundColor = isNewCalendarEnabled ? colors.teal900 : colors.blue400;
      dotColor = colors.teal500;
      if (_.isEmpty(assessmentType)) {
        icon = (
          <Acronym
            background={colors.white}
            color={backgroundColor}
            size={"xxx-small"}
            name={"LE"}
          />
        );
        iconLabel = "L E";
      } else {
        icon = (
          <CreateAssessmentSvg fill={colors.white} fill1={backgroundColor} />
        );
      }
  }

  return { icon, backgroundColor, dotColor, iconLabel };
};

const getAssessmentIconForUBD = ({
  assessmentType,
  isNewCalendarEnabled = true,
}) => {
  let icon = null;
  let backgroundColor = null;
  let dotColor = null;
  let iconLabel = "";
  const colorKey = isNewCalendarEnabled ? "newColor" : "color";

  switch (assessmentType) {
    case "le":
      backgroundColor = _.get(
        MYP_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
        `le.${colorKey}`,
        colors.violet900
      );
      dotColor = _.get(
        MYP_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
        "le.dotColor",
        colors.violet500
      );
      icon = (
        <Acronym
          background={colors.white}
          size={"xxx-small"}
          color={backgroundColor}
          name={"LE"}
        />
      );
      iconLabel = "L E";
      break;
    case "worksheet":
      backgroundColor = _.get(
        MYP_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
        `worksheet.${colorKey}`,
        colors.orange900
      );
      dotColor = _.get(
        MYP_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
        "worksheet.dotColor",
        colors.orange500
      );
      icon = (
        <Acronym
          background={colors.white}
          size={"xxx-small"}
          color={backgroundColor}
          name={"W"}
        />
      );
      iconLabel = "W";
      break;
    case "qt":
      backgroundColor = _.get(
        MYP_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
        `qt.${colorKey}`,
        colors.blue900
      );
      dotColor = _.get(
        MYP_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
        "qt.dotColor",
        colors.blue500
      );
      icon = (
        <Acronym
          background={colors.white}
          size={"xxx-small"}
          color={backgroundColor}
          name={"QT"}
        />
      );
      iconLabel = "Q T";
      break;

    case "ai_tutor":
      backgroundColor = _.get(
        MYP_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
        `ai_tutor.${colorKey}`,
        colors.purple900
      );
      dotColor = _.get(
        MYP_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
        "ai_tutor.dotColor",
        colors.purple500
      );
      icon = (
        <Acronym
          background={colors.white}
          size={"xxx-small"}
          color={backgroundColor}
          name={"AI"}
        />
      );
      iconLabel = "A I";
      break;
    default:
      backgroundColor = isNewCalendarEnabled
        ? _.get(
            UBD_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
            `as.${colorKey}`,
            colors.violet900
          )
        : _.get(
            UBD_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
            `as.${colorKey}`,
            colors.violet400
          );
      dotColor = _.get(
        UBD_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
        `as.dotColor`,
        colors.teal500
      );
      if (_.isEmpty(assessmentType)) {
        icon = (
          <Acronym
            background={colors.white}
            color={backgroundColor}
            size={"xxx-small"}
            name={"AS"}
          />
        );
        iconLabel = "A S";
      } else {
        icon = (
          <CreateAssessmentSvg fill={colors.white} fill1={backgroundColor} />
        );
      }
  }

  return { icon, backgroundColor, dotColor, iconLabel };
};
const getEventCountForDate = ({ isoDate, events }) => {
  const filteredEvents = _.filter(events, event => {
    const eventStartDate = _.get(event, "startTime", null);
    const eventEndDate = _.get(event, "endTime", null);
    return isDateInBetween({
      date: isoDate,
      date1: eventStartDate,
      date2: eventEndDate,
    });
  });
  return filteredEvents.length;
};

export const getWeekDays = ({
  week,
  visibleDays,
  selectedDate,
  calendarEvents,
}) => {
  return _.reduce(
    visibleDays,
    (result, item) => {
      const momentDate = moment(selectedDate).isoWeek(week).day(item);
      const isoDateString = momentDate.startOf("day").toDate().toISOString();
      result.push({
        day: momentDate.format("ddd")[0],
        date: momentDate.format("DD"),
        dateString: isoDateString,
        isToday:
          isoDateString === moment().startOf("day").toDate().toISOString(),
        isSelected: isoDateString === selectedDate,
        eventCount: getEventCountForDate({
          isoDate: isoDateString,
          events: calendarEvents,
        }),
      });
      return result;
    },
    []
  );
};

export const getStartEndDateOfWeek = ({
  week,
  visibleDays,
  year,
  selectedDate,
  isNewCalendarEnabled,
}) => {
  const currentDate = isNewCalendarEnabled ? selectedDate : year;
  const startDate = moment(currentDate).isoWeek(week).day(_.min(visibleDays));
  const endDate = moment(currentDate).isoWeek(week).day(_.max(visibleDays));
  return { startDate, endDate };
};

export const getStartEndDateOfWeekV2 = ({ selectedDate }) => {
  const startDate = moment(selectedDate).startOf("week");
  const endDate = moment(selectedDate).endOf("week");
  return { startDate, endDate };
};

export const getStartEndDateOfMonth = ({ currentMonth }) => {
  const startDate = moment(currentMonth).startOf(MY_CALENDAR_CONSTANTS.MONTH);
  const endDate = moment(startDate).endOf(MY_CALENDAR_CONSTANTS.MONTH);
  return { startDate, endDate };
};

export const getDurationText = ({ startDate, endDate }) => {
  return `${getMonthDurationFormat({
    startDate,
    endDate,
  })}, ${getYearDurationFormat({ startDate, endDate })}`;
};

export const getYearDurationFormatV2 = ({ endDate, isSwitcherRendered }) => {
  return `${formatDate({
    date: endDate,
    format: isSwitcherRendered
      ? DATE_TIME_CONSTANTS.YY
      : DATE_TIME_CONSTANTS.YYYY,
  })}`;
};

export const getMonthDurationFormatV2 = ({ startDate, endDate }) => {
  const startMonth = formatDate({
    date: startDate,
    format: DATE_TIME_CONSTANTS.MMM,
  });
  const endMonth = formatDate({
    date: endDate,
    format: DATE_TIME_CONSTANTS.MMM,
  });

  return startMonth !== endMonth
    ? `${startMonth} - ${endMonth}`
    : `${startMonth}`;
};

export const getDurationTextV2 = ({
  startDate,
  endDate,
  isSwitcherRendered,
}) => {
  const separator = isSwitcherRendered ? "' " : ", ";
  return `${getMonthDurationFormatV2({
    startDate,
    endDate,
  })}${separator}${getYearDurationFormatV2({ endDate, isSwitcherRendered })}`;
};

export const getStartEndTimeOfDateRange = ({ startDate, endDate }) => {
  const startDateTime = startDate.startOf("day").toDate().toISOString();
  const endDateTime = endDate.endOf("day").toDate().toISOString();
  return { startDateTime, endDateTime };
};

const getStartEndTimeByEventType = ({
  startTime,
  endTime,
  isEventAllDay,
  itemType,
  itemEventType,
}) => {
  // Note:  moment().toDate() is returns the Date with the system timezone.
  /*

      We recieved time from backend in UTC format,
      but moment reads it in local time zone therefore first we need to
      change the timezone so that moment reads it as UTC time.
      And then converts it to local time zone.

      ".utc(true)" - passing true here changes the timezone to UTC without changing the time

      */

  const isSchoolCalendarEventBoolean = isSchoolCalendarEvent({
    eventType: itemType,
    itemEventType,
  });

  const isProjectDeadlineEventBoolean = isProjectDeadlineEvent({
    eventType: itemType,
  });

  const start =
    isEventAllDay && !isProjectDeadlineEventBoolean
      ? isSchoolCalendarEventBoolean
        ? new Date(moment(moment(startTime)).utc().toISOString()) // since we only save date in case of school calendar event
        : new Date(moment(moment(startTime)).utc(true).toISOString())
      : moment(startTime).toDate();

  const end =
    isEventAllDay && !isProjectDeadlineEventBoolean
      ? isSchoolCalendarEventBoolean
        ? new Date(moment(moment(endTime)).utc().endOf("day").toISOString())
        : new Date(moment(moment(endTime)).utc(true).toISOString())
      : moment(endTime).toDate();

  return {
    start,
    end,
  };
};

export const getFormatedCalendarEvents = ({
  calendarEvents,
  orgId,
  userType,
}) => {
  const formattedEvents = _.reduce(
    calendarEvents,
    (result, event) => {
      const item = _.get(event, "item");
      const itemEventType = _.get(item, "eventType", null);
      const itemType = _.get(event, "itemType");
      const __typename = _.get(item, "__typename");
      const isProjectNewDeadline = __typename == "ProjectTaskResponse";

      // For students, ProjectTaskResponse needs deadline: item?.task so that downstream
      // utils (getEventMetadata, getIsDeadlineAllDay, getEventCreator etc.) can read item.deadline.*
      // previously this we are doing at getCalendarEventsDataEnhancer keeping transformation at one place
      const transformedItem =
        isProjectNewDeadline && !isUserTypeStaff({ userType })
          ? { ...item, deadline: item?.task }
          : item;

      const { title } = getEventMetadata({
        item: transformedItem,
        orgId,
        itemType,
        userType,
      });
      const calendars = _.get(event, "calendars", []);
      const isEventAllDay = isAllDayEvent({
        itemType,
        item: transformedItem,
        userType,
      });
      const { start, end } = getStartEndTimeByEventType({
        startTime: _.get(event, "startTime"),
        endTime: _.get(event, "endTime"),
        isEventAllDay,
        itemType,
        itemEventType,
      });
      const newEvent = {
        id: _.get(event, "id", null),
        title,
        start,
        end,
        allDay: isEventAllDay ? true : undefined,
        itemType,
        item:
          isProjectNewDeadline && isUserTypeStaff({ userType })
            ? { ...item?.task }
            : transformedItem,
        calendars,
      };

      result.push(newEvent);
      return result;
    },
    []
  );

  return formattedEvents;
};

export const getStartEndTimeText = ({ startDate, endDate }) => {
  const isStartEndDateSame =
    moment(startDate).startOf("day").toDate().toISOString() ===
    moment(endDate).startOf("day").toDate().toISOString();

  if (isStartEndDateSame) {
    return `${moment(startDate).format("hh:mm")} - ${moment(endDate).format(
      "hh:mm a"
    )}`;
  } else {
    return `${moment(startDate).format("hh:mm a")} - ${moment(endDate).format(
      "hh:mm a"
    )}`;
  }
};

export const getProjectIconDetails = ({ projectType }) => {
  let icon = null;
  let backgroundColor = null;
  let iconLabel = "";
  switch (projectType) {
    case PROJECT_TYPE_PERSONAL:
      backgroundColor = mypEventTags.PERSONAL.color;
      icon = (
        <Acronym
          background={colors.white}
          size={"xxx-small"}
          color={backgroundColor}
          name={"PP"}
        />
      );
      iconLabel = "P P";
      break;
    case PROJECT_TYPE_COMMUNITY:
      backgroundColor = mypEventTags.COMMUNITY.color;
      icon = (
        <Acronym
          background={colors.white}
          size={"xxx-small"}
          color={backgroundColor}
          name={"CP"}
        />
      );
      iconLabel = "C P";
      break;
    case PROJECT_TYPE_DP_EXTENDED_ESSAY:
      backgroundColor = dpEventTags.DP_EE.color;
      icon = (
        <Acronym
          background={colors.white}
          size={"xxx-small"}
          color={backgroundColor}
          name={"DP"}
        />
      );
      iconLabel = "E E";
      break;
    case PROJECT_TYPE_DP_TOK_ESSAY:
      backgroundColor = dpEventTags.DP_TOK_ESSAY.color;
      icon = (
        <Acronym
          background={colors.white}
          size={"xxx-small"}
          color={backgroundColor}
          name={"DP"}
        />
      );
      iconLabel = "TOK Essay";
      break;
    case PROJECT_TYPE_DP_TOK_EXHIBITION:
      backgroundColor = dpEventTags.DP_TOK_EXHIBITION.color;
      icon = (
        <Acronym
          background={colors.white}
          size={"xxx-small"}
          color={backgroundColor}
          name={"DP"}
        />
      );
      iconLabel = "TOK Exhibition";
      break;
    case PROJECT_TYPE_CP_REFLECTIVE_PROJECT:
      backgroundColor = dpEventTags.CP_REFLECTIVE_PROJECT.color;
      icon = (
        <Acronym
          background={colors.white}
          size={"xxx-small"}
          color={backgroundColor}
          name={"DP"}
        />
      );
      iconLabel = "R P";
      break;
    case PROJECT_SUBTYPE_INTERNAL_ASSESSMENT:
      backgroundColor = dpEventTags.INTERNAL_EXTERNAL_ASSESSMENT.color;
      icon = (
        <Acronym
          background={colors.white}
          size={"xxx-small"}
          color={backgroundColor}
          name={"DP"}
        />
      );
      iconLabel = "I A";
      break;
    case PROJECT_SUBTYPE_EXTERNAL_ASSESSMENT:
      backgroundColor = dpEventTags.INTERNAL_EXTERNAL_ASSESSMENT.color;
      icon = (
        <Acronym
          background={colors.white}
          size={"xxx-small"}
          color={backgroundColor}
          name={"DP"}
        />
      );
      iconLabel = "E A";
      break;
    case PROJECT_GROUP_TYPE_DP_G4_PROJECT:
      backgroundColor = dpEventTags.DP_G4_PROJECT.color;
      icon = (
        <Acronym
          background={colors.white}
          size={"xxx-small"}
          color={backgroundColor}
          name={"DP"}
        />
      );
      iconLabel = "G 4";
      break;
    case PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT:
      backgroundColor = dpEventTags.DP_COLLABORATIVE_SCIENCES_PROJECT.color;
      icon = (
        <Acronym
          background={colors.white}
          size={"xxx-small"}
          color={backgroundColor}
          name={"DP"}
        />
      );
      iconLabel = "C S";
      break;
    case MY_CALENDAR_CONSTANTS.INTERNAL_EXTERNAL_ASSESSMENT:
      backgroundColor = colors.blue400;
      iconLabel = "I A";
      break;
    default:
      break;
  }
  return { icon, backgroundColor, iconLabel };
};

const getAssessmentIconAccordingToCurriculum = ({
  assessmentType,
  isNewCalendarEnabled,
}) => {
  // accessing store directly to avoid passing state in multiple functions
  // selected platform curriculumProgramType is unlikely to change frequently during calendar usage
  // if platform curriculumProgramType change page will reload and store will be updated
  const state = store.getState();
  const { currentCurriculumProgramType } = getSelectedSchoolDetailsForCalendar(
    state
  );
  const isUBDAndCalendarEventAssessmentEnabled = isCalendarEventAssessmentEnabled(
    currentCurriculumProgramType
  );

  // In case of ubd we are ungrouping assessment types
  // to improve accessibilty we are using different icons and colors for each assessment type
  return isUBDAndCalendarEventAssessmentEnabled
    ? getAssessmentIconForUBD({
        assessmentType,
        isNewCalendarEnabled,
      })
    : getAssessmentIcon({
        assessmentType,
        isNewCalendarEnabled,
      });
};

export const getEventMetadata = ({
  item,
  itemType,
  userType,
  orgId,
  calendars,
  isNewCalendarEnabled = true,
  isDailyViewV2,
  currentCurriculumProgramId = null,
}) => {
  if (!item) {
    return {};
  }
  const { content, contentType } = item;
  let backgroundColor = "#e6e6e6";
  let eventIcon = "";
  let color = "#000";
  let title = "";
  let description = "";
  let assessmentType;
  let assessmentIconDetails;
  let headerTitle = "";
  let dotColor = colors.white;
  let eventSlotTextColor = "";
  let eventSlotTimeTextColor = "";
  let iconLabel = "";
  let assessmentValue = "";

  if (itemType === "ASSIGNMENT") {
    description = _.get(content, "label", "");
    assessmentType = _.get(content, "assessmentType.value", "le");
    switch (contentType) {
      case "ASSIGNMENT_DISCUSSION": {
        title = "Class Discussion";
        backgroundColor = colors.teal500;
        dotColor = isDailyViewV2 ? colors.teal500 : dotColor;
        color = colors.white;
        eventIcon = <DiscussionFilledIcon fill={colors.white} />;
        iconLabel = "Discussion";
        break;
      }
      case "ASSIGNMENT_RESOURCE": {
        title = _.get(content, "assignmentTitle", null);
        backgroundColor = colors.teal500;
        dotColor = isDailyViewV2 ? colors.teal500 : dotColor;
        color = colors.white;
        eventIcon = <QuickTaskFilledIcon fill={colors.white} />;
        iconLabel = "Quick Task";
        break;
      }
      case "ASSESSMENT": {
        title = _.get(content, "title.value", null);
        color = colors.white;
        if (
          getIsAssessmentTypeConfigurationEnabled() &&
          currentCurriculumProgramId
        ) {
          const {
            typeLabel: assessmentLabel,
            avatarIconColor: color,
            svg,
          } = getDynamicAssignmentTypeMapping({
            assessmentValue: assessmentType,
            curriculumId: currentCurriculumProgramId,
          });
          eventIcon = svg;
          backgroundColor = `var(--${color}-500)`;
          dotColor = `var(--${color}-500)`;
          assessmentValue = getInitials({ value: assessmentLabel });
          iconLabel = getInitials({ value: assessmentLabel });
          headerTitle = assessmentLabel;
        } else {
          assessmentValue = assessmentType;
          assessmentIconDetails = getAssessmentIconAccordingToCurriculum({
            assessmentType,
            isNewCalendarEnabled,
          });
          eventIcon = _.get(assessmentIconDetails, "icon");
          backgroundColor = _.get(assessmentIconDetails, "backgroundColor");
          dotColor = _.get(assessmentIconDetails, "dotColor");
          headerTitle = getAssessmentHeaderTitle({ assessmentType });
          iconLabel = _.get(assessmentIconDetails, "iconLabel");
        }

        break;
      }
      case "ASSIGNMENT_MEETING": {
        assessmentValue = _.get(item, "eventType", "");
        title = _.get(content, "assignmentTitle", null);
        backgroundColor = colors.teal500;
        color = colors.white;
        dotColor = isDailyViewV2 ? colors.teal500 : dotColor;
        eventIcon = (
          <VideoFilled
            style={{
              color: colors.white,
            }}
          />
        );
        headerTitle = "common:video_meeting_lower";
        iconLabel = "Video Meeting";
        break;
      }
    }

    /**
     * if user is staff then  show course wise colors
     */
    if (
      userType === "staff" &&
      contentType !== "ASSIGNMENT_MEETING" &&
      !getIsAssessmentTypeConfigurationEnabled()
    ) {
      assessmentIconDetails = getAssessmentIconAccordingToCurriculum({
        assessmentType,
        isNewCalendarEnabled,
      });

      eventIcon = _.get(assessmentIconDetails, "icon");
      color = colors.white;
      backgroundColor = _.get(assessmentIconDetails, "backgroundColor");
      dotColor = _.get(assessmentIconDetails, "dotColor");
      headerTitle = getAssessmentHeaderTitle({ assessmentType });
      iconLabel = _.get(assessmentIconDetails, "iconLabel");
    }
  } else if (
    itemType === MY_CALENDAR_CONSTANTS.CALENDAR_EVENT_ITEM ||
    itemType === MY_CALENDAR_CONSTANTS.VIDEO_MEETING
  ) {
    const colorKey = isNewCalendarEnabled ? "newColor" : "color";
    title = _.get(item, "label");
    description = _.get(item, "description", "");
    const eventType = _.get(item, "eventType", "");
    backgroundColor =
      eventType === MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT
        ? _.toLower(_.get(item, "tag.colorCode"))
        : _.get(VIDEO_MEETING, colorKey, colors.pink300);
    eventSlotTextColor =
      eventType === MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT
        ? _.get(
            _.find(EVENT_COLORS, { color: backgroundColor }),
            "textColor",
            "var(--text-primary)"
          )
        : "var(--text-inverse)";
    eventSlotTimeTextColor =
      eventType === MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT
        ? _.get(
            _.find(EVENT_COLORS, { color: backgroundColor }),
            "textColor",
            "var(--text-primary)"
          )
        : "";
    dotColor = _.get(VIDEO_MEETING, "dotColor", colors.pink200);
    color = colors.white;
    eventIcon = (
      <VideoFilled
        style={{
          color: colors.white,
        }}
      />
    );
    iconLabel =
      eventType === MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT
        ? ""
        : "Video Meeting";
    headerTitle = "common:video_meeting_lower";
    assessmentValue = eventType;
  } else if (itemType === MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT) {
    title = _.get(item, "title");
    eventIcon = <CalenderScheduleYearFilled variant="on" size="xxx-small" />;
    iconLabel = "";
    backgroundColor = _.toLower(_.get(item, "tag.colorCode"));
    dotColor = isDailyViewV2 ? backgroundColor : dotColor;
    eventSlotTextColor = _.get(
      _.find(EVENT_COLORS, { color: backgroundColor }),
      "textColor",
      colors.textOn
    );

    if (!backgroundColor && orgId) {
      // if no background color then use the color from org constant

      // get event tags from cache
      const calendarEventTags = _.get(
        getOrganizationConstantsFromCache(orgId),
        "calendarEventTags",
        {}
      );

      // assign color where item's category matches tag name
      backgroundColor = _.get(
        _.find(calendarEventTags, tag => {
          return tag.name === _.get(item, "category");
        }),
        "color_code"
      );
    }
  } else if (itemType === MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT) {
    let projectType, projectSubType;
    const isUserParent = userType === "parent";
    color = colors.white;
    if (userType === "staff") {
      title = _.get(item, "deadlineTitle");
      projectType = _.get(item, "projectGroup.type");
      projectSubType = _.get(item, "projectGroup.subType");
    } else if (userType === "student" || canFamilyViewDeadline(isUserParent)) {
      title = _.get(item, "deadline.deadlineTitle");
      projectType = _.get(item, "deadline.projectGroup.type");
      projectSubType = _.get(item, "deadline.projectGroup.subType");
    }
    let finalProjectType = projectSubType;
    if (
      _.includes(
        [PROJECT_SUBTYPE_CORE, PROJECT_SUBTYPE_SUBJECT_GROUP_PROJECT],
        projectSubType
      )
    ) {
      finalProjectType = projectType;
    }
    const projectIconDetails = getProjectIconDetails({
      projectType: finalProjectType,
    });
    backgroundColor = _.get(projectIconDetails, "backgroundColor");
    eventIcon = _.get(projectIconDetails, "icon");
    eventSlotTextColor = colors.white;
    iconLabel = _.get(projectIconDetails, "iconLabel");
    dotColor = isDailyViewV2 ? backgroundColor : dotColor;
  }
  return {
    backgroundColor,
    color,
    eventIcon,
    title,
    description,
    headerTitle,
    dotColor,
    eventSlotTextColor,
    eventSlotTimeTextColor,
    iconLabel,
    assessmentValue,
  };
};

export const getCourseWiseUsersDetails = (coursesArr, usersArr) => {
  let students = [],
    filteredStudent;
  const segregatedArr = [];

  _.forEach(coursesArr, course => {
    students = [];
    _.forEach(_.get(course, "allStudents.edges", []), student => {
      if (
        !_.isEmpty(
          (filteredStudent = _.find(
            usersArr,
            user => user.id === student.node.id
          ))
        )
      ) {
        students.push(filteredStudent);
      }
    });
    segregatedArr.push({
      id: course.id,
      title: course.title,
      students,
      totalStudents: _.get(course, "allStudents.edges", []),
    });
  });
  return segregatedArr;
};

export const getFilteredCourseList = ({ courseList, searchedText }) => {
  const shouldShowDisplayNames = getShouldShowCourseDisplayName();
  return _.filter(courseList, course => {
    const label = _.get(course, "label", "");
    const courseDisplayName =
      _.get(course, "learningCourse[0].academicCourse.label") ||
      _.get(course, "learningCourse[0].title", "");
    const index = localSearch({
      text: shouldShowDisplayNames ? courseDisplayName : label,
      searchText: searchedText,
    });

    return index > -1 || _.isEmpty(searchedText);
  });
};

export const getButtonLabelTextMemoize = _.memoize(
  params => getButtonLabelText(params),
  params => JSON.stringify(params)
);

const getButtonLabelText = ({
  calendarIds = [],
  notUserCourseIds = [],
  courseList,
  otherCourseList,
  allCourseList,
  t,
  labelLength = 8,
  isStaffUser,
}) => {
  const selectedCourseIds = _.uniq(_.concat(calendarIds, notUserCourseIds));
  const selectedIds = isStaffUser
    ? _.size(selectedCourseIds)
    : _.size(calendarIds);
  if (selectedIds === 0) {
    return t("common:none");
  } else if (selectedIds === 1) {
    if (_.size(calendarIds) === 1) {
      const label = _.get(
        _.find(courseList, ({ value }) => value === calendarIds[0]),
        "label",
        ""
      );
      return _.truncate(label, {
        length: labelLength,
      });
    } else {
      const label = _.get(
        _.find(otherCourseList, ({ value }) => value === notUserCourseIds[0]),
        "label",
        ""
      );
      return _.truncate(label, {
        length: labelLength,
      });
    }
  } else if (selectedIds === _.size(allCourseList)) {
    return t("common:all");
  } else {
    return isStaffUser ? selectedCourseIds : calendarIds;
  }
};

export const getButtonLabelTextMemoizeHeader = _.memoize(
  params => getButtonLabelTextHeader(params),
  params => JSON.stringify(params)
);

const getButtonLabelTextHeader = ({ value, courseList, t }) => {
  const selectedIds = _.size(value);
  if (selectedIds === 0) {
    return t("calendar:no_class");
  } else if (selectedIds === _.size(courseList)) {
    return t("common:all_classes_plural");
  } else {
    return t("common:classes_with_count", {
      count: selectedIds,
    });
  }
};

export const getCourseOptionsMemoize = _.memoize(
  params => getCourseOptions(params),
  params => JSON.stringify(params)
);

/**
 * @deprecated Use getCourseOptions instead. This function has O(n²) complexity.
 * Legacy function for backwards compatibility.
 */
export const oldGetCourseOptions = ({
  courseList,
  allowGradesSegregation = true,
}) => {
  return _.reduce(
    courseList,
    (courseOptions, course) => {
      const courseLabel = _.get(course, "label", "");
      const courseValue = _.get(course, "value", "");
      const learningCourseId = _.get(course, "learningCourse.0.id", "");
      const learningCourseTitle = _.get(course, "learningCourse.0.title", "");

      if (!allowGradesSegregation) {
        courseOptions.push({
          label: courseLabel,
          value: courseValue,
          learningCourseId,
          learningCourseTitle,
        });
        return courseOptions;
      }

      const gradeLabel = _.get(course, "grade.name");
      const idx = _.findIndex(
        courseOptions,
        courseOption => _.get(courseOption, "label") === gradeLabel
      );
      const gradeValue = _.get(course, "grade.id", "");
      const displaySequence = _.get(course, "grade.displaySequence", 0);

      if (idx !== -1) {
        courseOptions[idx]?.options.push({
          label: courseLabel,
          value: courseValue,
          learningCourseId,
          learningCourseTitle,
        });
      } else {
        courseOptions.push({
          label: gradeLabel,
          value: gradeValue,
          displaySequence,
          options: [
            {
              label: courseLabel,
              value: courseValue,
              learningCourseId,
              learningCourseTitle,
            },
          ],
        });
      }
      return courseOptions;
    },
    []
  );
};

/**
 * Optimized function to get course options with O(n) time complexity.
 * Uses lodash groupBy for efficient grade segregation.
 *
 * @param {Object} params - Parameters object
 * @param {Array} params.courseList - Array of courses
 * @param {boolean} params.allowGradesSegregation - Whether to group by grades
 * @returns {Array} Array of course options, optionally grouped by grades
 */
export const getCourseOptions = ({
  courseList,
  allowGradesSegregation = true,
  fromMarkedExcusals = false,
}) => {
  // Early return for simple case without grade segregation
  if (!allowGradesSegregation) {
    return _.map(courseList, course => {
      const courseLabel = _.get(course, "label", "");
      return {
        label: courseLabel,
        value: _.get(course, "value", ""),
        learningCourseId: _.get(course, "learningCourse.0.id", ""),
        learningCourseTitle: _.get(course, "learningCourse.0.title", ""),
        learningCourseDisplayName: _.get(
          course,
          "learningCourse[0].academicCourse.label",
          ""
        ),
        showItemTooltip: _.size(courseLabel) > (fromMarkedExcusals ? 30 : 31),
      };
    });
  }

  // Group courses by grade label using lodash groupBy - O(n) operation
  const coursesByGrade = _.groupBy(courseList, course =>
    _.get(course, "grade.name")
  );

  // Transform grouped courses into the expected format - O(k) where k is number of unique grades
  return _.map(coursesByGrade, (courses, gradeLabel) => {
    // Get grade info from the first course in the group (all courses in same grade have same grade info)
    const firstCourse = _.head(courses);
    const gradeValue = _.get(firstCourse, "grade.id", "");
    const displaySequence = _.get(firstCourse, "grade.displaySequence", 0);

    // Map all courses in this grade to the options format
    const options = _.map(courses, course => {
      const courseLabel = _.get(course, "label", "");
      return {
        label: courseLabel,
        value: _.get(course, "value", ""),
        learningCourseId: _.get(course, "learningCourse.0.id", ""),
        learningCourseTitle: _.get(course, "learningCourse.0.title", ""),
        learningCourseDisplayName: _.get(
          course,
          "learningCourse.0.academicCourse.label"
        ),
        showItemTooltip: _.size(courseLabel) > (fromMarkedExcusals ? 30 : 31),
      };
    });

    return {
      label: gradeLabel,
      value: gradeValue,
      displaySequence,
      options,
    };
  });
};

export const getCourseOptionsV2 = ({
  courseList,
  allowGradesSegregation = true,
}) => {
  return _.sortBy(
    getCourseOptions({ courseList, allowGradesSegregation }),
    "displaySequence"
  );
};

export const getProjectGroupCourses = ({ projectGroups, projectGroupId }) => {
  const projectGroup = _.find(projectGroups, { id: projectGroupId });
  const projectGroupCoursesEdges = _.get(projectGroup, "courses.edges", []);
  return _.map(projectGroupCoursesEdges, ({ node }) => node);
};

export const getCourseList = ({ courses }) => {
  return _.map(courses, course => ({
    courseId: _.get(course, "id"),
    label: _.get(course, "title"),
    value: _.get(course, ["calendar", "id"], null),
    students: _.get(course, ["students", "edges"], []),
    grade: _.get(course, ["grade"], {}),
    subjects: _.get(course, ["subjects"], []),
    primaryGrade: _.get(course, ["primaryGrade"], {}),
    academicYears: _.get(course, ["academicYears"], []),
    genericTags: _.get(course, ["genericTags"], []),
    enabledModules: _.get(course, "enabledModules", []),
    aclControlParameters: _.get(course, "aclControlParameters", []),
    learningCourse: _.get(course, "learningCourse", []),
  }));
};

const getCourseFolderList = ({ courseFolders }) => {
  return _.reduce(
    courseFolders,
    (result, folder) => {
      result.push({ label: folder.name, value: folder.id });
      return result;
    },
    []
  );
};

export const getCourseFolderListMemoize = _.memoize(
  params => getCourseFolderList(params),
  params => JSON.stringify(params)
);

export const getCourseIdsFromSelectedCalendarIds = ({
  courseList,
  calendarIds,
}) => {
  const calendarToCourseMap = _.keyBy(courseList, "value");
  const selectedCourses = _.pick(calendarToCourseMap, calendarIds);
  return _.compact(_.map(selectedCourses, "courseId"));
};

export const checkUserAuthScopes = async ({ accessToken, scopes }) => {
  try {
    const userScopeData = await getGoogleScopeOfUser({ accessToken });
    const userScopes = _.split(_.get(userScopeData, "scope", null), " ");
    if (
      !userScopes ||
      _.intersection(userScopes, scopes).length !== scopes.length
    ) {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
};

export const isWeekNumberInAcademicYear = ({
  weekNumber,
  visibleDays,
  yearStartDate,
  yearEndDate,
  selectedDate,
}) => {
  const { startDate, endDate } = getStartEndDateOfWeek({
    week: weekNumber,
    visibleDays,
    year: selectedDate,
  });
  if (
    startDate.diff(moment(yearStartDate), "day") >= -6 &&
    endDate.diff(moment(yearEndDate), "day") <= -1
  ) {
    return true;
  }
  return false;
};

export const findAllDayEvent = ({
  calendarEvents,
  startDate,
  endDate,
  userType,
}) => {
  return _.find(calendarEvents, ({ item, itemType, startTime, endTime }) => {
    if (
      isDateSameOrBefore(startTime, endDate) &&
      isDateSameOrAfter(endTime, startDate)
    )
      return isAllDayEvent({
        itemType,
        item,
        userType,
      });
  });
};

// returns true if date is between start and end
export const isDateInRange = (date, start, end) => {
  const range = Moment().range(start, end);
  return range.contains(new Date(date));
};

export const getSelectedDateEvents = ({ calendarEvents, selectedDate }) =>
  _.filter(calendarEvents, event => {
    return isDateInRange(selectedDate, event.startTime, event.endTime);
  });

export const getUpdatedStartAndEndDateEvents = ({ events, selectedDate }) => {
  return _.map(events, event => {
    // check if event is a school calendar event
    if (
      (event.itemType === MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT ||
        _.get(event, "item.eventType") ===
          MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT) &&
      _.get(event, "item.isFullDayEvent", true)
    ) {
      // check if selected date falls between start and end
      if (
        isDateInRange(
          selectedDate,
          moment(event.start).format("YYYY-MM-DD"),
          moment(event.end).format("YYYY-MM-DD")
        )
      ) {
        // [hack] assign start date and end date to selected date inorder to show in current selected date's pane

        // convert to system timezone using toDate() and then send this data to big calendar
        return Object.assign({}, event, {
          start: moment(selectedDate).toDate(),
          end: moment(selectedDate).toDate(),
        });
      }
    }
    return event;
  });
};

const getListEventDuration = ({ event, isWidgetList = false, t }) => {
  if (event?.allDay) {
    return t("common:all_day");
  }

  const { start, end } = event;
  let startTimeFormat = DATE_TIME_CONSTANTS.hh_mm_a;

  /**
   * If times are both AM or both PM, then show AM/PM in end time only
   * For eg. 10:00 - 11:00 AM
   * else show like - 11:00 AM - 01:00 PM
   */
  if (isWidgetList) {
    const formattedStartTime = formatDate({ date: start, format: "a" });
    const formattedEndTime = formatDate({ date: end, format: "a" });

    if (formattedStartTime === formattedEndTime) {
      startTimeFormat = DATE_TIME_CONSTANTS.hh_mm;
    }
  }

  return `${moment(end).format(DATE_TIME_CONSTANTS.hh_mm_a)}`;
};

export const generateListViewEventData = ({
  event,
  eventDate,
  eventMonth,
  eventDay,
  eventFullDate,
  t,
  userType,
  isWidgetList = false,
  formattedDeadlineDate,
}) => {
  const { item, itemType } = event;
  const {
    firstName = "",
    lastName = "",
    id = "",
    middleName = "",
  } = getEventCreator({
    item,
    itemType,
    userType,
  });
  const name = getFormattedUserName({
    user: {
      firstName,
      lastName,
      middleName,
    },
    type: userType,
  });
  return {
    ...event,
    eventDate,
    eventFullDate,
    eventMonthAndDay: `${eventMonth}, ${eventDay}`,
    eventDuration: getListEventDuration({ event, isWidgetList, t }),
    createdBy: name,
    authorId: id,
    formattedDeadlineDate,
  };
};

const getFormattedEventDate = ({ currentDate }) => {
  const eventDate = formatDate({
    date: currentDate,
    format: DATE_TIME_CONSTANTS.DD,
  });
  const eventMonth = formatDate({
    date: currentDate,
    format: DATE_TIME_CONSTANTS.MMM,
  });
  const eventDay = formatDate({
    date: currentDate,
    format: DATE_TIME_CONSTANTS.ddd,
  });
  return { eventDate, eventMonth, eventDay };
};

export const getSegregatedEvents = ({
  event,
  start,
  end,
  t,
  userType,
  formattedDateRange,
  isWidgetList = false,
}) => {
  const dateArr = getDateArrBetweenDates({ start, end });
  return _.reduce(
    dateArr,
    (result, { eventDate: currentDate }) => {
      const { eventDate, eventMonth, eventDay } = getFormattedEventDate({
        currentDate,
      });
      const isDateInRange = _.includes(formattedDateRange, eventDate);
      if (isDateInRange) {
        return [
          ...result,
          generateListViewEventData({
            event,
            eventDate,
            eventMonth,
            eventDay,
            eventFullDate: formatDate({
              date: currentDate,
              format: DATE_TIME_CONSTANTS.YYYY_MM_DD,
            }),
            t,
            userType,
            isWidgetList,
          }),
        ];
      } else {
        return result;
      }
    },
    []
  );
};

export const getFormattedListViewEvents = ({
  events,
  t,
  dateRange,
  userType,
  checkIsBefore = false,
  isWidgetList = false,
}) => {
  return _.reduce(
    events,
    (result, event) => {
      const { start, end } = event;
      if (checkIsBefore && !event?.allDay) {
        if (
          checkIsDateBefore({
            date1: end,
            date2: getTodaysDate(),
            key: DATE_TIME_CONSTANTS.SECOND,
          })
        ) {
          return result;
        }
      }

      const formattedDeadlineDate = formatDate({
        date: end,
        format: DATE_TIME_CONSTANTS.DD_MMM_YYYY,
      });

      const formattedStartDate = formatDate({ date: start, format: "DD" });
      const formattedEndDate = formatDate({ date: end, format: "DD" });

      // If event start date is out of range, then remove it
      const formattedDateRange = _.map(dateRange, currentDate =>
        formatDate({ date: currentDate, format: DATE_TIME_CONSTANTS.DD })
      );

      /**
       * CASE : single day event

       * If start and end date are same return single formatted event
       */
      if (formattedStartDate === formattedEndDate) {
        const isDateInRange = _.includes(
          formattedDateRange,
          formattedStartDate
        );
        if (!isDateInRange) {
          return result;
        }
        const updatedEvent = generateListViewEventData({
          event,
          formattedDeadlineDate,
          eventDate: formattedStartDate,
          eventMonth: formatDate({ date: start, format: "MMM" }),
          eventDay: formatDate({ date: start, format: "ddd" }),
          eventFullDate: formatDate({
            date: start,
            format: DATE_TIME_CONSTANTS.YYYY_MM_DD,
          }),
          t,
          userType,
          isWidgetList,
        });
        return [...result, updatedEvent];
      }

      /**
       * CASE : multi day event

       * If start and end date are different, then create multiple events.
       * These events will have different eventDate but same event data.
       * For eg. startDate = 22 and endDate = 25, then after segregation,
         there will be 4 events with evenDate 22, 23, 24, 25 but same event data.
       */
      const segregatedEvents = getSegregatedEvents({
        event,
        start,
        end,
        t,
        userType,
        formattedDateRange,
        isWidgetList,
      });

      return [...result, ...segregatedEvents];
    },
    []
  );
};

export const getGroupedSameDayEvents = ({ events }) => {
  return _.reduce(
    events,
    (result, event) => {
      const eventFullDate = _.get(event, "eventFullDate", "");
      if (_.isEmpty(result[eventFullDate])) {
        result = update(result, {
          [eventFullDate]: { $set: [] },
        });
      }
      result = update(result, {
        [eventFullDate]: { $push: [event] },
      });
      return result;
    },
    {}
  );
};

const formatCalendarEventsTags = ({ calendarEventsTags }) => {
  return _.reduce(
    calendarEventsTags,
    (eventObject, subEvent) => {
      if (_.isEmpty(subEvent?.label)) {
        return eventObject;
      }
      return {
        ...eventObject,
        [subEvent?.id]: {
          id: subEvent?.id,
          typeLabel: subEvent?.label,
          color: subEvent?.colorCode,
        },
      };
    },
    {}
  );
};

export const getFormattedListViewEventsMemoize = _.memoize(
  params => getFormattedListViewEvents(params),
  params => JSON.stringify(params)
);

export const getGroupedSameDayEventsMemoize = _.memoize(
  params => getGroupedSameDayEvents(params),
  params => JSON.stringify(params)
);

export const getStartEndDateOfList = ({ currentStartDate }) => {
  return {
    startDate: currentStartDate,
    endDate: getIncrementedDate({
      date: currentStartDate,
      key: DATE_TIME_CONSTANTS.DAY,
      incrementBy: 6,
    }),
  };
};

export const getStartEndDateRange = ({
  calendarView,
  visibleDays,
  week,
  currentMonth,
  endYear,
  currentStartDate,
  selectedDate,
  isNewCalendarEnabled,
}) => {
  switch (calendarView) {
    case MY_CALENDAR_CONSTANTS.MONTH: {
      const { startDate, endDate } = getStartEndDateOfMonth({
        currentMonth,
      });
      return { startDate, endDate };
    }
    case MY_CALENDAR_CONSTANTS.LIST: {
      const { startDate, endDate } = getStartEndDateOfList({
        currentStartDate,
      });
      return { startDate, endDate };
    }
    default: {
      const { startDate, endDate } = getStartEndDateOfWeek({
        week,
        visibleDays,
        year: endYear,
        selectedDate,
        isNewCalendarEnabled,
      });
      return { startDate, endDate };
    }
  }
};

export const getWeeklyCalendarData = ({
  isCurrentAcademicYear,
  isUpcomingAcademicYear,
  startDate,
  endDate,
}) => {
  let week = moment().isoWeek();
  let selectedDate = moment().startOf("day");
  if (!isCurrentAcademicYear) {
    if (isUpcomingAcademicYear) {
      week = moment(startDate).isoWeek();
      selectedDate = moment(startDate).startOf("day");
    } else {
      week = moment(endDate).isoWeek();
      selectedDate = moment(endDate).startOf("day");
    }
  }
  return { week, selectedDate };
};

export const getListCalendarData = ({
  isCurrentAcademicYear,
  isUpcomingAcademicYear,
  startDate,
  endDate,
}) => {
  if (!isCurrentAcademicYear) {
    if (isUpcomingAcademicYear) {
      return {
        currentStartDate: getIncrementedDate({
          date: startDate,
          key: DATE_TIME_CONSTANTS.DAY,
          incrementBy: 6,
        }),
      };
    } else {
      return {
        currentStartDate: getDecrementedDate({
          date: endDate,
          key: DATE_TIME_CONSTANTS.DAY,
          decrementBy: 6,
        }),
      };
    }
  }

  return { currentStartDate: getTodaysDate() };
};

export const getMonthlyCalendarData = ({
  isCurrentAcademicYear,
  isUpcomingAcademicYear,
  startDate,
  endDate,
}) => {
  if (!isCurrentAcademicYear) {
    if (isUpcomingAcademicYear) {
      return {
        currentMonth: moment(startDate),
      };
    } else {
      return {
        currentMonth: moment(endDate),
      };
    }
  }

  return { currentMonth: getTodaysDate() };
};

export const getAllCalendarData = ({
  isCurrentAcademicYear,
  isUpcomingAcademicYear,
  startDate,
  endDate,
}) => {
  const { week, selectedDate } = getWeeklyCalendarData({
    isCurrentAcademicYear,
    isUpcomingAcademicYear,
    startDate,
    endDate,
  });

  const { currentStartDate } = getListCalendarData({
    isCurrentAcademicYear,
    isUpcomingAcademicYear,
    startDate,
    endDate,
  });

  const { currentMonth } = getMonthlyCalendarData({
    isCurrentAcademicYear,
    isUpcomingAcademicYear,
    startDate,
    endDate,
  });

  return {
    week,
    selectedDate,
    currentStartDate,
    currentMonth,
  };
};

export const getEmptyEventData = ({ date }) => {
  return {
    id: date,
    eventDate: `${date.format("DD")}`,
    eventMonthAndDay: `${date.format("MMM")}, ${date.format("ddd")}`,
    formattedDeadlineDate: formatDate({
      date,
      format: DATE_TIME_CONSTANTS.DD_MMM_YYYY,
    }),
  };
};

export const getCourseId = ({ itemType, calendars }) => {
  if (itemType === MY_CALENDAR_CONSTANTS.ASSIGNMENT) {
    return _.get(
      _.find(calendars, { parentType: MY_CALENDAR_CONSTANTS.COURSE }),
      "parent.id",
      null
    );
  }
  return null;
};

export const getEventCreator = ({ item, itemType, userType }) => {
  switch (itemType) {
    case MY_CALENDAR_CONSTANTS.CALENDAR_EVENT_ITEM:
      return _.get(item, "meeting.createdBy", {});
    case MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT:
      return _.get(item, "author", {});
    case MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT:
      if (userType === "staff") {
        return _.get(item, "creatorUser", {});
      } else if (userType === "student") {
        return _.get(item, "deadline.creatorUser", {});
      }
      return {};
    default:
      return _.get(item, "createdBy", {});
  }
};

/**
 * Transforms calendar events assigned data into a map format
 * @param {Object} params - Parameters object
 * @param {Array} params.calendarEvents - Array of calendar events
 * @param {string} params.userType - Type of user (staff/student)
 * @param {Function} params.t - Translation function
 * @returns {Object} Map of event IDs to their assigned entity names
 */
export const getCalendarEventsParticipantDataMap = ({
  calendarEvents = [],
  userType,
  t,
}) => {
  return _.reduce(
    calendarEvents,
    (result, event) => {
      const item = _.get(event, "item");
      const itemType = _.get(event, "itemType");
      const itemId = _.get(item, "id");

      if (!itemId) {
        return result;
      }

      let assignedValue = "";

      // Assignment: use course title
      if (itemType === MY_CALENDAR_CONSTANTS.ASSIGNMENT) {
        assignedValue = _.get(
          getCourseDisplayData(_.get(item, "course", {})),
          "name"
        );
      }
      // Calendar Event Item: use users count, grade name, or course title
      else if (
        itemType === MY_CALENDAR_CONSTANTS.CALENDAR_EVENT_ITEM ||
        itemType === MY_CALENDAR_CONSTANTS.VIDEO_MEETING
      ) {
        const users = _.get(item, "users", []);
        const associatedEntities = _.get(item, "associatedEntities", []);

        if (!_.isEmpty(users)) {
          const userCount = _.size(users);
          assignedValue = t("common:participant_with_count", {
            count: userCount,
          });
        } else if (!_.isEmpty(associatedEntities)) {
          const grades = _.filter(
            associatedEntities,
            entity => _.get(entity, "__typename") === "Grade"
          );
          const courses = _.filter(
            associatedEntities,
            entity => _.get(entity, "__typename") === "Course"
          );

          if (!_.isEmpty(grades)) {
            const gradeNames = _.map(grades, grade => _.get(grade, "name", ""));
            assignedValue = gradeNames;
          } else if (!_.isEmpty(courses)) {
            const courseTitles = _.map(courses, course =>
              _.get(getCourseDisplayData(course), "name")
            );
            assignedValue = courseTitles;
          }
        }
      }
      // Project Deadline
      else if (itemType === MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT) {
        if (isUserTypeStaff({ userType })) {
          assignedValue = _.get(item, "projectGroup.yearGroup.name", "");
        } else if (isUserTypeStudent({ userType })) {
          assignedValue = _.get(
            item,
            "deadline.projectGroup.yearGroup.name",
            ""
          );
        }
      }
      // Project Task Response (for students)
      else if (item.__typename === "ProjectTaskResponse") {
        assignedValue = _.get(item, "task.projectGroup.yearGroup.name", "");
      }
      // Project Group Task (for staff)
      else if (
        item.__typename === "ProjectGroupTask" ||
        item.__typename === "ProjectGroupDeadline"
      ) {
        assignedValue = _.get(item, "projectGroup.yearGroup.name", "");
      }

      if (!_.isEmpty(assignedValue)) {
        result[itemId] = assignedValue;
      }

      return result;
    },
    {}
  );
};

export const formatCalendarEventsTagsMemoize = _.memoize(
  params => formatCalendarEventsTags(params),
  params => JSON.stringify(params)
);

const getTagList = ({ searchText = "", data, withoutLocales, t }) => {
  const isAssessmentTypeConfigurationEnabled = getIsAssessmentTypeConfigurationEnabled();
  return _.reduce(
    data,
    (tagList, curr, key) => {
      const type = _.get(curr, "type");
      const typeLabel = _.get(curr, "typeLabel");
      let allowLocales = !withoutLocales;
      if (type && _.includes(["dpTags", "mypTags", "assessmentTypes"], type)) {
        allowLocales = true;
      }
      const label = !allowLocales ? typeLabel : t(typeLabel);
      if (!_.includes(_.toLower(label), _.toLower(searchText))) {
        return tagList;
      }
      return [
        ...tagList,
        {
          label,
          value: isAssessmentTypeConfigurationEnabled
            ? _.get(curr, "uid", key)
            : key,
        },
      ];
    },
    []
  );
};
export const getTagListMemoize = _.memoize(
  params => getTagList(params),
  ({ searchText = "", data, withoutLocales }) =>
    JSON.stringify({
      searchText,
      dataIds: _.values(data),
      withoutLocales,
    })
);

const getTagColorList = ({ data, assessmentTags = [] }) => {
  const event_color_list = {};
  let colorKey = "color";

  _.forEach(data, (category, key) => {
    if (!_.isEmpty(assessmentTags) && _.includes(assessmentTags, key)) {
      colorKey = "newColor";
    }
    event_color_list[key] = _.get(category, colorKey);
  });

  return event_color_list;
};

export const getTagColorListMemoize = _.memoize(
  params => getTagColorList(params),
  params => JSON.stringify(params)
);

export const getTickVariantList = ({ data, assessmentTags = [] }) => {
  return _.reduce(
    data,
    (tickVariantList, category, key) => {
      tickVariantList[key] = "light";
      return tickVariantList;
    },
    {}
  );
};

export const getTickVariantListMemoize = _.memoize(
  params => getTickVariantList(params),
  params => JSON.stringify(params)
);

export const getFilteredCalendarEvents = ({
  calendarEvents,
  dateRange,
  userType,
  t,
  checkIsBefore = false,
  isWidgetList = false,
}) => {
  const formattedCalendarEvents = getFormatedCalendarEvents({
    calendarEvents,
    userType,
  });
  const formattedListViewEvents = getFormattedListViewEventsMemoize({
    events: formattedCalendarEvents,
    dateRange,
    t,
    userType,
    checkIsBefore,
    isWidgetList,
  });
  return getGroupedSameDayEventsMemoize({ events: formattedListViewEvents });
};

export const getFilteredCalendarEventsMemoize = _.memoize(
  params => getFilteredCalendarEvents(params),
  params => JSON.stringify(params)
);

export const getDateRange = ({ startDate, endDate }) => {
  const dateArr = getDateArrBetweenDates({ start: startDate, end: endDate });
  return _.map(dateArr, ({ eventDate }) => eventDate);
};

export const getFirstNSortedCalendarEvents = (events, count, eventsToShow) => {
  if (count < eventsToShow) {
    return _.sortBy(events, "start");
  }
  return events;
};

export const getFirstNEvents = ({ events, dateRange, n = 0 }) => {
  if (n == 0) {
    return events;
  }
  let count = 0;
  return _.reduce(
    dateRange,
    (result, currentDate) => {
      const currentDay = formatDate({
        date: currentDate,
        format: DATE_TIME_CONSTANTS.YYYY_MM_DD,
      });
      const eventsByDate = getFirstNSortedCalendarEvents(
        _.get(events, currentDay),
        count,
        n
      );
      if (_.isEmpty(eventsByDate)) {
        return result;
      }
      _.forEach(eventsByDate, event => {
        if (count >= n) {
          return false;
        }
        if (_.isEmpty(result[currentDay])) {
          result = update(result, {
            [currentDay]: { $set: [] },
          });
        }
        result = update(result, {
          [currentDay]: { $push: [event] },
        });
        count += 1;
      });
      return result;
    },
    {}
  );
};

export const getFirstNEventsMemoize = _.memoize(
  params => getFirstNEvents(params),
  params => JSON.stringify(params)
);

export const getTotalNoOfEvents = ({ events }) => {
  return _.reduce(
    events,
    (count, eventsByDate) => {
      count += _.size(eventsByDate);
      return count;
    },
    0
  );
};

export const getTotalNoOfEventsMemoize = _.memoize(
  params => getTotalNoOfEvents(params),
  params => JSON.stringify(params)
);

export const getLastEvent = ({ events, dateRange }) => {
  const flattenedEvents = _.reduce(
    dateRange,
    (res, currentDate) => {
      const currentDay = formatDate({
        date: currentDate,
        format: DATE_TIME_CONSTANTS.YYYY_MM_DD,
      });
      if (events[currentDay]) {
        return [...res, ...events[currentDay]];
      } else {
        return res;
      }
    },
    []
  );
  return _.last(flattenedEvents);
};

export const getDefaultGradesSelected = ({ gradeIds, gradeList }) => {
  return _.reduce(
    gradeList,
    (result, gradeItem) => {
      if (_.includes(gradeIds, _.get(gradeItem, "id"))) {
        const { name: label, id: value } = gradeItem;
        return [...result, { label, value }];
      } else {
        return result;
      }
    },
    []
  );
};

export const getLastEventMemoize = _.memoize(
  params => getLastEvent(params),
  params => JSON.stringify(params)
);

export const getDefaultGradesSelectedMemoize = _.memoize(
  params => getDefaultGradesSelected(params),
  params => JSON.stringify(params)
);
export const mypEventTags = {
  PERSONAL: {
    typeLabel: "project:personal_project",
    color: "var(--teal-300)",
  },
  COMMUNITY: {
    typeLabel: "project:community_project",
    color: "var(--orange-400)",
  },
};

export const dpEventTags = {
  DP_EE: {
    typeLabel: "project:extended_essay",
    color: "var(--green-300)",
  },
  DP_TOK_ESSAY: {
    typeLabel: "project:tok_essay",
    color: "var(--pink-400)",
  },
  DP_TOK_EXHIBITION: {
    typeLabel: "project:tok_exhibition",
    color: "var(--yellow-400)",
  },
  DP_G4_PROJECT: {
    typeLabel: "project:group_4_project",
    color: "var(--blue-300)",
  },
  DP_COLLABORATIVE_SCIENCES_PROJECT: {
    typeLabel: "project:dp_collaborative_sciences_project",
    color: "var(--blue-300)",
  },
  INTERNAL_EXTERNAL_ASSESSMENT: {
    typeLabel: "project:internal_external_assessment",
    color: "var(--violet-300)",
  },
  CP_REFLECTIVE_PROJECT: {
    typeLabel: "project:reflective_project",
    color: "var(--purple-400)",
  },
  COMMUNITY_ENGAGEMENT: {
    typeLabel: "project:community_engagement",
    color: "var(--pink-400)",
  },
};

const getUserProjectGroupsTypes = ({ projectGroups, projectGroupId }) => {
  const userProjectGroupTypes = _.reduce(
    projectGroups,
    (projectGroupTypes, { type, subType, id }) => {
      if (projectGroupId) {
        if (projectGroupId === id) {
          if (
            _.includes(
              [PROJECT_SUBTYPE_CORE, PROJECT_SUBTYPE_SUBJECT_GROUP_PROJECT],
              subType
            )
          ) {
            return [...projectGroupTypes, type];
          } else {
            return [...projectGroupTypes, subType];
          }
        } else {
          return projectGroupTypes;
        }
      } else {
        if (
          _.includes(
            [PROJECT_SUBTYPE_CORE, PROJECT_SUBTYPE_SUBJECT_GROUP_PROJECT],
            subType
          )
        ) {
          return [...projectGroupTypes, type];
        } else {
          return [...projectGroupTypes, subType];
        }
      }
    },
    []
  );
  return _.uniq(userProjectGroupTypes);
};

/**
 * This function decides myp calendar tags based on whether user is mapped to respective projects or not.
 * If userType is student, this function will return the MYP PROJECT TAGS, in which student is invited.
 * If userType is staff/admin, this function will return the MYP PROJECT TAGS, for which staff can add, edit or delete deadlines.
 */
export const getUserMypCalendarTags = ({
  userType,
  projectGroups,
  currentCurriculumProgramType,
  projectGroupId,
  isCalendarOpenedFromHome,
  courseId = null,
  projectGroupCategoryIdByType,
  curriculumProgramId,
}) => {
  const isPersonalProjectAdmin = isStaffAdminForProject({
    projectGroupType: PROJECT_TYPE_PERSONAL,
    projectGroupCategoryIdByType,
    curriculumProgramId,
  });
  const isCommunityProjectAdmin = isStaffAdminForProject({
    projectGroupType: PROJECT_TYPE_COMMUNITY,
    projectGroupCategoryIdByType,
    curriculumProgramId,
  });

  const isUserStaff = isUserTypeStaff({ userType });
  const isUserStudent = isUserTypeStudent({ userType });
  const isUserParent = isUserTypeParent({ userType });

  if (
    currentCurriculumProgramType !== CURRICULUM_TYPE_MYP ||
    !_.isEmpty(courseId) ||
    (isUserStaff && !isPersonalProjectAdmin && !isCommunityProjectAdmin)
  ) {
    return {};
  }

  let projectEventTags = {};

  if (isUserStaff || isUserStudent || canFamilyViewDeadline(isUserParent)) {
    // If project group year group mapping is enabled
    const userProjectGroupTypes = getUserProjectGroupsTypes({
      projectGroups,
      projectGroupId,
    });
    _.map(userProjectGroupTypes, type => {
      if (!_.includes(nonDeadlineProjectGroupTypes, type)) {
        projectEventTags = {
          ...projectEventTags,
          [type]: _.get(mypEventTags, type),
        };
      }
    });
  }
  return projectEventTags;
};

export const getUserMypCalendarTagsMemoize = _.memoize(
  params => getUserMypCalendarTags(params),
  params => JSON.stringify(params)
);

export const getUserDpCalendarTags = ({
  projectGroups,
  currentCurriculumProgramType,
  projectGroupId,
  userType,
  projectGroupCategoryIdByType,
  curriculumProgramId,
}) => {
  if (currentCurriculumProgramType !== CURRICULUM_TYPE_DP) {
    return {};
  }

  const userProjectGroupTypes = getUserProjectGroupsTypes({
    projectGroups,
    projectGroupId,
  });

  const isUserStaff = isUserTypeStaff({ userType });
  const isUserStudent = isUserTypeStudent({ userType });
  const isUserParent = isUserTypeParent({ userType });

  let projectEventTags = {};
  _.forEach(userProjectGroupTypes, type => {
    if (!_.includes(nonDeadlineDPProjectGroupTypes, type)) {
      if (isProjectTypeIAOrEA({ projectGroupType: type })) {
        projectEventTags = {
          ...projectEventTags,
          [MY_CALENDAR_CONSTANTS.INTERNAL_EXTERNAL_ASSESSMENT]: _.get(
            dpEventTags,
            MY_CALENDAR_CONSTANTS.INTERNAL_EXTERNAL_ASSESSMENT
          ),
        };
      } else if (type === MY_CALENDAR_CONSTANTS.CP_REFLECTIVE_PROJECT) {
        if (IsReflectiveProjectDpTagEnabled()) {
          projectEventTags = {
            ...projectEventTags,
            [type]: _.get(dpEventTags, type),
          };
        }
      } else if (
        isUserStudent ||
        canFamilyViewDeadline(isUserParent) ||
        (isUserStaff &&
          isStaffAdminForProject({
            projectGroupType: type,
            projectGroupCategoryIdByType,
            curriculumProgramId,
          }))
      ) {
        projectEventTags = {
          ...projectEventTags,
          [type]: _.get(dpEventTags, type),
        };
      }
    }
  });
  return projectEventTags;
};

export const getUserDpCalendarTagsMemoize = _.memoize(
  params => getUserDpCalendarTags(params),
  params => JSON.stringify(params)
);

export const isPossibleAllDayEvent = ({ itemType }) => {
  return _.includes(possibleAllDayEvents, itemType);
};

export const isAllDayEvent = ({ itemType, item, userType }) => {
  const isDeadlineAllDay = getIsDeadlineAllDay({
    userType,
    eventItem: { event: { item } },
  });

  switch (itemType) {
    case MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT:
      return isDeadlineAllDay;
    case MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT:
      return true;
    case MY_CALENDAR_CONSTANTS.CALENDAR_EVENT_ITEM:
      return _.get(item, "isFullDayEvent", false);
    default:
      return false;
  }
};

export const getUserProjectGroupIds = ({
  projectGroups,
  allProjectGroups = [],
  selectedProjectTypeTags,
  currentCurriculumProgramType,
  yearGroupId = null,
}) => {
  let userProjectGroupIds = [];
  if (
    currentCurriculumProgramType === CURRICULUM_TYPE_MYP ||
    currentCurriculumProgramType === CURRICULUM_TYPE_DP
  ) {
    const finalProjectGroups = _.isEmpty(allProjectGroups)
      ? projectGroups
      : allProjectGroups;

    const projectGroupTypeIdsMap = _.reduce(
      finalProjectGroups,
      (projectGroupTypeIdsMap, { id, type, subType, yearGroup = {} }) => {
        const finalProjectType = _.includes(
          [PROJECT_SUBTYPE_CORE, PROJECT_SUBTYPE_SUBJECT_GROUP_PROJECT],
          subType
        )
          ? type
          : subType;

        const projectGroupYearGroupId = _.get(yearGroup, "id");

        // Filter project groups which are not of current year group for core and subject group project deadlines
        if (
          _.includes(
            [PROJECT_SUBTYPE_CORE, PROJECT_SUBTYPE_SUBJECT_GROUP_PROJECT],
            subType
          ) &&
          yearGroupId &&
          yearGroupId !== projectGroupYearGroupId
        ) {
          return projectGroupTypeIdsMap;
        }

        if (!_.isEmpty(projectGroupTypeIdsMap[finalProjectType])) {
          projectGroupTypeIdsMap[finalProjectType].push(id);
        } else {
          projectGroupTypeIdsMap[finalProjectType] = [id];
        }

        return projectGroupTypeIdsMap;
      },
      {}
    );

    userProjectGroupIds = _.reduce(
      selectedProjectTypeTags,
      (projectGroupIds, tag) => {
        if (tag === MY_CALENDAR_CONSTANTS.INTERNAL_EXTERNAL_ASSESSMENT) {
          const internalAssessmentIds = _.get(
            projectGroupTypeIdsMap,
            PROJECT_SUBTYPE_INTERNAL_ASSESSMENT,
            []
          );
          const externalAssessmentIds = _.get(
            projectGroupTypeIdsMap,
            PROJECT_SUBTYPE_EXTERNAL_ASSESSMENT,
            []
          );
          return [
            ...projectGroupIds,
            ...internalAssessmentIds,
            ...externalAssessmentIds,
          ];
        }
        return [...projectGroupIds, ..._.get(projectGroupTypeIdsMap, tag, [])];
      },
      []
    );
  }
  return userProjectGroupIds;
};

export const getCalendarDurationText = ({
  calendarView,
  startDate,
  endDate,
}) => {
  switch (calendarView) {
    case MY_CALENDAR_CONSTANTS.MONTH:
      return formatDate({
        date: startDate,
        format: DATE_TIME_CONSTANTS.MMM_YYYY,
      });
    default:
      return getDurationText({ startDate, endDate });
  }
};

export const isMonthInAcademicYear = ({ date, startDate, endDate }) => {
  return moment(date).isBetween(startDate, endDate);
};

export const getMonthDateCellNodeFromDate = ({
  date,
  isOffRangeCell = false,
}) => {
  const monthlySlots = document.getElementsByClassName("rbc-date-cell");

  const nodeArray = _.filter(monthlySlots, slot => {
    const checkOffRange = isOffRangeCell
      ? _.includes(slot?.className, "rbc-off-range")
      : !_.includes(slot?.className, "rbc-off-range");
    return (
      slot.getElementsByTagName("span")[0].innerHTML ===
        formatDate({ date, format: DATE_TIME_CONSTANTS.DD }) && checkOffRange
    );
  });

  return _.head(nodeArray);
};

export const getMonthlySlotDropdownPosition = ({
  date,
  isOffRangeCell = false,
}) => {
  const dayBg = document.getElementsByClassName("rbc-day-bg")?.[0];
  const { width, height } = dayBg?.getBoundingClientRect() || {};
  const node = getMonthDateCellNodeFromDate({ date, isOffRangeCell });
  const { x, y } = node?.getBoundingClientRect() || {};

  return {
    left: x,
    top: y + height - 28,
    width,
    height: 24,
    node,
  };
};

export const STEPS_COUNT = 5;
export const TIME_SLOT_COUNT = 60 / STEPS_COUNT; // 5-minute slots in an hour

// by default event duration is 30 mins, so height multiplier is calculated accordingly
export const selectedSlotHeightMultiplier = 30 / STEPS_COUNT; // 6 times height of single slot to cover 30 mins slot height

export const getWeeklySlotDropdownPosition = ({ date }) => {
  const node = document.getElementsByClassName(moment(date).toISOString())?.[0];
  const { x, y, width, height } = node?.getBoundingClientRect() || {};

  return {
    left: x,
    top: y,
    width,
    height: height * selectedSlotHeightMultiplier,
    node,
  };
};

export const getSlotDropdownPosition = ({
  date,
  calendarView,
  isOffRangeCell = false,
}) => {
  switch (calendarView) {
    case MY_CALENDAR_CONSTANTS.MONTH:
      return getMonthlySlotDropdownPosition({ date, isOffRangeCell });
    default:
      return getWeeklySlotDropdownPosition({ date });
  }
};

export const isValidDateOnDecrement = ({
  startDate,
  academicYearStartDate,
}) => {
  return !checkIsDateBefore({
    date1: getPreviousDayDate(startDate),
    date2: academicYearStartDate,
  });
};

export const isValidDateOnIncrement = ({ endDate, academicYearEndDate }) => {
  return !checkIsDateAfter({
    date1: getNextDayDate(endDate),
    date2: academicYearEndDate,
  });
};

export const isSchoolCalendarEvent = ({ eventType, itemEventType }) => {
  return (
    eventType === MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT ||
    (eventType === MY_CALENDAR_CONSTANTS.CALENDAR_EVENT_ITEM &&
      itemEventType === MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT)
  );
};

export const isProjectDeadlineEvent = ({ eventType }) => {
  return eventType === MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT;
};

export const isProjectDeadlineIAOrEA = ({ value }) => {
  return value === MY_CALENDAR_CONSTANTS.INTERNAL_EXTERNAL_ASSESSMENT;
};

export const getFilteredYearGroups = ({
  projectGroups,
  tag,
  isEventTypeSchoolCalendar,
}) => {
  if (isEventTypeSchoolCalendar) {
    return [];
  }

  return _.reduce(
    projectGroups,
    (yearGroupList, projectGroup) => {
      const { type, subType } = projectGroup;

      const projectGroupType = _.includes(
        [PROJECT_SUBTYPE_SUBJECT_GROUP_PROJECT, PROJECT_SUBTYPE_CORE],
        subType
      )
        ? type
        : subType;

      const isIAOrEAProjectType = isProjectTypeIAOrEA({ projectGroupType });

      if (
        isIAOrEAProjectType &&
        tag?.value !== MY_CALENDAR_CONSTANTS.INTERNAL_EXTERNAL_ASSESSMENT
      ) {
        return yearGroupList;
      } else if (!isIAOrEAProjectType && projectGroupType !== tag?.value) {
        return yearGroupList;
      }

      const yearGroup = _.get(projectGroup, "yearGroup", null);
      let yearGroupObj = null;
      if (yearGroup) {
        yearGroupObj = {
          label: yearGroup?.name,
          type: tag?.value,
        };
      }

      if (yearGroup && !_.find(yearGroupList, yearGroupObj)) {
        return [
          ...yearGroupList,
          { ...yearGroupObj, value: projectGroup?.id, id: yearGroup?.id },
        ];
      } else {
        return yearGroupList;
      }
    },
    []
  );
};

export const getFilteredYearGroupsMemoize = _.memoize(
  params => getFilteredYearGroups(params),
  ({ projectGroups, tag }) =>
    JSON.stringify({ projectGroups, label: tag?.label, value: tag?.value })
);

const getStudentNames = ({ projects, defaultStudentNameOrderPreference }) => {
  const students = _.reduce(
    projects,
    (result, project) => {
      if (project?.students) result.push(...project.students);
      return result;
    },
    []
  );
  return _.map(students, student => {
    return {
      name: getFormattedUserName({
        user: student,
        defaultStudentNameOrderPreference,
        type: "student",
      }),
    };
  });
};

const getProjectStudents = ({ projects }) => {
  return _.reduce(
    projects,
    (result, project) => {
      const { students, status: submissionStatus } = project || {};
      const studentEntries = _.map(students, item => {
        return { ...item, submissionStatus };
      });
      if (students) result.push(...studentEntries);
      return result;
    },
    []
  );
};

const getJoinedCourseNamesString = ({ courses }) => {
  return _.join(
    _.map(_.get(courses, "edges", []), course => course?.node?.title),
    ", "
  );
};

export const getTransformedEventData = ({
  itemType,
  data = {},
  userType,
  defaultStudentNameOrderPreference,
  eventItemId,
  eventData,
  associatedEntities,
}) => {
  const {
    title,
    label,
    location,
    description,
    grades,
    tag,
    deadlineTitle,
    start,
    end,
    deadlineDate,
    statusWiseProjects = {},
    projectGroup: {
      type,
      subType,
      yearGroup,
      id: projectGroupId,
      name,
      subject = {},
      courses,
    } = {},
    creatorUser = {},
    author,
    createdBy,
    associatedEntities: associatedEntitiesBasicDetils,
    deadline = {},
    id,
    isDeadlineCompleted,
    isDeadlineAllDay = true,
    __typename,
    responses,
    isStudentSubmissionEnabled,
    dueOn: newDeadlineDueOn,
    isFullDayEvent,
    attachments = [],
    eventReminders = [],
    sharedWith,
    users = [],
    recurringSetting,
    repeatEventSettings,
    metadata,
  } = data;
  const isRecurringSetting = recurringSetting !== null;
  const { startTime, endTime } = eventData || {};
  const { completedProjects = [], pendingProjects = [] } =
    statusWiseProjects || {};
  const eventCreator = author ?? createdBy ?? {};
  const projectEventTags = { ...mypEventTags, ...dpEventTags };

  let rawStartDate = ""; // this is the date exactly recieved from query
  let rawEndDate = ""; // this is the date exactly recieved from query
  const finalAssociatedEntities = _.isEmpty(associatedEntities)
    ? associatedEntitiesBasicDetils
    : associatedEntities;
  const createdByUserType = _.toLower(
    _.get(eventCreator, "__typename", userType)
  );

  switch (itemType) {
    case MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT: {
      const eventCreatorName = getFormattedUserName({
        user: eventCreator,
        type: createdByUserType,
      });
      return {
        title: label ?? title,
        location,
        description,
        gradeIds:
          grades ??
          _.map(finalAssociatedEntities, entity => _.get(entity, "id")),
        startDate: isRecurringSetting ? startTime : start,
        endDate: isRecurringSetting ? endTime : end,
        eventTypeLabel: _.get(tag, "label", "School Event"),
        tag,
        id: eventItemId,
        isFullDayEvent,
        attachments,
        eventReminders,
        sharedWith,
        associatedEntities: finalAssociatedEntities,
        createdBy: {
          id: _.get(eventCreator, "id", null),
          name: eventCreatorName,
          profileImage: _.get(eventCreator, "profileImage", null),
        },
        users,
        recurringSetting,
        repeatEventSettings:
          !_.isEmpty(repeatEventSettings) && metadata?.recurrenceType
            ? {
                ...repeatEventSettings,
                id: RECURRING_QUERY_TYPE_MAPPING[metadata?.recurrenceType],
              }
            : null,
        metadata,
        categoryId: _.get(tag, "id", null),
      };
    }
    case MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT: {
      const isProjectNewDeadline = _.includes(
        ["ProjectGroupTask", "ProjectTaskResponse"],
        __typename
      );
      if (userType === "staff") {
        const eventCreatorName = getFormattedUserName({
          user: creatorUser,
          type: createdByUserType,
        });
        const finalProjectGroupType = _.includes(
          [PROJECT_SUBTYPE_CORE, PROJECT_SUBTYPE_SUBJECT_GROUP_PROJECT],
          subType
        )
          ? type
          : subType;

        const courseNames = getJoinedCourseNamesString({ courses });
        let startDate = "";
        let endDate = "";
        if (isProjectNewDeadline) {
          const formattedDueOn = moment(newDeadlineDueOn)
            .utc(true)
            .toISOString();
          startDate = formattedDueOn;
          endDate = formattedDueOn;
          rawStartDate = newDeadlineDueOn;
          rawEndDate = newDeadlineDueOn;
        } else {
          const deadlineDateAdjustedForTime = moment(deadlineDate)
            .utc(true)
            .toISOString();
          startDate = deadlineDateAdjustedForTime;
          endDate = deadlineDateAdjustedForTime;
          rawStartDate = deadlineDateAdjustedForTime;
          rawEndDate = deadlineDateAdjustedForTime;
        }

        let completedProjectsCount = _.size(completedProjects, 0);
        let pendingProjectsCount = _.size(pendingProjects, 0);
        let updatedPendingProjects = pendingProjects;
        let updatedCompletedProjects = completedProjects;
        let turnedInCount = 0;
        let totalProjectsCount = 0;

        if (isProjectNewDeadline) {
          const {
            pendingCount,
            completedCount,
            pendingProjects,
            completedProjects,
            totalCount,
          } = _.reduce(
            responses,
            (result, response) => {
              const {
                isComplete,
                isSubmissionTurnedIn,
                latestSubmissionResponse,
              } = response;
              const { status } = latestSubmissionResponse || {};
              result.totalCount += 1;
              if (isComplete) {
                result.completedCount += 1;
                result.completedProjects.push({
                  ...response?.project,
                  status,
                });
              } else if (!isComplete) {
                result.pendingCount += 1;
                result.pendingProjects.push({
                  ...response?.project,
                  status,
                });
              }
              if (isSubmissionTurnedIn) {
                turnedInCount += 1;
              }
              return result;
            },
            {
              pendingCount: 0,
              completedCount: 0,
              pendingProjects: [],
              completedProjects: [],
              totalCount: 0,
            }
          );

          completedProjectsCount = completedCount;
          pendingProjectsCount = pendingCount;
          updatedPendingProjects = pendingProjects;
          updatedCompletedProjects = completedProjects;
          totalProjectsCount = totalCount;
        }

        return {
          id,
          title: deadlineTitle,
          startDate,
          description,
          endDate,
          rawStartDate,
          rawEndDate,
          completedProjectsCount,
          pendingProjectsCount,
          eventTypeLabel: _.get(projectEventTags, [
            isProjectTypeIAOrEA({ projectGroupType: finalProjectGroupType })
              ? MY_CALENDAR_CONSTANTS.INTERNAL_EXTERNAL_ASSESSMENT
              : finalProjectGroupType,
            "typeLabel",
          ]),
          yearGroup,
          createdBy: {
            id: _.get(creatorUser, "id", null),
            name: eventCreatorName,
            profileImage: _.get(creatorUser, "profileImage", null),
          },
          projectGroupType: finalProjectGroupType,
          projectGroupLabel: name,
          projectGroupId,
          subject,
          courseNames,
          completedStudentNames: getStudentNames({
            projects: updatedCompletedProjects,
            defaultStudentNameOrderPreference,
          }),
          pendingStudentNames: getStudentNames({
            projects: updatedPendingProjects,
            defaultStudentNameOrderPreference,
          }),
          completedStudents: getProjectStudents({
            projects: updatedCompletedProjects,
          }),
          pendingStudents: getProjectStudents({
            projects: updatedPendingProjects,
          }),
          isDeadlineAllDay,
          isProjectNewDeadline,
          isStudentSubmissionEnabled,
          turnedInCount,
          totalProjectsCount,
        };
      } else if (
        userType === "student" ||
        canFamilyViewDeadline(userType === "parent")
      ) {
        const description = _.get(deadline, "description");
        const projectGroup = _.get(deadline, "projectGroup");
        const {
          type: projectGroupType,
          id: projectGroupId,
          subType: projectGroupSubType,
          courses = {},
          name,
          subject = {},
          yearGroup,
        } = projectGroup;
        const deadlineCreatedBy = _.get(deadline, "creatorUser");
        const deadlineCreatedByUserType = _.toLower(
          _.get(deadlineCreatedBy, "type", userType)
        );
        const projectGroupCourseIds = _.map(
          _.get(courses, "edges", []),
          ({ node: { id } }) => id
        );
        const eventCreatorName = getFormattedUserName({
          user: deadlineCreatedBy,
          type: deadlineCreatedByUserType,
        });
        const finalProjectGroupType = _.includes(
          [PROJECT_SUBTYPE_CORE, PROJECT_SUBTYPE_SUBJECT_GROUP_PROJECT],
          projectGroupSubType
        )
          ? projectGroupType
          : projectGroupSubType;

        const courseNames = getJoinedCourseNamesString({ courses });
        let startDate = "";
        let endDate = "";

        if (isProjectNewDeadline) {
          startDate = deadline?.dueOn;
          endDate = deadline?.dueOn;
          rawStartDate = deadline?.dueOn;
          rawEndDate = deadline?.dueOn;
        } else {
          const deadlineDateAdjustedForTime = moment(
            _.get(deadline, "deadlineDate")
          )
            .utc(true)
            .toISOString();
          startDate = deadlineDateAdjustedForTime;
          endDate = deadlineDateAdjustedForTime;
          rawStartDate = deadlineDateAdjustedForTime;
          rawEndDate = deadlineDateAdjustedForTime;
        }

        const isDeadlineAllDay = _.get(deadline, "isDeadlineAllDay");

        return {
          title: _.get(deadline, "deadlineTitle"),
          startDate,
          endDate,
          eventTypeLabel: _.get(projectEventTags, [
            isProjectTypeIAOrEA({ projectGroupType: finalProjectGroupType })
              ? MY_CALENDAR_CONSTANTS.INTERNAL_EXTERNAL_ASSESSMENT
              : finalProjectGroupType,
            "typeLabel",
          ]),
          createdBy: {
            id: _.get(deadlineCreatedBy, "id", null),
            name: eventCreatorName,
            profileImage: _.get(deadlineCreatedBy, "profileImage", null),
          },
          projectGroupId,
          projectGroupLabel: name,
          projectGroupType: finalProjectGroupType,
          projectGroupCourseIds,
          isDeadlineCompleted,
          subject,
          yearGroup,
          courseNames,
          description,
          isDeadlineAllDay,
          isProjectNewDeadline,
          rawStartDate,
          rawEndDate,
        };
      }
      return {};
    }
    default:
      return {};
  }
};

export const isPendingStudentsCountVisible = ({
  pendingStudentsCount,
  userType,
}) => {
  return !_.isNil(pendingStudentsCount) && userType === STAFF;
};

export const isCompletedStudentsCountVisible = ({
  completedStudentsCount,
  userType,
}) => {
  return !_.isNil(completedStudentsCount) && userType === STAFF;
};

export const checkProjectGroupsQueriesSkip = ({
  currentCurriculumProgramType,
}) => {
  return (
    !isMasterCalendarV1Enabled({ currentCurriculumProgramType }) ||
    !_.includes(
      [CURRICULUM_TYPE_DP, CURRICULUM_TYPE_MYP],
      currentCurriculumProgramType
    )
  );
};

export const isCurriculumProgramMYPOrDp = ({
  currentCurriculumProgramType,
}) => {
  return _.includes(
    [CURRICULUM_TYPE_MYP, CURRICULUM_TYPE_DP],
    currentCurriculumProgramType
  );
};

export const getFilteredSubjectList = ({
  projectGroups,
  yearGroupId: selectedYearGroupId,
}) => {
  return _.reduce(
    projectGroups,
    (subjectList, projectGroup) => {
      const subType = _.get(projectGroup, "subType", "");
      if (
        _.includes(
          [PROJECT_SUBTYPE_CORE, PROJECT_SUBTYPE_SUBJECT_GROUP_PROJECT],
          subType
        )
      ) {
        return subjectList;
      }

      const yearGroupId = _.get(projectGroup, "yearGroup.id", null);
      if (yearGroupId !== selectedYearGroupId) {
        return subjectList;
      }

      const subject = _.get(projectGroup, "subject", null);
      if (!subject) {
        return subjectList;
      }

      const subjectId = _.get(subject, "id", null);

      const assessmentYearTitle = _.get(
        subject,
        "ibOfferedSubject.contentSubject.assessmentYearTitle",
        null
      );

      const subjectName = `${subject?.name} (${assessmentYearTitle})`;
      if (_.isEmpty(subjectList[subjectId])) {
        subjectList = {
          ...subjectList,
          [subjectId]: { subjectName, subjectComponentList: [] },
        };
      }

      return {
        ...subjectList,
        [subjectId]: {
          ...subjectList[subjectId],
          subjectComponentList: [
            ..._.get(subjectList[subjectId], "subjectComponentList", []),
            {
              label: projectGroup?.name,
              value: projectGroup?.id,
            },
          ],
        },
      };
    },
    {}
  );
};

export const getFilteredSubjectListMemoize = _.memoize(
  params => getFilteredSubjectList(params),
  params => JSON.stringify(params)
);

export const isProjectTypeIAOrEA = ({ projectGroupType }) => {
  return (
    projectGroupType === PROJECT_SUBTYPE_INTERNAL_ASSESSMENT ||
    projectGroupType === PROJECT_SUBTYPE_EXTERNAL_ASSESSMENT
  );
};

const initialTagSelectedStyle = {
  height: "12px",
  width: "12px",
  borderRadius: "50%",
};

export const getDefaultTagSelected = ({ tag }) => {
  const { id: value, label, uid } = tag;
  const icon = (
    <div
      style={{
        backgroundColor: _.get(tag, "colorCode", ""),
        ...initialTagSelectedStyle,
      }}
    ></div>
  );
  return { label, value, icon, uid };
};

export const getDefaultProjectDeadlineTag = ({ projectGroupType, t }) => {
  const { backgroundColor } = getProjectIconDetails({
    projectType: projectGroupType,
  });
  const icon = (
    <div
      style={{
        backgroundColor,
        ...initialTagSelectedStyle,
      }}
    ></div>
  );

  const isIAOrEAProjectType = isProjectTypeIAOrEA({ projectGroupType });

  const defaultProjectTag = _.find(ALL_PROJECT_TAGS(t), {
    value: isIAOrEAProjectType
      ? MY_CALENDAR_CONSTANTS.INTERNAL_EXTERNAL_ASSESSMENT
      : projectGroupType,
  });

  return {
    ...defaultProjectTag,
    icon,
  };
};

export const getDefaultYearGroup = ({
  yearGroup,
  projectGroupId,
  projectGroupType,
}) => {
  if (_.isEmpty(yearGroup)) {
    return null;
  }
  const isIAOrEAProjectType = isProjectTypeIAOrEA({ projectGroupType });
  return {
    label: _.get(yearGroup, "name"),
    value: projectGroupId,
    id: _.get(yearGroup, "id"),
    type: isIAOrEAProjectType
      ? MY_CALENDAR_CONSTANTS.INTERNAL_EXTERNAL_ASSESSMENT
      : projectGroupType,
  };
};

export const getDefaultSubject = ({ subject }) => {
  return {
    label: subject?.name,
    value: subject?.id,
  };
};

export const getDefaultSubjectComponent = ({
  projectGroupId,
  projectGroupLabel,
}) => {
  return {
    label: projectGroupLabel,
    value: projectGroupId,
  };
};

export const getEventDetails = ({
  itemType,
  id,
  title,
  description,
  location,
  gradeIds,
  gradeList,
  tag,
  projectGroupId,
  projectGroupType,
  projectGroupLabel,
  yearGroup,
  subject,
  t,
  isDeadlineAllDay,
  isFullDayEvent,
  attachments,
  users,
  sharedWith,
  associatedEntities,
  eventReminders,
  repeatEventSettings,
  metadata,
  endDate,
}) => {
  switch (itemType) {
    case MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT:
      return {
        id,
        eventName: title,
        eventDescription: description,
        eventLocation: location,
        grades: getDefaultGradesSelectedMemoize({ gradeIds, gradeList }),
        tag: getDefaultTagSelected({ tag }),
        isFullDayEvent,
        attachments,
        users,
        sharedWith,
        associatedEntities,
        eventReminders,
        repeatEventSettings: !_.isEmpty(repeatEventSettings)
          ? {
              ..._.omit(repeatEventSettings, "__typename"),
              id: RECURRING_QUERY_TYPE_MAPPING[metadata?.recurrenceType],
              endDate: repeatEventSettings?.endDate
                ? getDateMomentObject(repeatEventSettings?.endDate).format()
                : null,
              endType: getEndType({
                repeatEventSettings,
                academicYearEndDate: endDate,
                count: repeatEventSettings?.count,
              }),
            }
          : null,
        metadata,
      };
    default:
      return {
        id,
        eventName: title,
        eventDescription: description,
        tag: getDefaultProjectDeadlineTag({
          projectGroupLabel,
          projectGroupType,
          t,
        }),
        yearGroup: getDefaultYearGroup({
          yearGroup,
          projectGroupId,
          projectGroupType,
        }),
        subject: getDefaultSubject({ subject }),
        subjectComponent: getDefaultSubjectComponent({
          projectGroupLabel,
          projectGroupId,
        }),
        isDeadlineAllDay,
      };
  }
};

export const getCourseSubjectGroupType = ({ courseId, academicYearId }) => {
  const courseDetails = getCourseDetailsFromCache({
    id: courseId,
    courseGradeFilters: { academicYearId },
  });
  const subjectGroups = _.get(courseDetails, "subjectGroups", []);
  return _.get(_.head(subjectGroups), "type", null);
};

export const SCHOOL_CALENDAR_EVENT_CREATE_OPTION_V2 = {
  label: "announcement:event",
  key: MY_CALENDAR_CONSTANTS.CREATE_EVENT,
  icon: <CalendarStarOutlined variant={"subtle"} />,
  perm: "FeatureFlag:MasterCalendarV2",
};

export const canShowParticipantOnAgendaAndViewmore = () => {
  return ACLStore.can(
    "FeatureFlag:EnableEventParticipantDetailOnAgendaAndViewmore"
  );
};

export const getOptionsListHavingSchoolEventOnTopOnFFEnable = ({
  options,
  curriculumProgramId,
  isCalendarOpenedFromHome,
  isCalendarDailyView,
  courseList,
}) => {
  const isNewEventCreation = isNewEventCreationFlowEnabled();
  if (!isNewEventCreation) {
    return options;
  }
  const cloneOptions = _.cloneDeep(options);
  const firstOption = _.first(cloneOptions);

  const isStaffSchoolCalendarAdmin = isStaffAdminForSchoolCalendarByContext({
    contexts: [
      {
        entityId: curriculumProgramId,
        entityType: "CURRICULUM_PROGRAM",
      },
    ],
  });

  const canUserCreateEvent = canUserCreateEventOnCalendar({
    isStaffSchoolCalendarAdmin,
    currentCurriculumProgramId: curriculumProgramId,
    courseList,
  });

  if (canUserCreateEvent) {
    firstOption?.options?.unshift(SCHOOL_CALENDAR_EVENT_CREATE_OPTION_V2);
  }

  return cloneOptions;
};

export const getOptionsList = ({
  curriculumProgramType,
  options,
  projectGroups,
  courseId,
  isCalendarOpenedFromHome,
  isCalendarDeadlineView,
  isCalendarDailyView,
  subjectType,
  academicYearId,
  isSelectedDateInCurrentAcademicYear,
  projectGroupCategoryIdByType,
  curriculumProgramId,
  canUserCreateEvent,
}) => {
  /*
    Since in DP we allow create dropdown upto 2 academic year
    We want to restrict class event creation for future acad year dates
  */
  const newOptions =
    isCalendarDeadlineView || !isSelectedDateInCurrentAcademicYear
      ? []
      : _.cloneDeep(options);

  const isStaffProjectAdmin = isStaffAdminForProjectModules({
    projectGroupCategoryIdByType,
    curriculumProgramId,
  });

  const isNewEventCreationFlowFFEnabled = isNewEventCreationFlowEnabled();
  if (canUserCreateEvent && !isNewEventCreationFlowFFEnabled) {
    newOptions.push(SCHOOL_CALENDAR_EVENT_CREATE_OPTION);
  }
  const isNewDeadlineEnabled = ACLStore.can(
    "FeatureFlag:EnableNewDeadlinesForProjects"
  );

  switch (curriculumProgramType) {
    case CURRICULUM_TYPE_DP:
      if (!isStaffProjectAdmin) {
        if (
          getCourseSubjectGroupType({ courseId, academicYearId }) !==
            PROJECT_SUBTYPE_CORE &&
          !_.isEmpty(projectGroups)
        ) {
          if (isNewDeadlineEnabled)
            newOptions.push(DP_PROJECT_DEADLINE_CREATE_OPTION_STAFF_NEW);
          else newOptions.push(DP_PROJECT_DEADLINE_CREATE_OPTION_STAFF);
        }
      } else {
        if (subjectType !== SUBJECT_TYPE_CAS && !_.isEmpty(projectGroups)) {
          if (getIsCpCoreEnabled()) {
            if (isNewDeadlineEnabled)
              newOptions.push(DP_CP_PROJECT_DEADLINE_CREATE_OPTION_NEW);
            else newOptions.push(DP_CP_PROJECT_DEADLINE_CREATE_OPTION);
          } else {
            if (isNewDeadlineEnabled)
              newOptions.push(DP_PROJECT_DEADLINE_CREATE_OPTION_NEW);
            else newOptions.push(DP_PROJECT_DEADLINE_CREATE_OPTION);
          }
        }
      }
      break;
    case CURRICULUM_TYPE_MYP:
      if (isStaffProjectAdmin && !courseId) {
        if (isNewDeadlineEnabled)
          newOptions.push(MYP_PROJECT_DEADLINE_CREATE_OPTION_NEW);
        else newOptions.push(MYP_PROJECT_DEADLINE_CREATE_OPTION);
      }
      break;
  }
  return newOptions;
};

export const getModifiedContentTypes = ({
  selectedTags = [],
  contentTypes,
  type,
}) => {
  if (type === MY_CALENDAR_CONSTANTS.VIEW_ONLY_TAGS) {
    return contentTypes;
  }
  let modifiedContentTypes = contentTypes;

  switch (type) {
    case MY_CALENDAR_CONSTANTS.ASSESSMENT:
      {
        const assessmentTagListWithoutMeeting = _.filter(
          selectedTags,
          tag => tag !== MY_CALENDAR_CONSTANTS.VIDEO_MEETING
        );
        if (_.includes(selectedTags, MY_CALENDAR_CONSTANTS.VIDEO_MEETING)) {
          modifiedContentTypes = _.uniq([
            ...contentTypes,
            MY_CALENDAR_CONSTANTS.RECURRING_MEETING,
          ]);
        } else {
          modifiedContentTypes = _.filter(
            modifiedContentTypes,
            tag => tag !== MY_CALENDAR_CONSTANTS.RECURRING_MEETING
          );
        }
        if (!_.isEmpty(assessmentTagListWithoutMeeting)) {
          modifiedContentTypes = _.uniq([
            ...modifiedContentTypes,
            MY_CALENDAR_CONSTANTS.ASSESSMENT,
          ]);
        } else {
          modifiedContentTypes = _.filter(
            modifiedContentTypes,
            tag => tag !== MY_CALENDAR_CONSTANTS.ASSESSMENT
          );
        }
      }
      break;
    default:
      if (!_.isEmpty(selectedTags)) {
        modifiedContentTypes = _.uniq([...contentTypes, type]);
      } else {
        modifiedContentTypes = _.filter(contentTypes, tag => tag !== type);
      }
  }
  return modifiedContentTypes;
};

export const getModifiedContentTypesMemoize = _.memoize(
  params => getModifiedContentTypes(params),
  params => JSON.stringify(params)
);

export const canFamilyViewDeadline = isUserParent => {
  const isFeatureFamilyDeadlineFlagEnable = ACLStore.can(
    "FeatureFlag:EnableTaskDeadlineCalendarEventOnFamilyEnd"
  );
  return isUserParent && isFeatureFamilyDeadlineFlagEnable;
};

/**
 * Adds project content type filters based on the curriculum program type
 * @param {string} currentCurriculumProgramType - Current curriculum program type
 * @param {Array} mypTagList - List of MYP tags
 * @param {Array} dpTagList - List of DP tags
 * @param {Array} modifiedContentTypes - Current content type list to modify
 * @returns {Array} Updated content types list
 */
const addProjectContentType = ({
  currentCurriculumProgramType,
  mypTagList,
  dpTagList,
  modifiedContentTypes,
}) => {
  switch (currentCurriculumProgramType) {
    case CURRICULUM_TYPE_MYP:
      return getModifiedContentTypesMemoize({
        selectedTags: mypTagList,
        contentTypes: modifiedContentTypes,
        type: MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT,
      });
    case CURRICULUM_TYPE_DP:
      return getModifiedContentTypesMemoize({
        selectedTags: dpTagList,
        contentTypes: modifiedContentTypes,
        type: MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT,
      });
    default:
      return modifiedContentTypes;
  }
};

export const getInitialContentTypes = ({
  mypTagList,
  dpTagList,
  eventTagList,
  assessmentTagList,
  contentTypes,
  currentCurriculumProgramType,
  isMasterCalendarV1,
  isCalendarDeadlineView,
  isUserParent,
}) => {
  let modifiedContentTypes = contentTypes;

  if (!isMasterCalendarV1) {
    return modifiedContentTypes;
  }

  if (isUserParent)
    return canFamilyViewDeadline(isUserParent)
      ? addProjectContentType({
          currentCurriculumProgramType,
          mypTagList,
          dpTagList,
          modifiedContentTypes,
        })
      : modifiedContentTypes;

  modifiedContentTypes = getModifiedContentTypesMemoize({
    selectedTags: eventTagList,
    contentTypes: modifiedContentTypes,
    type: MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR,
  });

  if (isCalendarDeadlineView) {
    modifiedContentTypes = getModifiedContentTypesMemoize({
      selectedTags: assessmentTagList,
      contentTypes: modifiedContentTypes,
      type: MY_CALENDAR_CONSTANTS.ASSESSMENT,
    });
  }

  modifiedContentTypes = addProjectContentType({
    currentCurriculumProgramType,
    mypTagList,
    dpTagList,
    modifiedContentTypes,
  });

  return modifiedContentTypes;
};

export const getInitialContentTypesMemoize = _.memoize(
  params => getInitialContentTypes(params),
  params => JSON.stringify(params)
);

export const getFilteredClassStreamTags = ({
  currentCurriculumProgramType,
}) => {
  let classStreamTags = _.get(
    getClassTagsForCalendar({ curriculumType: currentCurriculumProgramType }),
    "value",
    {}
  );
  // Filtering this option here since we have removed perm from ai_tutor option from create array for promotional banner
  classStreamTags = _.omitBy(classStreamTags, (tag, type) => {
    return type === "ai_tutor" && !ACLStore.can(ENABLE_AI_TUTOR);
  });

  return classStreamTags;
};

export const getCalendarSidebarData = ({
  t,
  currentCurriculumProgramType,
  assessmentTypes,
  isCalendarOpenedFromHome,
  filteredSchoolCalendarTags,
  schoolCalendarTagIds,
  schoolCalendarEventTags,
  mypTags,
  dpTags,
  mypEventTags,
  dpEventTags,
  setSidebarFilters,
  setViewOnlyTagsFilters,
  isCalendarDeadlineView,
  viewOnlyTagsList,
  selectedViewOnlyTags,
  isMasterCalendarV1,
  isUserStaff,
  assessmentData,
  isStaffSchoolCalendarAdmin,
  isUserStudent,
  isUserParent,
  isGlobalHeaderEnabled,
  projectGroupCategoryIdByType,
  currentCurriculumProgramId,
  canUserManageEventTagsWithOldPermissionFallback,
  courseList,
}) => {
  let sectionData = [];

  const canUserCreateEvent = canUserCreateEventOnCalendar({
    isStaffSchoolCalendarAdmin,
    currentCurriculumProgramId: currentCurriculumProgramId,
    courseList,
  });

  if (
    (!isCalendarDeadlineView && !isUserParent) ||
    canFamilyViewDeadline(isUserParent)
  ) {
    sectionData = [
      ...sectionData,
      {
        id: MY_CALENDAR_CONSTANTS.CLASS_TAGS,
        sectionTitle: isGlobalHeaderEnabled
          ? `${t("calendar:assignment_tags")}`
          : t("common:uppercase", {
              text: `${t("calendar:assignment_tags")}`,
            }),
        data: assessmentData,
        onClick: selectedTags =>
          setSidebarFilters({
            selectedTags,
            key: "assessmentTypes",
            type: MY_CALENDAR_CONSTANTS.ASSESSMENT,
          }),
        selectedTags: assessmentTypes,
        showManageTagsIcon: false,
        tickVariant: "dark",
      },
    ];
  }

  const showEventTags = canUserCreateEvent || isUserStudent || isUserParent;

  if (showEventTags) {
    sectionData = [
      ...sectionData,
      {
        id: MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT_TAGS,
        sectionTitle: isGlobalHeaderEnabled
          ? `${t("announcement:event")}  ${t("common:lowercase", {
              text: `${t("common:tags")}`,
            })}`
          : t("common:uppercase", {
              text: `${t("announcement:event")}  ${t("common:tags")}`,
            }),
        data: formatCalendarEventsTagsMemoize({
          calendarEventsTags: filteredSchoolCalendarTags,
        }),
        onClick: selectedTags =>
          setSidebarFilters({
            selectedTags,
            key: "schoolCalendarTagIds",
            type: MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR,
          }),
        selectedTags: schoolCalendarTagIds,
        withoutLocales: true,
        showManageTagsIcon:
          canUserManageEventTagsWithOldPermissionFallback &&
          isMasterCalendarV2Enabled(),
        tags: filteredSchoolCalendarTags,
        tickVariant: "light",
      },
    ];
  }
  if (
    currentCurriculumProgramType === CURRICULUM_TYPE_MYP &&
    !_.isEmpty(mypEventTags) &&
    (isCalendarOpenedFromHome || isCalendarDeadlineView)
  ) {
    sectionData = [
      ...sectionData,
      {
        sectionTitle: isGlobalHeaderEnabled
          ? `${t("common:MYP")} ${t("common:lowercase", {
              text: `${t("project:project")} ${t("common:tags")}`,
            })}`
          : t("common:uppercase", {
              text: `${t("common:MYP")} ${t("project:project")} ${t(
                "common:tags"
              )}`,
            }),
        data: mypEventTags,
        onClick: selectedTags =>
          setSidebarFilters({
            selectedTags,
            key: "mypTags",
            type: MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT,
          }),
        selectedTags: mypTags,
        tickVariant: "light",
      },
    ];
  }
  if (
    currentCurriculumProgramType === CURRICULUM_TYPE_DP &&
    !_.isEmpty(dpEventTags)
  ) {
    sectionData = [
      ...sectionData,
      {
        sectionTitle: isGlobalHeaderEnabled
          ? getIsCpCoreEnabled()
            ? `${t("common:DP_&_CP")} ${t("common:lowercase", {
                text: t("common:tags"),
              })}`
            : `${t("common:DP")} ${t("common:lowercase", {
                text: t("common:tags"),
              })}`
          : t("common:uppercase", {
              text: getIsCpCoreEnabled()
                ? `${t("common:DP_&_CP")} ${t("common:tags")}`
                : `${t("common:DP")} ${t("common:tags")}`,
            }),
        data: dpEventTags,
        onClick: selectedTags =>
          setSidebarFilters({
            selectedTags,
            key: "dpTags",
            type: MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT,
          }),
        selectedTags: dpTags,
        tickVariant: "light",
      },
    ];
  }

  const showViewOnlyTagsSection =
    isMasterCalendarV1 &&
    isUserStaff &&
    (canUserCreateEvent &&
    isAdminForAllProjectModules({
      currentCurriculumProgramType,
      projectGroupCategoryIdByType,
      currentCurriculumProgramId,
    })
      ? false
      : true);

  /*
  View only tags details are saved as a configuration in the calendar module.
  So if the tags gets updated, the configuration still holds the old details of tag.

  schoolCalendarEventTags contains the latest tags details
  and viewOnlyTagsList contains the tags selected by the user.

  So we need to filter the viewOnlyTagsList based on the schoolCalendarEventTags
  to ensure that the tags displayed in the sidebar are up-to-date.
  */

  const updatedViewOnlyTagsList = _.mapValues(
    viewOnlyTagsList,
    (tagDetails, tagId) => {
      const latestTagDetails = _.find(schoolCalendarEventTags, { id: tagId });

      if (latestTagDetails) {
        return {
          ...tagDetails,
          typeLabel: latestTagDetails?.label,
          color: latestTagDetails?.colorCode,
        };
      }

      return tagDetails;
    }
  );

  if (showViewOnlyTagsSection) {
    sectionData = [
      ...sectionData,
      {
        id: MY_CALENDAR_CONSTANTS.VIEW_ONLY_TAGS,
        sectionTitle: isGlobalHeaderEnabled
          ? t("calendar:other_view_only_tags")
          : t("common:uppercase", {
              text: t("calendar:other_view_only_tags"),
            }),
        showViewOnlyTagsIcon: true,
        data: updatedViewOnlyTagsList,
        withoutLocales: true,
        onClick: selectedTags => setViewOnlyTagsFilters({ selectedTags }),

        selectedTags: selectedViewOnlyTags,
      },
    ];
  }
  return sectionData;
};

export const getCalendarSidebarDataMemoize = _.memoize(
  params => getCalendarSidebarData(params),
  params => JSON.stringify(params)
);

export const globalCalendarTagIds = {
  assessmentTypes: "assessmentTypes",
  schoolCalendarTagIds: "schoolCalendarTagIds",
  mypTags: "mypTags",
  dpTags: "dpTags",
  selectedViewOnlyTags: "selectedViewOnlyTags",
};

export const getGlobalCalendarTagList = ({
  t,
  currentCurriculumProgramType,
  assessmentTypes,
  filteredSchoolCalendarTags,
  schoolCalendarTagIds,
  mypTags,
  dpTags,
  mypEventTags,
  dpEventTags,
  assessmentData,
  isGlobalHeaderEnabled,
}) => {
  let sectionData = [
    {
      id: globalCalendarTagIds.assessmentTypes,
      sectionTitle: isGlobalHeaderEnabled
        ? `${t("calendar:assignment_tags")}`
        : t("common:uppercase", {
            text: `${t("calendar:assignment_tags")}`,
          }),
      data: assessmentData,
      selectedTags: assessmentTypes,
      showManageTagsIcon: false,
      tickVariant: "dark",
    },
    {
      id: globalCalendarTagIds.schoolCalendarTagIds,
      sectionTitle: isGlobalHeaderEnabled
        ? `${t("announcement:event")}  ${t("common:lowercase", {
            text: `${t("common:tags")}`,
          })}`
        : t("common:uppercase", {
            text: `${t("announcement:event")}  ${t("common:tags")}`,
          }),
      data: formatCalendarEventsTagsMemoize({
        calendarEventsTags: filteredSchoolCalendarTags,
      }),
      selectedTags: schoolCalendarTagIds,
      withoutLocales: true,
      tags: filteredSchoolCalendarTags,
      tickVariant: "light",
    },
  ];

  if (
    currentCurriculumProgramType === CURRICULUM_TYPE_MYP &&
    !_.isEmpty(mypEventTags)
  ) {
    sectionData = [
      ...sectionData,
      {
        id: globalCalendarTagIds.mypTags,
        sectionTitle: isGlobalHeaderEnabled
          ? `${t("common:MYP")} ${t("common:lowercase", {
              text: `${t("project:project")} ${t("common:tags")}`,
            })}`
          : t("common:uppercase", {
              text: `${t("common:MYP")} ${t("project:project")} ${t(
                "common:tags"
              )}`,
            }),
        data: mypEventTags,
        selectedTags: mypTags,
        tickVariant: "light",
      },
    ];
  }
  if (
    currentCurriculumProgramType === CURRICULUM_TYPE_DP &&
    !_.isEmpty(dpEventTags)
  ) {
    sectionData = [
      ...sectionData,
      {
        id: globalCalendarTagIds.dpTags,
        sectionTitle: isGlobalHeaderEnabled
          ? getIsCpCoreEnabled()
            ? `${t("common:DP_&_CP")} ${t("common:lowercase", {
                text: t("common:tags"),
              })}`
            : `${t("common:DP")} ${t("common:lowercase", {
                text: t("common:tags"),
              })}`
          : t("common:uppercase", {
              text: getIsCpCoreEnabled()
                ? `${t("common:DP_&_CP")} ${t("common:tags")}`
                : `${t("common:DP")} ${t("common:tags")}`,
            }),
        data: dpEventTags,
        selectedTags: dpTags,
        tickVariant: "light",
      },
    ];
  }

  return sectionData;
};

export const getClassCalendarTags = ({ courseList, courseId }) => {
  return _.reduce(
    courseList,
    (classCalendarTags, { label, value, courseId: id }) => {
      if (courseId === id) {
        return classCalendarTags;
      }
      return {
        ...classCalendarTags,
        [value]: { typeLabel: label, color: colors.blue400 },
      };
    },
    {}
  );
};

const getViewOnlyDpTags = ({ currentDpTags }) => {
  const currentDpTagsProjectTypes = _.keys(currentDpTags);
  return _.reduce(
    dpEventTags,
    (dpTags, value, key) => {
      if (!_.includes(currentDpTagsProjectTypes, key)) {
        dpTags[key] = value;
      }
      return dpTags;
    },
    {}
  );
};

const getViewOnlyDpTagsMemoize = _.memoize(
  params => getViewOnlyDpTags(params),
  params => JSON.stringify(params)
);

const getViewOnlyMypTags = ({ currentMypTags }) => {
  const currentMypTagsProjectTypes = _.keys(currentMypTags);
  return _.reduce(
    mypEventTags,
    (mypTags, value, key) => {
      if (!_.includes(currentMypTagsProjectTypes, key)) {
        mypTags[key] = value;
      }
      return mypTags;
    },
    {}
  );
};

const getViewOnlyMypTagsMemoize = _.memoize(
  params => getViewOnlyMypTags(params),
  params => JSON.stringify(params)
);

export const getInitialSelectedModalTags = ({ calendarTagsPreference }) => {
  if (_.isEmpty(calendarTagsPreference)) {
    return {
      assessmentTypes: [],
      schoolCalendarTagIds: [],
      dpTags: [],
      mypTags: [],
    };
  }

  return _.reduce(
    calendarTagsPreference,
    (selectedTags, { type }, key) => {
      if (_.isEmpty(selectedTags[type])) {
        selectedTags = update(selectedTags, {
          [type]: { $set: [] },
        });
      }
      return update(selectedTags, {
        [type]: { $push: [key] },
      });
    },
    {}
  );
};

export const getInitialSelectedModalTagsMemoize = _.memoize(
  params => getInitialSelectedModalTags(params),
  params => JSON.stringify(params)
);

export const getViewOnlyTagsData = ({
  filteredSchoolCalendarTags,
  schoolCalendarTagIds,
  mypTags,
  dpTags,
  currentCurriculumProgramType,
  currentCurriculumProgramId,
  currentDpTags,
  currentMypTags,
  isCalendarOpenedFromHome,
  isCalendarDeadlineView,
  assessmentTypes,
  t,
  courseList,
}) => {
  const viewOnlyTagsData = [];
  const isStaffAdminForSchoolCalendar = isStaffAdminForSchoolCalendarByContext({
    contexts: [
      {
        entityId: currentCurriculumProgramId,
        entityType: "CURRICULUM_PROGRAM",
      },
    ],
  });
  const canUserCreateEvent = canUserCreateEventOnCalendar({
    isStaffSchoolCalendarAdmin: isStaffAdminForSchoolCalendar,
    currentCurriculumProgramId: currentCurriculumProgramId,
    courseList,
  });
  if (currentCurriculumProgramType === CURRICULUM_TYPE_DP) {
    viewOnlyTagsData.push({
      id: MY_CALENDAR_CONSTANTS.DP_CALENDARS,
      title: `${t("common:DP")} ${t("common:lowercase", {
        text: t("common:tags"),
      })}`,
      data: getViewOnlyDpTagsMemoize({
        currentDpTags,
      }),
      selectedTags: dpTags,
      key: "dpTags",
      withoutLocales: false,
    });
  }
  if (currentCurriculumProgramType === CURRICULUM_TYPE_MYP) {
    viewOnlyTagsData.push({
      id: MY_CALENDAR_CONSTANTS.MYP_CALENDARS,
      title: `${t("common:MYP")} ${t("common:lowercase", {
        text: t("common:tags"),
      })}`,
      data: getViewOnlyMypTagsMemoize({
        currentMypTags,
      }),
      selectedTags: mypTags,
      key: "mypTags",
      withoutLocales: false,
    });
  }
  if (!canUserCreateEvent) {
    viewOnlyTagsData.push({
      id: MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR,
      title: `${t("announcement:event")} ${t("common:lowercase", {
        text: t("common:tags"),
      })}`,
      data: formatCalendarEventsTagsMemoize({
        calendarEventsTags: filteredSchoolCalendarTags,
      }),
      selectedTags: schoolCalendarTagIds,
      key: "schoolCalendarTagIds",
      withoutLocales: true,
    });
    if (isCalendarDeadlineView) {
      viewOnlyTagsData.push({
        id: MY_CALENDAR_CONSTANTS.CLASS_TAGS,
        title: t("common:uppercase", {
          text: `${t("calendar:assignment_tags")}`,
        }),
        data: getFilteredClassStreamTags({
          currentCurriculumProgramType,
        }),
        selectedTags: assessmentTypes,
        key: "assessmentTypes",
        withoutLocales: false,
        tickVariant: "dark",
      });
    }
  }

  return viewOnlyTagsData;
};

export const getViewOnlyTagsDataMemoize = _.memoize(
  params => getViewOnlyTagsData(params),
  params => JSON.stringify(params)
);

export const getSelectedViewOnlyTags = ({ viewOnlyTags }) => {
  return _.reduce(
    viewOnlyTags,
    (selectedViewOnlyTags, { data, selectedTags, key: type }) => {
      _.forEach(data, (val, key) => {
        if (_.includes(selectedTags, key)) {
          return (selectedViewOnlyTags[key] = { ...val, type });
        } else {
          return selectedViewOnlyTags;
        }
      });
      return selectedViewOnlyTags;
    },
    {}
  );
};

export const getYearGroupId = ({
  projectGroupId,
  courseProjectGroups,
  projectGroups,
}) => {
  if (_.isEmpty(projectGroups)) {
    return null;
  }

  if (!_.isEmpty(projectGroupId)) {
    const projectGroup = _.find(projectGroups, { id: projectGroupId });
    return _.get(projectGroup, "yearGroup.id", null);
  }

  if (_.isEmpty(courseProjectGroups)) {
    return null;
  }

  const courseProjectGroupId = _.get(_.head(courseProjectGroups), "id", null);
  const courseProjectGroup = _.filter(
    projectGroups,
    ({ id }) => id === courseProjectGroupId
  );

  return _.get(_.head(courseProjectGroup), "yearGroup.id", null);
};

export const getYearGroupIdMemoize = _.memoize(
  params => getYearGroupId(params),
  params => JSON.stringify(params)
);

export const getSelectedTagType = ({
  selectedTag,
  currentCurriculumProgramType,
}) => {
  if (_.includes(_.keys(dpEventTags), selectedTag)) {
    return "dpTags";
  }
  if (_.includes(_.keys(mypEventTags), selectedTag)) {
    return "mypTags";
  }
  const assessmentTags = _.get(
    getClassTagsForCalendar({ curriculumType: currentCurriculumProgramType }),
    "value",
    {}
  );
  if (_.includes(_.keys(assessmentTags), selectedTag)) {
    return "assessmentTypes";
  }
  return "schoolCalendarTagIds";
};

export const getUpdatedViewMoreData = ({
  selectedTags,
  contentTypes,
  dpEventTags,
  currentDpTags,
  mypEventTags,
  currentMypTags,
  currentCurriculumProgramType,
  currentCurriculumProgramId,
  currentSchoolCalendarIds,
  isCalendarOpenedFromHome,
  isCalendarDeadlineView,
  currentAssessmentTypes,
  courseList,
}) => {
  const updatedViewMoreData = {
    assessmentTypes: [],
    schoolCalendarTagIds: [],
    dpTags: [],
    mypTags: [],
  };
  _.forEach(selectedTags, selectedTag => {
    const type = getSelectedTagType({
      selectedTag,
      currentCurriculumProgramType,
    });
    updatedViewMoreData[type].push(selectedTag);
  });

  const {
    assessmentTypes,
    schoolCalendarTagIds,
    dpTags,
    mypTags,
  } = updatedViewMoreData;

  let modifiedContentTypes = contentTypes;

  modifiedContentTypes = getModifiedContentTypesMemoize({
    selectedTags: isCalendarDeadlineView
      ? assessmentTypes
      : currentAssessmentTypes,
    contentTypes: modifiedContentTypes,
    type: MY_CALENDAR_CONSTANTS.ASSESSMENT,
  });

  const isStaffCalendarAdmin = isStaffAdminForSchoolCalendarByContext({
    contexts: [
      {
        entityId: currentCurriculumProgramId,
        entityType: "CURRICULUM_PROGRAM",
      },
    ],
  });

  const canUserCreateEvent = canUserCreateEventOnCalendar({
    isStaffSchoolCalendarAdmin: isStaffCalendarAdmin,
    currentCurriculumProgramId: currentCurriculumProgramId,
    courseList,
  });

  modifiedContentTypes = getModifiedContentTypesMemoize({
    selectedTags: !canUserCreateEvent
      ? schoolCalendarTagIds
      : currentSchoolCalendarIds,
    contentTypes: modifiedContentTypes,
    type: MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR,
  });

  let updatedDpTags = [];
  if (currentCurriculumProgramType === CURRICULUM_TYPE_DP) {
    const notViewOnlyDpTags = _.filter(currentDpTags, currentDpTag =>
      _.includes(_.keys(dpEventTags), currentDpTag)
    );

    updatedDpTags = [...notViewOnlyDpTags, ...dpTags];

    modifiedContentTypes = getModifiedContentTypesMemoize({
      selectedTags: updatedDpTags,
      contentTypes: modifiedContentTypes,
      type: MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT,
    });
  }

  let updatedMypTags = [];
  if (currentCurriculumProgramType === CURRICULUM_TYPE_MYP) {
    const notViewOnlyMypTags = _.filter(currentMypTags, currentMypTag =>
      _.includes(_.keys(mypEventTags), currentMypTag)
    );

    updatedMypTags = [...notViewOnlyMypTags, ...mypTags];

    modifiedContentTypes = getModifiedContentTypesMemoize({
      selectedTags: updatedMypTags,
      contentTypes: modifiedContentTypes,
      type: MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT,
    });
  }

  return {
    updatedAssessmentTypes: isCalendarDeadlineView
      ? assessmentTypes
      : currentAssessmentTypes,
    updatedSchoolCalendarTagIds: !canUserCreateEvent
      ? schoolCalendarTagIds
      : currentSchoolCalendarIds,
    updatedDpTags,
    updatedMypTags,
    modifiedContentTypes,
  };
};

export const getUpdatedViewMoreDataMemoize = _.memoize(
  params => getUpdatedViewMoreData(params),
  params => JSON.stringify(params)
);

const isViewOnlyTag = ({
  selectedViewOnlyTags,
  tag = {},
  projectGroupType = "",
  itemType,
  isCalendarDeadlineView,
}) => {
  switch (itemType) {
    case MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT:
      return _.includes(selectedViewOnlyTags, tag?.id);

    case MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT:
      if (isProjectTypeIAOrEA({ projectGroupType })) {
        return _.includes(
          selectedViewOnlyTags,
          MY_CALENDAR_CONSTANTS.INTERNAL_EXTERNAL_ASSESSMENT
        );
      }
      return _.includes(selectedViewOnlyTags, projectGroupType);

    default: {
      return isCalendarDeadlineView;
    }
  }
};

export const isViewOnlyTagMemoize = _.memoize(
  params => isViewOnlyTag(params),
  params => JSON.stringify(params)
);

export const getRandomColorForAvatar = ({ id }) => {
  return dsAvatarColors[id % _.size(dsAvatarColors)];
};

export const getDefaultViewOnlyProjectTags = ({
  projectGroups,
  courseProjectGroups,
  projectGroupId,
  courseId,
  isAllProjectsAdmin,
  currentCurriculumProgramType,
  projectGroupCategoryIdByType,
  currentCurriculumProgramId,
}) => {
  //If staff is admin for all projects return
  if (
    isAllProjectsAdmin ||
    !isCurriculumProgramMYPOrDp({ currentCurriculumProgramType })
  ) {
    return {};
  }

  const projectTags =
    currentCurriculumProgramType === CURRICULUM_TYPE_DP
      ? dpEventTags
      : mypEventTags;

  // return default tag if core or subject_group_project deadline view
  if (!_.isEmpty(projectGroupId)) {
    const projectGroup = _.find(projectGroups, { id: projectGroupId }) || {};
    if (_.isEmpty(projectGroup)) {
      return {};
    }
    const { type, subType } = projectGroup;
    const finalProjectGroupType =
      subType === PROJECT_SUBTYPE_CORE ? type : subType;
    if (isProjectTypeIAOrEA({ projectGroupType: finalProjectGroupType })) {
      return {};
    }
    const projectTag = _.find(
      projectTags,
      (tag, type) => type === finalProjectGroupType
    );

    if (
      !_.isEmpty(projectTag) &&
      !isStaffAdminForProject({
        projectGroupType: finalProjectGroupType,
        projectGroupCategoryIdByType,
        curriculumProgramId: currentCurriculumProgramId,
      })
    ) {
      return { [finalProjectGroupType]: projectTag };
    }

    return {};
  }

  if (currentCurriculumProgramType === CURRICULUM_TYPE_MYP) {
    return {};
  }

  // return default tag if main / class calendar view
  const projectGroupsToSearch = !_.isEmpty(courseId)
    ? courseProjectGroups
    : projectGroups;

  return _.reduce(
    projectTags,
    (defaultProjectTags, tag, tagType) => {
      const isProjectGroupExist = _.find(
        projectGroupsToSearch,
        ({ type, subType }) => {
          const projectGroupType =
            subType === PROJECT_SUBTYPE_CORE ? type : subType;
          return projectGroupType === tagType;
        }
      );

      if (
        !isProjectTypeIAOrEA({ projectGroupType: tagType }) &&
        isProjectGroupExist &&
        !isStaffAdminForProject({
          projectGroupType: tagType,
          projectGroupCategoryIdByType,
          curriculumProgramId: currentCurriculumProgramId,
        })
      ) {
        return { ...defaultProjectTags, [tagType]: tag };
      } else {
        return defaultProjectTags;
      }
    },
    {}
  );
};

export const getDefaultViewOnlyProjectTagsMemoize = _.memoize(
  params => getDefaultViewOnlyProjectTags(params),
  params => JSON.stringify(params)
);

export const getDefaultViewOnlyTags = ({
  filteredSchoolCalendarTags,
  eventTagList,
  projectGroups,
  courseProjectGroups,
  projectGroupId,
  courseId,
  currentCurriculumProgramType,
  isMasterCalendarV1,
  isCalendarOpenedFromHome,
  isUserStaff,
  isDefaultViewOnlyTagsSet,
  projectGroupCategoryIdByType,
  currentCurriculumProgramId,
}) => {
  const isAllProjectsAdmin = isAdminForAllProjectModules({
    currentCurriculumProgramType,
    projectGroupCategoryIdByType,
    currentCurriculumProgramId,
  });

  const viewOnlyTags = [];
  let defaultViewOnlyMypTags = [];
  let defaultViewOnlyDpTags = [];
  let defaultViewOnlyEventTags = [];
  let defaultProjectTagsType = null;

  const shouldSetDefaultProjectTags =
    isMasterCalendarV1 &&
    !isDefaultViewOnlyTagsSet &&
    !isAllProjectsAdmin &&
    isCurriculumProgramMYPOrDp({ currentCurriculumProgramType });

  if (shouldSetDefaultProjectTags) {
    const defaultViewOnlyProjectTags = getDefaultViewOnlyProjectTagsMemoize({
      projectGroups,
      courseProjectGroups,
      projectGroupId,
      courseId,
      isAllProjectsAdmin,
      currentCurriculumProgramType,
      projectGroupCategoryIdByType,
      currentCurriculumProgramId,
    });
    if (currentCurriculumProgramType === CURRICULUM_TYPE_DP) {
      defaultViewOnlyDpTags = _.keys(defaultViewOnlyProjectTags);
      defaultProjectTagsType = "dpTags";
    } else {
      defaultViewOnlyMypTags = _.keys(defaultViewOnlyProjectTags);
      defaultProjectTagsType = "mypTags";
    }
    viewOnlyTags.push({
      data: defaultViewOnlyProjectTags,
      selectedTags:
        currentCurriculumProgramType === CURRICULUM_TYPE_DP
          ? defaultViewOnlyDpTags
          : defaultViewOnlyMypTags,
      key: defaultProjectTagsType,
    });
  }

  const isStaffAdminForSchoolCalendar = isStaffAdminForSchoolCalendarByContext({
    contexts: [
      {
        entityId: currentCurriculumProgramId,
        entityType: "CURRICULUM_PROGRAM",
      },
    ],
  });

  const shouldSetDefaultEventTags =
    isMasterCalendarV1 &&
    isUserStaff &&
    !isDefaultViewOnlyTagsSet &&
    !(isStaffAdminForSchoolCalendar && isCalendarOpenedFromHome);

  if (shouldSetDefaultEventTags) {
    defaultViewOnlyEventTags = eventTagList;
    viewOnlyTags.push({
      data: formatCalendarEventsTagsMemoize({
        calendarEventsTags: filteredSchoolCalendarTags,
      }),
      selectedTags: defaultViewOnlyEventTags,
      key: "schoolCalendarTagIds",
    });
  }

  return {
    defaultViewOnlyTagsList: !_.isEmpty(viewOnlyTags)
      ? getSelectedViewOnlyTags({ viewOnlyTags })
      : {},
    defaultViewOnlyDpTags,
    defaultViewOnlyMypTags,
    defaultViewOnlyEventTags,
  };
};

export const getUpdateCalendarTagsPreference = ({
  calendarTagsPreference,
  defaultViewOnlyTagsList,
  projectGroupId,
  courseId,
  currentCurriculumProgramId,
}) => {
  let updatedCalendarTagsPreference = {};
  if (!_.isEmpty(projectGroupId)) {
    updatedCalendarTagsPreference = {
      ...calendarTagsPreference,
      [projectGroupId]: {
        ...defaultViewOnlyTagsList,
        isDefaultValueSet: true,
      },
    };
  } else if (!_.isEmpty(courseId)) {
    updatedCalendarTagsPreference = {
      ...calendarTagsPreference,
      [courseId]: {
        ...defaultViewOnlyTagsList,
        isDefaultValueSet: true,
      },
    };
  } else {
    updatedCalendarTagsPreference = {
      ...calendarTagsPreference,
      [currentCurriculumProgramId]: {
        ...defaultViewOnlyTagsList,
        isDefaultValueSet: true,
      },
    };
  }
  return updatedCalendarTagsPreference;
};

/**
 * This function filters view only list tags
 * Remove all school calendar tags if staff given school calendar admin access
 * Remove all school calendar tags which are deleted by admin
 * Remove all project module tags for which staff has been given admin access
 */
export const getFilteredViewOnlyList = ({
  viewOnlyTagsList,
  eventTagList,
  dpEventTags,
  mypEventTags,
  isCalendarOpenedFromHome,
  projectGroupCategoryIdByType,
  curriculumProgramId,
  courseList,
}) => {
  return _.omitBy(viewOnlyTagsList, (tag, key) => {
    if (key === "isDefaultValueSet") {
      return true;
    }
    const isStaffCalendarAdmin = isStaffAdminForSchoolCalendarByContext({
      contexts: [
        { entityId: curriculumProgramId, entityType: "CURRICULUM_PROGRAM" },
      ],
    });
    const canUserCreateEvent = canUserCreateEventOnCalendar({
      isStaffSchoolCalendarAdmin: isStaffCalendarAdmin,
      currentCurriculumProgramId: curriculumProgramId,
      courseList,
    });

    const type = _.get(tag, "type", "");

    switch (type) {
      case "schoolCalendarTagIds":
        return !_.includes(eventTagList, key) || canUserCreateEvent;
      case "mypTags":
        return (
          _.includes(_.keys(mypEventTags), key) &&
          isStaffAdminForProject({
            projectGroupType: key,
            projectGroupCategoryIdByType,
            curriculumProgramId,
          })
        );
      case "dpTags":
        return (
          _.includes(_.keys(dpEventTags), key) &&
          isStaffAdminForProject({
            projectGroupType: key,
            projectGroupCategoryIdByType,
            curriculumProgramId,
          })
        );
      default:
        return false;
    }
  });
};

const getSelectedCourses = ({ courses, calendarIds }) => {
  return _.filter(courses, ({ calendar }) => {
    const calendarId = _.get(calendar, "id");
    return _.includes(calendarIds, calendarId);
  });
};

export const isCASOrEEClassesSelected = ({ courses, calendarIds }) => {
  const selectedCourses = getSelectedCourses({ courses, calendarIds });
  if (_.isEmpty(selectedCourses)) {
    return false;
  }
  return _.every(selectedCourses, ({ subjects }) => {
    const subjectType = _.head(subjects)?.type;
    return _.includes(["CAS", "EE"], subjectType);
  });
};

export const getViewOnlyClassTagsOnClassFilters = ({
  calendarTagsPreference,
  viewOnlyTagsList,
  isCASOrEESelected,
  projectGroupId,
}) => {
  let viewOnlyClassTagsToInclude = {};
  if (!isCASOrEESelected) {
    viewOnlyClassTagsToInclude = _.get(
      calendarTagsPreference,
      `${projectGroupId}`,
      {}
    );
    viewOnlyClassTagsToInclude = _.pickBy(
      viewOnlyClassTagsToInclude,
      (value, key) => key !== "isDefaultValueSet"
    );
  } else {
    const viewOnlyClassTagsToExclude = _.pickBy(
      viewOnlyTagsList,
      (value, key) => _.includes(["le", "fmt", "smt"], key)
    );
    if (!_.isEmpty(viewOnlyClassTagsToExclude)) {
      viewOnlyClassTagsToInclude = _.pickBy(
        viewOnlyTagsList,
        (value, key) => !_.includes(["le", "fmt", "smt"], key)
      );
    }
  }
  return viewOnlyClassTagsToInclude;
};

// This method returns the parent element for quick view modal positioning
export const getEventPopoverNode = ({
  isMonthlyView,
  startDate,
  eventStartDateMomentObject,
  endDate,
}) => {
  if (isMonthlyView) {
    const daySlotsMonth = document.getElementsByClassName("rbc-date-cell");

    const firstWeekSlots = _.slice(daySlotsMonth, 0, 7);

    const indexStartForCurrentMonth = _.findIndex(firstWeekSlots, slot => {
      return _.toNumber(slot.getElementsByTagName("span")[0].innerHTML) === 1;
    });

    const firstdayOfMonthView = moment(startDate);

    firstdayOfMonthView.subtract(indexStartForCurrentMonth, "days");

    const quickViewPopupParentDate = checkIsDateAfter({
      date1: eventStartDateMomentObject,
      date2: firstdayOfMonthView,
    })
      ? eventStartDateMomentObject
      : firstdayOfMonthView;

    const isOffRangeCell = !isDateInBetween({
      date: quickViewPopupParentDate,
      date1: startDate,
      date2: endDate,
    });

    return getMonthDateCellNodeFromDate({
      date: quickViewPopupParentDate,
      isOffRangeCell,
    });
  } else {
    const daySlotsWeek = document.getElementsByClassName("rbc-day-bg");

    const quickViewPopupParentDate = checkIsDateAfter({
      date1: eventStartDateMomentObject,
      date2: startDate,
    })
      ? eventStartDateMomentObject
      : startDate;

    const daySlotNumber = getDateTimeDifference({
      date1: quickViewPopupParentDate,
      date2: startDate,
    });

    return daySlotsWeek[daySlotNumber];
  }
};

export const getGradeSelectLabelValue = ({ grades, gradeList, t }) => {
  const gradesLength = _.size(grades);

  if (_.isEqual(gradesLength, _.size(gradeList))) return t("common:all");
  else if (_.size(grades)) {
    if (gradesLength > 1) return `${gradesLength} ${t("common:grade_plural")}`;
    else {
      return _.find(gradeList, grade => {
        return _.isEqual(grade?.id, _.first(grades));
      })?.name;
    }
  } else {
    return t("common:none");
  }
};

export const getGroupedDeadlinesListArraySortedByDate = ({
  groupedDeadlinesListArray,
}) => {
  return _.sortBy(groupedDeadlinesListArray, (deadline1, deadline2) => {
    const date1 = _.first(deadline1);
    const date2 = _.first(deadline2);
    const timeDiff = getDateTimeDifference({
      date1,
      date2,
      differenceBy: DATE_TIME_CONSTANTS.minutes,
    });

    return timeDiff;
  });
};
export const getGroupedDeadlinesListArraySortedByDateMemoize = _.memoize(
  params => getGroupedDeadlinesListArraySortedByDate(params),
  params => JSON.stringify(params)
);

/**
 * Checks if the current user has staff admin permissions for the school calendar based on the provided contexts.
 *
 * @param {Object} params - The parameter object.
 * @param {Array} params.contexts - The contexts to check permissions against. example: [{ entityId: curriculumProgramId, entityType: "CURRICULUM_PROGRAM" }]
 * @returns {boolean} - Returns true if the user has permission to manage calendar events and meetings, false otherwise.
 */
export const isStaffAdminForSchoolCalendarByContext = ({ contexts }) => {
  return ACLStorage.getPermissionValueByContext(
    CAN_MANAGE_CALENDAR_EVENTS_AND_MEETINGS_PERMISSION,
    contexts
  );
};

export const isStaffAdminForProject = ({
  projectGroupType,
  defaultForIaOrEa = false,
  projectGroupCategoryIdByType,
  curriculumProgramId,
}) => {
  if (isProjectDeadlineIAOrEA({ value: projectGroupType })) {
    return defaultForIaOrEa;
  }
  const projectGroupCategoryId = _.get(
    projectGroupCategoryIdByType,
    projectGroupType
  );
  if (!projectGroupCategoryId) return false;

  return checkIsProjectCoordinator({
    projectGroupCategoryId,
    curriculumProgramId,
  });
};

export const isStaffAdminForProjectModules = ({
  checkFor = "ANY",
  defaultForIaOrEa = false,
  projectGroupCategoryIdByType,
  curriculumProgramId,
}) => {
  const validateProjectsAdminAccess = (value, projectGroupType) => {
    return isStaffAdminForProject({
      projectGroupType,
      defaultForIaOrEa,
      projectGroupCategoryIdByType,
      curriculumProgramId,
    });
  };

  switch (checkFor) {
    case "ALL_DP_PROJECTS":
      return _.every(dpEventTags, validateProjectsAdminAccess);
    case "ALL_MYP_PROJECTS":
      return _.every(mypEventTags, validateProjectsAdminAccess);
    default: {
      const allProjectTags = { ...mypEventTags, ...dpEventTags };
      return _.some(allProjectTags, validateProjectsAdminAccess);
    }
  }
};

export const isAdminForAllProjectModules = ({
  currentCurriculumProgramType,
  projectGroupCategoryIdByType,
  currentCurriculumProgramId,
}) => {
  return currentCurriculumProgramType === CURRICULUM_TYPE_DP
    ? isStaffAdminForProjectModules({
        checkFor: "ALL_DP_PROJECTS",
        defaultForIaOrEa: true,
        projectGroupCategoryIdByType,
        curriculumProgramId: currentCurriculumProgramId,
      })
    : currentCurriculumProgramType === CURRICULUM_TYPE_MYP
    ? isStaffAdminForProjectModules({
        checkFor: "ALL_MYP_PROJECTS",
        projectGroupCategoryIdByType,
        curriculumProgramId: currentCurriculumProgramId,
      })
    : true;
};

export const isAdminForAllCalendarModules = ({
  currentCurriculumProgramType,
  projectGroupCategoryIdByType,
  currentCurriculumProgramId,
}) => {
  return (
    isStaffAdminForSchoolCalendarByContext({
      contexts: [
        {
          entityId: currentCurriculumProgramId,
          entityType: "CURRICULUM_PROGRAM",
        },
      ],
    }) &&
    isAdminForAllProjectModules({
      currentCurriculumProgramType,
      projectGroupCategoryIdByType,
      currentCurriculumProgramId,
    })
  );
};

export const getProjectGroupType = ({ projectGroups }) => {
  const projectGroup = _.head(projectGroups) || {};
  const type = _.get(projectGroup, "type");
  const subType = _.get(projectGroup, "subType");
  return _.includes(
    [PROJECT_SUBTYPE_CORE, PROJECT_SUBTYPE_SUBJECT_GROUP_PROJECT],
    subType
  )
    ? type
    : subType;
};

export const getIsDeadlineAllDay = ({ eventItem, userType }) => {
  const itemType = _.get(eventItem, "event.itemType", "");
  switch (itemType) {
    case MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT:
      return isUserTypeStaff({ userType })
        ? _.get(eventItem, "event.item.isDeadlineAllDay", true)
        : _.get(eventItem, "event.item.deadline.isDeadlineAllDay", true);
    case MY_CALENDAR_CONSTANTS.CALENDAR_EVENT_ITEM:
      return _.get(eventItem, "event.item.isFullDayEvent", false);
    case MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT:
      return true;
    default:
      return isUserTypeStaff({ userType })
        ? _.get(eventItem, "event.item.isDeadlineAllDay", true)
        : _.get(eventItem, "event.item.deadline.isDeadlineAllDay", true);
  }
};

export const canEditIaOrEaDeadline = ({
  projectGroups,
  projectGroupId,
  projectGroupType,
  isUserStaff,
}) => {
  return (
    isUserStaff &&
    isProjectTypeIAOrEA({ projectGroupType }) &&
    _.find(projectGroups, { id: projectGroupId })
  );
};

export const canEditIaOrEaDeadlineMemoize = _.memoize(
  params => canEditIaOrEaDeadline(params),
  params => JSON.stringify(params)
);

export const IsReflectiveProjectDpTagEnabled = () => {
  return ACLStore.can("Common:ReflectiveProject");
};

const removeDemoCourses = ({ allCourses }) =>
  _.filter(allCourses, { isDemo: false });

export const removeDemoCoursesMemoized = _.memoize(
  params => removeDemoCourses(params),
  params => JSON.stringify(params)
);

export const removeDemoFromOtherCourses = ({ allCourses }) =>
  _.reduce(
    allCourses,
    (otherCourses, { node }) => {
      if (!node.isDemo) {
        otherCourses.push(node);
      }
      return otherCourses;
    },
    []
  );

const getGlobalConstantsQueryFilter = ({ currentAcademicYearId }) => {
  return {
    academicYearIds: currentAcademicYearId,
    names: [ATTENDANCE_GLOBAL_CONSTANTS.OPERATIONAL_DAYS],
  };
};

export const getGlobalConstantsQueryFilterMemoized = _.memoize(
  params => getGlobalConstantsQueryFilter(params),
  params => JSON.stringify(params)
);

const getCourseGradeFilters = ({ academicYearId }) => {
  return {
    academicYearId,
  };
};

export const getCourseGradeFiltersMemoized = _.memoize(
  params => getCourseGradeFilters(params),
  params => JSON.stringify(params)
);

const getCourseFilters = ({
  courseId,
  courseGradeFilters,
  currentCurriculumProgramType,
  organizationCurriculumPrograms,
  currentCurriculumProgramId,
  academicYearSelected,
  isLearningCoursesClassSelectorEnabled = false,
}) => {
  const { id } = academicYearSelected;
  let courseFilters = {};
  if (courseId) {
    const courseDetails = getCourseDetailsFromCache({
      id: courseId,
      courseGradeFilters,
    });
    const curriculumProgramId = _.get(courseDetails, "curriculumProgram.id");
    courseFilters = {
      curriculumProgramIds: [curriculumProgramId],
      academicYear: id,
      fetchOnlyMappedCourses: false,
      ...(isLearningCoursesClassSelectorEnabled
        ? { learningCourseAssignedFilter: "MAPPED" }
        : {}),
    };
  } else {
    courseFilters = {
      ...getUserCoursesFilters({
        currentCurriculumProgramType,
        organizationCurriculumPrograms,
        currentCurriculumProgramId,
        archivalState: "ACTIVE",
      }),
      fetchOnlyMappedCourses: false,
      academicYear: id,
      ...(isLearningCoursesClassSelectorEnabled
        ? { learningCourseAssignedFilter: "MAPPED" }
        : {}),
    };
  }
  return courseFilters;
};

export const getCourseFiltersMemoized = _.memoize(
  params => getCourseFilters(params),
  params => JSON.stringify(params)
);

const getCurriculumGlobalConstantsQueryFilter = ({
  currentAcademicYearId,
  curriculumProgramId,
}) => {
  return {
    academicYearIds: [currentAcademicYearId],
    curriculumProgramIds: curriculumProgramId,
    names: [ATTENDANCE_GLOBAL_CONSTANTS.ROUTINE_MODE],
  };
};

export const getCurriculumGlobalConstantsQueryFilterMemoized = _.memoize(
  params => getCurriculumGlobalConstantsQueryFilter(params),
  params => JSON.stringify(params)
);

const getSchoolCalendarEventTags = ({
  schoolCalendarEventTags,
  hiddenCalendarTagsUid,
}) => {
  return _.filter(
    schoolCalendarEventTags,
    tag => !_.includes(hiddenCalendarTagsUid, _.get(tag, "uid"))
  );
};

export const getSchoolCalendarEventTagsMemoized = _.memoize(
  params => getSchoolCalendarEventTags(params),
  params => JSON.stringify(params)
);

export const isVideoMeeting = (item, itemType) => {
  const { contentType } = item;
  return (
    (itemType === "ASSIGNMENT" && contentType == "ASSIGNMENT_MEETING") ||
    itemType === "CALENDAR_EVENT_ITEM"
  );
};

export const getDateLabel = ({
  isDeadlineEvent,
  t,
  eventDateTime,
  eventEndDateTime,
  isSchoolCalendarEvent = false,
}) => {
  const isSameDay = checkIsDateSame({
    date1: eventDateTime,
    date2: eventEndDateTime,
    check: DATE_TIME_CONSTANTS.DAY,
  });
  if (isDeadlineEvent) {
    return t("common:due_date");
  } else if (isSchoolCalendarEvent) {
    return isSameDay ? t("common:for") : t("common:from");
  } else if (isFutureDateTime(eventDateTime)) {
    return t("classRoom:will_be_assigned_on");
  } else {
    return t("classRoom:assigned_on");
  }
};

export const getSubmissionOpenLabel = ({ t, eventDateTime }) => {
  if (isFutureDateTime(eventDateTime)) {
    return t("calendar:submission_will_open_on");
  } else {
    return t("calendar:submission_opened_on");
  }
};

export const getSubmissionCloseLabel = ({ t, eventDateTime }) => {
  if (isFutureDateTime(eventDateTime)) {
    return t("calendar:submission_will_close_on");
  } else {
    return t("calendar:submission_closed_on");
  }
};

export const getVideoMeetingDateLabel = ({
  isDeadlineEvent,
  t,
  isVideoMeeting,
  eventDateTime,
  isSchoolCalendarEvent,
}) => {
  if (!isVideoMeeting)
    return getDateLabel({
      isDeadlineEvent,
      t,
      eventDateTime,
      eventEndDateTime: eventDateTime,
      isSchoolCalendarEvent,
    });
  return t("common:time");
};

export const isGlobalHeaderEnabledInCalendar = userType => {
  return _.includes(["parent", "student"], userType)
    ? ACLStore.can("FeatureFlag:CalendarGlobalHeaderRevampEnabled")
    : ACLStore.can("FeatureFlag:EnableGlobalHeader");
};

export const getGlobalHeaderFeatureFlagForNonStaff = () =>
  ACLStore.can("FeatureFlag:CalendarGlobalHeaderRevampEnabled");

export const getCalendarEventIdsAfterRemovingPrefix = calendarIds => {
  return _.map(calendarIds, calendarEventId => {
    return _.replace(calendarEventId, "COURSE_CALENDAR=>", "");
  });
};

const getGradeNames = ({ gradeIds, gradeList }) => {
  return _.map(
    _.filter(gradeList, gradeItem => _.includes(gradeIds, gradeItem?.id)),
    item => item?.name
  ).join(", ");
};
export const getGradeNamesMemoize = _.memoize(
  params => getGradeNames(params),
  params => {
    const { gradeIds = [], gradeList = [] } = params;
    return `${gradeIds.join("_")}:${gradeList.length}`;
  }
);

const getGrades = ({ gradeIds, gradeList }) => {
  return _.filter(gradeList, gradeItem => _.includes(gradeIds, gradeItem?.id));
};
export const getGradesMemoize = _.memoize(
  params => getGrades(params),
  params => JSON.stringify(params)
);

const preTagStyle = {
  all: "unset",
  display: "block",
  whiteSpace: "pre-wrap",
  wordWrap: "break-word",
};
export const getDescriptionForDisplay = ({
  description,
  toggleItem,
  showAllDescription,
}) => {
  let slicedDescription = "";
  if (_.size(description) <= 235) {
    return (
      <pre
        dangerouslySetInnerHTML={{
          __html: getStyleStrippedText({
            text: getStringAutoLinks(replaceSlashNWithBRTag(description)),
            type: "SANITIZE_DANGER_HTML_PARAGRAPH",
          }),
        }}
        dir="auto"
        style={{ ...preTagStyle, margin: "0px" }}
      ></pre>
    );
  } else {
    slicedDescription = _.join(_.slice([...description], 0, 235), "");
    return (
      <>
        <pre
          dangerouslySetInnerHTML={{
            __html: getStyleStrippedText({
              text: getStringAutoLinks(
                replaceSlashNWithBRTag(
                  showAllDescription ? description : `${slicedDescription}...`
                )
              ),
              type: "SANITIZE_DANGER_HTML_PARAGRAPH",
            }),
          }}
          dir="auto"
          style={{ ...preTagStyle, margin: "0px" }}
        ></pre>
        {_.size(description) <= 235 ? null : toggleItem}
      </>
    );
  }
};

const getEventDateText = ({
  start,
  end,
  isTimedEvent,
  rawStartDate,
  rawEndDate,
  isTimedSchoolCalendarEvent = false,
}) => {
  const startDateTime = getDateMomentObject(
    isTimedEvent && rawStartDate ? rawStartDate : start
  );
  const endDateTime = getDateMomentObject(
    isTimedEvent && rawEndDate ? rawEndDate : end
  );

  const isOneDayEvent = checkIsDateSame({ date1: start, date2: end });

  if (isOneDayEvent) {
    return isTimedSchoolCalendarEvent
      ? `${formatDate({
          date: startDateTime,
          format: DATE_TIME_CONSTANTS.DD_MMM_ddd_hh_mm_a,
        })} - ${formatDate({
          date: endDateTime,
          format: DATE_TIME_CONSTANTS.hh_mm_a, //since this is same day event we don't need to show date in enddateTime
        })}`
      : formatDate({
          date: startDateTime,
          format: isTimedEvent
            ? DATE_TIME_CONSTANTS.DD_MMM_ddd_hh_mm_a
            : DATE_TIME_CONSTANTS.DD_MMM_ddd,
        });
  } else {
    return `${formatDate({
      date: startDateTime,
      format: DATE_TIME_CONSTANTS.DD_MMM_ddd,
    })} - ${formatDate({
      date: endDateTime,
      format: DATE_TIME_CONSTANTS.DD_MMM_ddd,
    })}`;
  }
};

export const getEventDateTextMemoized = _.memoize(
  params => getEventDateText(params),
  params => JSON.stringify(params)
);

export const filterCreateOptionsOnCalendarByPermission = optionParents => {
  return _.map(optionParents, optionParent => {
    const { options } = optionParent;
    return {
      ...optionParent,
      options: _.filter(options, ({ permission }) => {
        return permission ? ACLStorage.getPermissionValue(permission) : true;
      }),
    };
  });
};

export const getVariablesForCreateEventModalPermissions = ({
  curriculumPrograms,
}) => {
  const contexts = [[]];

  _.forEach(curriculumPrograms, ({ id }) => {
    const context = [
      {
        entityId: id,
        entityType: "CURRICULUM_PROGRAM",
      },
    ];
    contexts.push(context);
  });

  return {
    filters: {
      module: "CALENDAR",
      appType: ["TEACHER_WEB"],
      contexts,
    },
  };
};

/**
 * Get quarters for an academic year (fixed 3-month intervals).
 */
export const getQuartersForAcademicYear = ({ startDate, endDate }) => {
  const quarters = [];
  let currentQuarterStart = startDate.clone();

  while (currentQuarterStart.isBefore(endDate)) {
    let quarterEnd = getDateMomentObject(
      getDecrementedDate({
        date: getIncrementedDate({
          date: currentQuarterStart,
          key: "month",
          incrementBy: 3,
        }),
        key: "day",
        decrementBy: 1,
      })
    );

    // Ensure quarter end doesn't go past the academic year's end date
    if (checkIsDateAfter({ date1: quarterEnd, date2: endDate })) {
      quarterEnd = endDate.clone();
    }

    quarters.push({
      startDate: formatDate({
        date: currentQuarterStart,
        format: DATE_TIME_CONSTANTS.YYYY_MM_DD,
      }),
      endDate: formatDate({
        date: quarterEnd,
        format: DATE_TIME_CONSTANTS.YYYY_MM_DD,
      }),
    });

    // Move to next quarter
    currentQuarterStart = getIncrementedDate({
      date: quarterEnd,
      key: "day",
      incrementBy: 1,
    });
  }

  return quarters;
};

/**
 * Get the quarter for a given date in an academic year.
 */
export const getQuarterForDate = ({ date, quarters }) => {
  const currentDate = formatDate({
    date: getDateMomentObject(date),
    format: DATE_TIME_CONSTANTS.YYYY_MM_DD,
  });

  return (
    _.find(quarters, quarter => {
      const quarterStart = _.get(quarter, "startDate");
      const quarterEnd = _.get(quarter, "endDate");

      return isDateInBetween({
        date: currentDate,
        date1: quarterStart,
        date2: quarterEnd,
        includeStartEnd: true,
      });
    }) || null
  );
};

/**
 * Groups events by start date for fast lookup.
 * @param {Array} events - List of calendar events.
 * @returns {Map} - Map of startDate → Array of events.
 */
const groupEventsByStartDate = events => {
  const groupedMap = new Map();

  _.forEach(events, event => {
    const startDate = getDateMomentObject(_.get(event, "start"));
    const endDate = getDateMomentObject(_.get(event, "end"));
    const currentDate = startDate.clone();

    while (isDateSameOrBefore(currentDate, endDate)) {
      const dateKey = formatDate({
        date: currentDate,
        format: DATE_TIME_CONSTANTS.YYYY_MM_DD,
      });

      if (!groupedMap.has(dateKey)) {
        groupedMap.set(dateKey, []);
      }

      // Only add event if it doesn't already exist for this date
      const eventsForDate = groupedMap.get(dateKey);
      if (
        !_.some(eventsForDate, currentEvent => currentEvent?.id === event?.id)
      ) {
        eventsForDate.push(event);
      }
      currentDate.add(1, "day");
    }
  });

  return groupedMap;
};

/**
 * Gets events starting from today until maxEvents limit.
 * @param {Array} events - List of events.
 * @param {number} maxEvents - Maximum number of events to return.
 * @returns {Array} - Array of { date, events } objects.
 */
export const getFilteredEvents = ({
  calendarEvents,
  currentDate,
  maxEvents = 30,
}) => {
  const today = formatDate({
    date: currentDate,
    format: DATE_TIME_CONSTANTS.YYYY_MM_DD,
  });
  const groupedMap = groupEventsByStartDate(calendarEvents);

  // Ensure today's date is present in the map
  if (!groupedMap.has(today)) {
    groupedMap.set(today, []);
  }

  // Sort keys (dates) for fast lookup
  const sortedDates = _.sortBy(Array.from(groupedMap.keys()), date =>
    getDateMomentObject(date).valueOf()
  );

  // Find first date >= today (Binary Search for fast lookup)
  const startIdx = _.sortedIndex(sortedDates, today);

  return _.chain(sortedDates)
    .slice(startIdx)
    .reduce(
      (acc, date) => {
        if (_.get(acc, "eventCount") >= maxEvents) return acc;

        const eventsForDate = _.sortBy(groupedMap.get(date), [
          event => (_.get(event, "allDay") ? 0 : 1),
          "start",
        ]);

        acc.selectedEvents.push({ date, events: eventsForDate });
        acc.eventCount += _.size(eventsForDate);

        return acc;
      },
      { selectedEvents: [], eventCount: 0 }
    )
    .get("selectedEvents")
    .value();
};

export const getFilteredEventsMemoized = _.memoize(
  params => getFilteredEvents(params),
  ({ calendarEvents, currentDate, maxEvents }) => {
    return JSON.stringify({
      calendarEvents: _.map(calendarEvents, event => ({
        item: event?.item,
        start: event?.start,
        end: event?.end,
      })),
      currentDate,
      maxEvents,
    });
  }
);

/**
 * Gets events starting from today until maxEvents limit.
 * @param {Array} events - List of events.
 * @param {number} maxEvents - Maximum number of events to return.
 * @returns {Array} - Array of { date, events } objects.
 */
export const getFilteredEventsInGlobalHeaderCalendar = ({
  calendarEvents,
  currentDate,
}) => {
  const today = formatDate({
    date: currentDate,
    format: DATE_TIME_CONSTANTS.YYYY_MM_DD,
  });
  const groupedMap = groupEventsByStartDate(calendarEvents);

  // Ensure today's date is present in the map
  if (!groupedMap.has(today)) {
    groupedMap.set(today, []);
  }

  // Sort keys (dates) for fast lookup
  const sortedDates = _.sortBy(Array.from(groupedMap.keys()), date =>
    getDateMomentObject(date).valueOf()
  );
  let isTodayFound = false;

  const lastDay = getIncrementedDate({
    date: _.last(sortedDates),
    key: "day",
    incrementBy: 1,
  });
  const eventMapping = _.chain(sortedDates)
    .reduce(
      (acc, date) => {
        const eventsForDate = _.sortBy(groupedMap.get(date), [
          event => (_.get(event, "allDay") ? 0 : 1),
          "start",
        ]);

        if (
          !isTodayFound &&
          checkIsDateSame({
            date1: date,
            date2: moment(),
            check: DATE_TIME_CONSTANTS.DAY,
          })
        ) {
          isTodayFound = true;
        }

        if (
          !isTodayFound &&
          checkIsDateAfter({
            date1: date,
            date2: formatDate({ format: DATE_TIME_CONSTANTS.YYYY_MM_DD }),
            check: DATE_TIME_CONSTANTS.DAY,
          })
        ) {
          // If we find a future date before finding today, we should include today
          // This happens when there are no events for today
          acc.selectedEvents.push({
            date: formatDate({ format: DATE_TIME_CONSTANTS.YYYY_MM_DD }),
            events: [],
          });
          isTodayFound = true;
        }

        acc.selectedEvents.push({ date, events: eventsForDate });
        acc.eventCount += _.size(eventsForDate);

        return acc;
      },
      { selectedEvents: [], eventCount: 0 }
    )
    .get("selectedEvents")
    .value();

  eventMapping.push({
    date: lastDay,
    events: [],
    isLoading: true,
  });

  return eventMapping;
};

export const getFilteredEventsInGlobalHeaderCalendarMemoized = _.memoize(
  params => getFilteredEventsInGlobalHeaderCalendar(params),
  params => JSON.stringify(params)
);

export const getStartEndTimeTextOfAgendaEvent = ({ startDate, endDate }) => {
  const startPeriod = formatDate({
    date: getDateMomentObject(startDate),
    format: "A",
  });
  const endPeriod = formatDate({
    date: getDateMomentObject(endDate),
    format: "A",
  });

  if (startPeriod === endPeriod) {
    return `${formatDate({
      date: getDateMomentObject(startDate),
      format: "h:mm",
    })} - ${formatDate({
      date: getDateMomentObject(endDate),
      format: "h:mm A",
    })}`;
  }

  return `${formatDate({
    date: getDateMomentObject(startDate),
    format: "h:mm A",
  })} - ${formatDate({
    date: getDateMomentObject(endDate),
    format: "h:mm A",
  })}`;
};
/**
 * Filters a list based on whether items in the list are included in a specific property from a source object.
 * If the property doesn't exist in the source object, the original list is returned unfiltered.
 *
 * @param {Object} options - The options object.
 * @param {Array} options.list - The array to filter.
 * @param {Object} options.sourceObject - The object containing the property to compare against.
 * @param {string|Array<string>} options.propertyPath - The path to the property in the source object.
 *                                                    Can be a string like 'user.permissions' or an array like ['user', 'permissions'].
 * @returns {Array} - The filtered list if the property exists, otherwise the original list.
 */
export const filterByMatchingProperty = ({
  list,
  sourceObject,
  propertyPath,
  isStudentProfileCalendarView,
}) => {
  return _.has(sourceObject, propertyPath) && !isStudentProfileCalendarView
    ? _.filter(list, item =>
        _.includes(_.get(sourceObject, propertyPath, []), item)
      )
    : list;
};

/**
 * Filters calendar content types based on user preferences
 *
 * @param {Array} contentTypes - Array of content type constants to filter
 * @param {Object} curriculumUserPreference - User preference object containing filter settings
 * @param {Object} calendarConstants - Object containing calendar constant values
 * @returns {Array} - Filtered array of content types based on user preferences
 *
 * @description
 * This function determines which content types should be included in calendar views
 * based on user preference settings. It handles several special cases:
 *
 * - If a preference key doesn't exist for a content type, it's included by default
 * - For recurring meetings, they're only included if VIDEO_MEETING is in assessmentTypes
 * - For assessment type, it's excluded if assessmentTypes only contains VIDEO_MEETING
 * - For other types, they're included if their preference array is non-empty
 */
export const getFilteredContentTypes = ({
  currentCurriculumUserPreference,
}) => {
  return _.filter(INITIAL_CONTENT_TYPES, type => {
    const preferenceKeyMap = {
      [MY_CALENDAR_CONSTANTS.ASSESSMENT]: "assessmentTypes",
      [MY_CALENDAR_CONSTANTS.RECURRING_MEETING]: "assessmentTypes",
      [MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR]: "schoolCalendarTagIds",
    };

    const preferenceKey = _.get(preferenceKeyMap, type);

    if (
      _.isEmpty(preferenceKey) ||
      !_.has(currentCurriculumUserPreference, preferenceKey)
    ) {
      return true;
    }

    const preferenceValues = _.get(
      currentCurriculumUserPreference,
      preferenceKey,
      []
    );

    if (_.isEqual(preferenceKey, "assessmentTypes")) {
      const hasVideoMeeting = _.includes(
        preferenceValues,
        MY_CALENDAR_CONSTANTS.VIDEO_MEETING
      );
      const isOnlyVideoMeeting =
        _.isEqual(_.size(preferenceValues), 1) && hasVideoMeeting;

      if (_.isEqual(type, MY_CALENDAR_CONSTANTS.RECURRING_MEETING)) {
        return hasVideoMeeting;
      }

      if (_.isEqual(type, MY_CALENDAR_CONSTANTS.ASSESSMENT)) {
        return !_.isEmpty(preferenceValues) && !isOnlyVideoMeeting;
      }
    }

    return !_.isEmpty(preferenceValues);
  });
};

export const getIsAgendaViewEnabled = () => {
  return ACLStore.can("FeatureFlag:EnableCalendarAgendaViewInWeb");
};

export const getCalendarQueryDateRange = (
  isMonthlyView,
  isAgendaView,
  currentQuarter,
  startDate,
  endDate,
  monthlyViewStartDate,
  monthlyViewEndDate
) => {
  return {
    calendarStartDate: isMonthlyView
      ? monthlyViewStartDate
      : isAgendaView
      ? moment(_.get(currentQuarter, "startDate"))
      : startDate,

    calendarEndDate: isMonthlyView
      ? monthlyViewEndDate
      : isAgendaView
      ? moment(_.get(currentQuarter, "endDate"))
      : endDate,
  };
};

export const getRelativeTop = ({
  events,
  isGlobalHeaderAgendaView = false,
  isForMobileView = false,
}) => {
  if (_.isEmpty(events)) {
    return isGlobalHeaderAgendaView ? 32 : 8;
  }

  const completedEvents = _.sumBy(events, calendarEvent => {
    const allDay = _.get(calendarEvent, "allDay", false);
    const end = _.get(calendarEvent, "end");
    return allDay || !isFutureDateTime(end) ? 1 : 0;
  });

  if (isGlobalHeaderAgendaView) {
    const eventHeight = 46;
    const verticalGapBetweenEvents = 12;
    return completedEvents > 0
      ? completedEvents * (eventHeight + verticalGapBetweenEvents) - 6
      : -8;
  }
  const eventHeight = isForMobileView ? 60 : 36;
  return completedEvents > 0 ? completedEvents * eventHeight - 4 : -4;
};
export const getNewUserCalendarPreference = ({ userId }) => {
  return (
    getSettingValue({
      name: "Common:UserCalendarPreference",
      userId,
      readFromUserAndOrgLevel: true,
    }) || {}
  );
};

/**
 * Gets the user's calendar preference object for a given context.
 * @param {Object} params
 * @param {string} params.userId - The user ID.
 * @param {string} [params.calendarType=CALENDAR_TYPES.MASTER_CALENDAR] - The type of calendar (master/class/etc).
 * @param {string|number} params.currentCurriculumProgramId - The curriculum program ID.
 * @returns {Object} The user calendar preference object.
 */
export const getUserCalendarPreference = ({
  userId,
  calendarType = CALENDAR_TYPES.MASTER_CALENDAR,
  currentCurriculumProgramId,
}) => {
  const preference = getNewUserCalendarPreference({ userId });
  const calendarPreference = _.get(preference, "WEB", {});
  const isParent = getIsParent();
  const userCalendarPreference = _.get(
    calendarPreference,
    getReadPreferencePath({
      currentCurriculumProgramId: currentCurriculumProgramId,
      isParent,
      studentId: getChildId(),
      calendarType,
    }),

    {}
  );
  return userCalendarPreference;
};

export const isNewUserClassPreferenceEmpty = preference => {
  return _.isEmpty(_.get(preference, "classes", []));
};

/**
 * Returns a filtered array of class IDs representing the user's calendar class preferences.
 * @param {Object} params
 * @param {string} [params.calendarType=CALENDAR_TYPES.MASTER_CALENDAR]
 * @param {string} params.userId
 * @param {Array} params.courseList
 * @param {string} params.userEntityType
 * @param {string|number} params.currentCurriculumProgramId
 * @returns {Array<string>} Array of class/calendar IDs.
 */
export const getFilteredUserCalendarClassPreference = ({
  calendarType = CALENDAR_TYPES.MASTER_CALENDAR,
  userId,
  courseList,
  userEntityType,
  currentCurriculumProgramId,
}) => {
  const userCalendarPreference = getUserCalendarPreference({
    userId,
    calendarType,
    currentCurriculumProgramId,
  });
  const selectedClassIds = isNewUserClassPreferenceEmpty(userCalendarPreference)
    ? _.filter(
        getSettingValue({
          name: "Common:CalendarPreference",
          userId,
          userEntityType,
          currentCurriculumProgramId,
        }) || [],
        calendarId => _.find(courseList, course => course.value === calendarId)
      )
    : _.filter(_.get(userCalendarPreference, "classes", []), calendarId =>
        _.find(courseList, course => course.value === calendarId)
      );
  return selectedClassIds;
};

/**
 * Transforms user tag selections into the expected format for the calendar
 *
 * @param {Object} userTagSelectionFromSetting - User's saved tag preferences
 * @param {string} currentCurriculumProgramId - ID of the current curriculum program
 * @return {Object} An object with structure { tagTypeId: { tagId: true, ... }, ... }
 */
export const transformUserTagSelectionsToMapping = (
  userTagSelectionFromSetting,
  currentCurriculumProgramId
) => {
  // Extract tags for current curriculum program

  const currentProgramTags = _.get(
    userTagSelectionFromSetting,
    currentCurriculumProgramId,
    {}
  );

  return {
    tags: currentProgramTags,
  };
};

export const getGlobalCalenderCourseFilters = ({
  currentCurriculumProgramType,
  organizationCurriculumPrograms,
  currentCurriculumProgramId,
  archivalState,
  selectedAcademicYearId,
  isLearningCoursesClassSelectorEnabled,
}) => {
  let courseFilters = getUserCoursesFilters({
    currentCurriculumProgramType,
    organizationCurriculumPrograms,
    currentCurriculumProgramId,
    archivalState,
  });
  courseFilters = {
    ...courseFilters,
    fetchOnlyMappedCourses: false,
    academicYear: selectedAcademicYearId,
    ...(isLearningCoursesClassSelectorEnabled
      ? { learningCourseAssignedFilter: "MAPPED" }
      : {}),
  };

  return courseFilters;
};

export const getFilteredProjectGroupIds = ({
  selectedTagsMapping,
  projectGroups,
  currentCurriculumProgramType,
}) => {
  let projectGroupTypes = getProjectGroupIds({
    selectedTagsMapping,
    curriculumType: currentCurriculumProgramType,
  });
  if (
    _.includes(
      projectGroupTypes,
      MY_CALENDAR_CONSTANTS.INTERNAL_EXTERNAL_ASSESSMENT
    )
  ) {
    projectGroupTypes = _.chain(projectGroupTypes)
      .without(MY_CALENDAR_CONSTANTS.INTERNAL_EXTERNAL_ASSESSMENT)
      .concat([
        PROJECT_SUBTYPE_INTERNAL_ASSESSMENT,
        PROJECT_SUBTYPE_EXTERNAL_ASSESSMENT,
      ])
      .value();
  }

  const projectGroupIds = _.chain(projectGroups)
    .filter(projectGroup => {
      // Check if projectGroupTypes includes either type or subType
      return _.some([projectGroup?.type, projectGroup?.subType], type =>
        _.includes(projectGroupTypes, type)
      );
    })
    .map(projectGroup => projectGroup?.id)
    .value();

  return projectGroupIds;
};

export const getGlobalCalendarFilteredContentTypes = ({
  schoolCalendarTagIds,
  assessmentTypes,
  projectGroupIds,
}) => {
  let filteredContentTypes = [...INITIAL_CONTENT_TYPES];
  if (
    _.size(projectGroupIds) > 0 &&
    !_.includes(
      filteredContentTypes,
      MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT
    )
  ) {
    filteredContentTypes.push(MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT);
  }
  if (_.isEmpty(projectGroupIds)) {
    filteredContentTypes = _.without(
      filteredContentTypes,
      MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT
    );
  }
  if (_.isEmpty(schoolCalendarTagIds)) {
    filteredContentTypes = _.without(
      filteredContentTypes,
      MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR
    );
  }

  const hasVideoMeeting = _.includes(
    assessmentTypes,
    MY_CALENDAR_CONSTANTS.VIDEO_MEETING
  );
  if (
    (_.size(assessmentTypes) === 1 && hasVideoMeeting) ||
    _.isEmpty(assessmentTypes)
  ) {
    filteredContentTypes = _.without(
      filteredContentTypes,
      MY_CALENDAR_CONSTANTS.ASSESSMENT
    );
  }

  if (!hasVideoMeeting) {
    filteredContentTypes = _.without(
      filteredContentTypes,
      MY_CALENDAR_CONSTANTS.RECURRING_MEETING
    );
  }

  return filteredContentTypes;
};

export const getSchoolCalendarTagIds = selectedTagsMapping => {
  return _.filter(
    _.get(selectedTagsMapping, globalCalendarTagIds.schoolCalendarTagIds, []),
    tagId => tagId !== "undefined"
  );
};

export const getAssessmentTypes = selectedTagsMapping => {
  return _.filter(
    _.get(selectedTagsMapping, globalCalendarTagIds.assessmentTypes, []),
    assessmentType => assessmentType !== "undefined"
  );
};

export const getTagKey = curriculumType => {
  return curriculumType === CURRICULUM_TYPE_DP
    ? globalCalendarTagIds.dpTags
    : globalCalendarTagIds.mypTags;
};
export const getProjectGroupIds = ({ selectedTagsMapping, curriculumType }) => {
  return _.get(
    selectedTagsMapping,
    globalCalendarTagIds?.[getTagKey(curriculumType)]
  );
};

/**
 * Updates the user's calendar preference for a specific filter key (e.g., classes or tags).
 * @param {Object} params
 * @param {any} params.newPreference - The new preference value to set.
 * @param {Function} params.updateSettings - Function to trigger the settings update.
 * @param {string|number} params.currentCurriculumProgramId
 * @param {string} params.calendarType
 * @param {string} params.filterKey - Key to update (e.g., "classes" or "tags").
 * @param {string} params.userId
 * @param {string|null} [params.preferencePath] - Optional preference path for parent context.
 * @returns {Promise<void>}
 */
export const updateUserCalendarPreference = async ({
  newPreference,
  updateSettings,
  currentCurriculumProgramId,
  calendarType,
  filterKey,
  userId,
  preferencePath,
}) => {
  try {
    // Get existing preferences or empty object if none exists
    const existingPreferences = _.cloneDeep(
      getNewUserCalendarPreference({ userId }) || {}
    );

    // Create a deep copy of the existing preferences
    const updatedPreference = _.cloneDeep(existingPreferences);
    const path = preferencePath
      ? [
          "WEB",
          preferencePath,
          `CURRICULUMPROGRAM_${currentCurriculumProgramId}`,
          calendarType,
          filterKey,
        ]
      : [
          "WEB",
          `CURRICULUMPROGRAM_${currentCurriculumProgramId}`,
          calendarType,
          filterKey,
        ];
    // Set the new preference at the exact path, replacing any previous value
    _.set(updatedPreference, path, newPreference);

    await updateSettings({
      settings: [
        {
          name: "Common:UserCalendarPreference",
          value: JSON.stringify(updatedPreference),
        },
      ],
      showToastMsg: false,
    });
  } catch (error) {
    console.error(error, "Error updating user calendar preference");
  }
};

const getCurrentOrgIdForCalendarPreference = () => getUserInfo()?.org_id;

const getCchPreferencePath = orgId => [
  "WEB",
  `${ORGANIZATION_PREFERENCE_KEY_PREFIX}${orgId}`,
  CCH_SELECTED_CURRICULUMPROGRAM_KEY,
];

/**
 * Returns the persisted CCH-last-selected curriculum program id for the current
 * user in the current organization, or null when absent.
 * @param {Object} params
 * @param {string} params.userId
 * @returns {string|null}
 */
export const getCchSelectedCurriculumProgramId = ({ userId }) => {
  const orgId = getCurrentOrgIdForCalendarPreference();
  if (!orgId) return null;
  const preference = getNewUserCalendarPreference({ userId });
  return _.get(preference, getCchPreferencePath(orgId), null);
};

/**
 * Persists the CCH-last-selected curriculum program id for the current user in
 * the current organization. `_.set` on a deep-cloned object preserves sibling
 * keys (`CURRICULUMPROGRAM_*`, other `ORGANIZATION_*` buckets).
 * @param {Object} params
 * @param {string} params.curriculumProgramId
 * @param {Function} params.updateSettings - settings-mutation thunk
 * @param {string} params.userId
 * @returns {Promise<void>}
 */
export const updateCchSelectedCurriculumProgramId = async ({
  curriculumProgramId,
  updateSettings,
  userId,
}) => {
  try {
    const orgId = getCurrentOrgIdForCalendarPreference();
    if (!orgId || !curriculumProgramId) return;

    const updatedPreference = _.cloneDeep(
      getNewUserCalendarPreference({ userId }) || {}
    );
    _.set(updatedPreference, getCchPreferencePath(orgId), curriculumProgramId);

    await updateSettings({
      settings: [
        {
          name: "Common:UserCalendarPreference",
          value: JSON.stringify(updatedPreference),
        },
      ],
      showToastMsg: false,
    });
  } catch (error) {
    console.error(
      error,
      "Error updating CCH selected curriculum program preference"
    );
  }
};

export const getClassCalendarUserPreferences = ({
  userId,
  currentCurriculumProgramId,
  calendarType = CALENDAR_TYPES.MASTER_CALENDAR,
  userEntityType,
}) => {
  const newCalendarPreference = getUserCalendarPreference({
    userId,
    calendarType,
    currentCurriculumProgramId,
  });
  const calendarPreference = isNewUserClassPreferenceEmpty(
    newCalendarPreference
  )
    ? getSettingValue({
        userId,
        userEntityType,
        name: "Common:CalendarPreference",
        currentCurriculumProgramId,
      })
    : _.get(newCalendarPreference, "classes", []);

  return calendarPreference;
};

export const isDailyViewCalendar = calendarView => {
  return VIEW_FILTER_MAPPING.DAILY === calendarView;
};

export const getGlobalCalendarAgendaViewCurrentDate = state => {
  return _.get(state, "myCalendar.dailyView.agendaView.currentDate");
};

export const getGlobalCalendarAgendaViewSelectedDate = state => {
  return _.get(state, "myCalendar.dailyView.agendaView.selectedDate");
};

export const isEnableAgendaViewInGlobalHeaderCalendar = () => {
  return ACLStore.can("FeatureFlag:EnableAgendaViewInGlobalHeaderCalendar");
};

export const getIsCalendarRevampPhase1Enabled = () => {
  return ACLStore.can("FeatureFlag:EnableCalendarRevampPhase1");
};

export const getCalendarEventsSortedFilters = filters => {
  const {
    type,
    calendarIds,
    folderIds,
    excludedAssessmentTypes,
    startDate,
    endDate,
    assessmentTypes,
    taskTypeIds,
    schoolCalendarTagIds,
    contentTypes,
    curriculumType,
    projectGroupIds,
    curriculumProgramId,
    academicYearId,
  } = filters;

  const isAssessmentTypeConfigurationEnabled = getIsAssessmentTypeConfigurationEnabled();

  // Sorting filter variables alphabetically for maintaining consistency apollo cache use stringify method for caching
  const sortedFilters = {
    type,
    academicYearId,
    calendarIds: _.sortBy(calendarIds),
    contentTypes: _.sortBy(contentTypes),
    curriculumProgramId,
    curriculumType: curriculumType,
    endDate,
    excludedAssessmentTypes: _.sortBy(excludedAssessmentTypes),
    folderIds: _.sortBy(folderIds),
    projectGroupIds: _.sortBy(projectGroupIds),
    schoolCalendarTagIds: _.sortBy(schoolCalendarTagIds),
    startDate,
    // Use taskTypeIds when FF is enabled, otherwise use assessmentTypes
    ...(isAssessmentTypeConfigurationEnabled
      ? { taskTypeIds: _.sortBy(taskTypeIds || assessmentTypes) }
      : { assessmentTypes: _.sortBy(assessmentTypes) }),
  };
  return sortedFilters;
};

export const mergeCalendarEvents = (calendarEvents, formattedCacheEvents) => {
  if (_.isEmpty(calendarEvents)) {
    return {
      mergedEvents: formattedCacheEvents,
      isCacheData: true,
    };
  }

  // Map real-time events by their unique event ID
  const realTimeEventsById = new Map(
    calendarEvents.map(event => [event.id, event])
  );

  // Group real-time events by item.id for handling new/unmatched events
  const realTimeEventsByItemId = new Map();
  calendarEvents.forEach(event => {
    const itemId = _.get(event, "item.id");
    if (itemId) {
      if (!realTimeEventsByItemId.has(itemId)) {
        realTimeEventsByItemId.set(itemId, []);
      }
      realTimeEventsByItemId.get(itemId).push(event);
    }
  });

  // Track which events have been processed
  const processedEventIds = new Set();

  // Process cached events, replacing with real-time versions when available
  const mergedEvents = _.map(formattedCacheEvents, cachedEvent => {
    const cachedEventId = _.get(cachedEvent, "id");
    // If we have a direct match by event.id, use the real-time version
    if (cachedEventId && realTimeEventsById.has(cachedEventId)) {
      processedEventIds.add(cachedEventId);
      return realTimeEventsById.get(cachedEventId);
    }

    // Otherwise, try matching by item.id - these are updates where the event id changed
    const itemId = _.get(cachedEvent, "item.id");
    if (itemId && realTimeEventsByItemId.has(itemId)) {
      const matchingEvents = realTimeEventsByItemId.get(itemId);

      // Look for an event with matching start/end times
      const startTimeMatch = _.find(
        matchingEvents,
        rtEvent =>
          _.get(rtEvent, "start") === _.get(cachedEvent, "start") &&
          _.get(rtEvent, "end") === _.get(cachedEvent, "end")
      );

      if (startTimeMatch) {
        processedEventIds.add(_.get(startTimeMatch, "id"));
        return startTimeMatch;
      }

      // For recurring events where time was updated, match by event ID prefix
      // Format: CALENDAR_EVENT_ITEM=>{itemId}=>{date}T{time}
      // Match by: CALENDAR_EVENT_ITEM=>{itemId}=>{date} (ignore time part)
      if (cachedEventId && _.includes(cachedEventId, "T")) {
        const cachedEventIdPrefix = cachedEventId.substring(
          0,
          cachedEventId.lastIndexOf("T")
        );

        const prefixMatch = _.find(matchingEvents, rtEvent => {
          const rtEventId = _.get(rtEvent, "id");
          if (!rtEventId || !_.includes(rtEventId, "T")) return false;

          const rtEventIdPrefix = rtEventId.substring(
            0,
            rtEventId.lastIndexOf("T")
          );
          return (
            cachedEventIdPrefix === rtEventIdPrefix &&
            !processedEventIds.has(rtEventId)
          );
        });

        if (prefixMatch) {
          processedEventIds.add(_.get(prefixMatch, "id"));
          return prefixMatch;
        }
      }

      // If only one real-time event with this item.id, it might be an update
      if (
        _.size(matchingEvents) === 1 &&
        !processedEventIds.has(matchingEvents[0]?.id)
      ) {
        processedEventIds.add(matchingEvents[0]?.id);
        return matchingEvents[0];
      }
    }

    // Default: keep the cached event
    return cachedEvent;
  });

  // Add any real-time events that weren't matched with cached events
  const newRealTimeEvents = calendarEvents.filter(
    event => !processedEventIds.has(event.id)
  );

  return {
    mergedEvents: [...mergedEvents, ...newRealTimeEvents],
    isCacheData: true,
  };
};

/**
 * Returns the user's selected tag preference for the calendar.
 * @param {Object} params
 * @param {string} params.userId
 * @param {string|number} params.currentCurriculumProgramId
 * @param {string} [params.calendarType=CALENDAR_TYPES.MASTER_CALENDAR]
 * @param {string} params.userEntityType
 * @returns {Array<string>} Array of tag IDs.
 */

export const getUserCalendarViewPreference = ({
  userId,
  currentCurriculumProgramId,
  calendarType = CALENDAR_TYPES.MASTER_CALENDAR,
}) => {
  const newCalendarPreference = getUserCalendarPreference({
    userId,
    calendarType,
    currentCurriculumProgramId,
  });
  const calendarViewPreference = _.get(
    newCalendarPreference,
    "calendarView",
    MY_CALENDAR_CONSTANTS.AGENDA
  );
  return calendarViewPreference;
};

/**
 * Returns the current calendar view type based on context.
 * @param {boolean} isClassRoomCalendar
 * @returns {string} One of CALENDAR_TYPES.CLASS_CALENDAR or CALENDAR_TYPES.MASTER_CALENDAR
 */
export const getCurrentCalendarViewType = isClassRoomCalendar => {
  return isClassRoomCalendar
    ? CALENDAR_TYPES.CLASS_CALENDAR
    : CALENDAR_TYPES.MASTER_CALENDAR;
};

/**
 * Returns the user's selected full screen calendar tags with fallback.
 * @param {Object} params
 * @param {string} params.userId
 * @param {string|number} params.currentCurriculumProgramId
 * @param {boolean} params.isClassRoomCalendar
 * @returns {{ userTagSelectionFromSetting: Object }} User's tag selection.
 */
export const getUserSelectedFullScreenCalendarTagPreference = ({
  userId,
  currentCurriculumProgramId,
  isClassRoomCalendar,
}) => {
  const userOldTagSelectionFromSetting =
    getSettingValue({
      name: "Common:UserSelectedCalendarTags",
      userId,
      readFromUserAndOrgLevel: true,
    }) || {};

  const calendarViewType = getCurrentCalendarViewType(isClassRoomCalendar);
  const newUserTagSelectionFromSetting = getUserCalendarPreference({
    userId,
    calendarType: calendarViewType,
    currentCurriculumProgramId,
  });

  const userSelectedNewTagsPreference = newUserTagSelectionFromSetting?.tags;
  const userTagSelectionFromSetting = _.isEmpty(userSelectedNewTagsPreference)
    ? userOldTagSelectionFromSetting
    : { [currentCurriculumProgramId]: userSelectedNewTagsPreference };

  return { userTagSelectionFromSetting };
};

export const getPreferencePath = () => {
  const isParent = getIsParent();
  const studentId = getChildId();
  return isParent ? `STUDENT_${studentId}` : null;
};

/**
 * Returns the read preference path array for accessing nested user preferences.
 * @param {Object} params
 * @param {string|number} params.currentCurriculumProgramId
 * @param {string} params.calendarType
 * @returns {Array<string>} Path segments for lodash _.get/_.set.
 */
export const getReadPreferencePath = ({
  currentCurriculumProgramId,
  calendarType,
}) => {
  const isParent = getIsParent();
  const studentId = getChildId();
  return isParent
    ? [
        `STUDENT_${studentId}`,
        `CURRICULUMPROGRAM_${currentCurriculumProgramId}`,
        calendarType,
      ]
    : [`CURRICULUMPROGRAM_${currentCurriculumProgramId}`, calendarType];
};

export const MODAL_HEIGHT = 400;
export const MODAL_WIDTH = 496;
/**
 * Sets the position of the modal relative to the button
 * @param {Object} params - Parameter object
 * @param {React.RefObject} params.modalRef - Reference to the modal DOM element
 * @param {React.RefObject} params.buttonRef - Reference to the button DOM element
 */
export const setPosition = ({ modalRef, buttonRef }) => {
  if (modalRef?.current) {
    // Get button position or use fallback values
    const { x, y } = buttonRef?.current?.getBoundingClientRect() || {
      x: 1412, // Fallback x position for 1500px screen
      y: 70, // Fallback y position for
    };

    const iconHeight = buttonRef?.current?.offsetHeight || 30;
    const iconWidth = buttonRef?.current?.offsetWidth || 30;

    // Calculate appropriate position for modal
    // Position it to align with right side of viewport with some margin
    // This is more responsive than using a fixed offset
    const windowWidth = window.innerWidth;
    const modalWidth = MODAL_WIDTH; // Using the defined width from Modal props
    const rightMargin = 16; // Margin from right edge

    const leftPosition = Math.min(
      // Don't let it go beyond right edge
      windowWidth - modalWidth - rightMargin,
      // Try to align it near the button, but shifted left to account for modal width
      x - (modalWidth - iconWidth)
    );

    // Apply the calculated position
    Object.assign(modalRef.current.style, {
      left: `${leftPosition}px`,
      top: `${y + iconHeight}px`,
      margin: "0px",
      overflowY: "hidden",
    });
  }
};

const getFlatClassListArrayWithLearningCourses = ({
  courseOptions,
  isLearningCoursesClassSelectorEnabled = false,
}) => {
  const shouldShowDisplayNames = getShouldShowCourseDisplayName();

  // If display names are enabled and user is not staff, map options to use learningCourseDisplayName or learningCourseTitle as label else fallback to course title
  if (shouldShowDisplayNames) {
    return _.map(courseOptions, option => ({
      ...option,
      label:
        _.get(option, "learningCourseDisplayName") ||
        _.get(option, "learningCourseTitle") ||
        _.get(option, "title", ""),
    }));
  } else if (isLearningCoursesClassSelectorEnabled) {
    //if learning courses class selector is enabled, group by learning course title
    return (
      _.chain(courseOptions)
        // First sort by learning course title
        .sortBy(option => _.get(option, "learningCourseTitle", ""))
        // Group options with same learning course title together
        .groupBy(option => _.get(option, "learningCourseTitle", ""))
        // Transform grouped data into the final array with headers
        .reduce((result, groupOptions, learningCourseTitle) => {
          // Only add header if there's a learning course title
          if (learningCourseTitle) {
            // Get learning course ID from the first option in the group
            const learningCourseId = _.get(groupOptions[0], "learningCourseId");

            // Add header for this group
            result.push({
              label: learningCourseTitle,
              value: `header-${learningCourseId}`,
              isHeader: true,
            });
          }

          // Add all options from this group
          return result.concat(groupOptions);
        }, [])
        .value()
    );
  } else {
    // Fallback to original options if no special handling is needed
    return courseOptions;
  }
};

export const getFlatClassListArrayWithLearningCoursesMemoized = _.memoize(
  params => getFlatClassListArrayWithLearningCourses(params),
  ({ courseOptions }) => _.map(courseOptions, course => course.value).join(",")
);

export const isNewEventCreationFlowEnabled = () => {
  return ACLStore.can("FeatureFlag:EnableCalendarRevampPhase2");
};

export const canUserManageEventTags = ({ isStaffSchoolCalendarAdmin }) => {
  const rnpEnabled = ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION);
  const hasAdminAccess = hasModuleAdminAccess({
    moduleName: MODULES.SCHOOL_CALENDAR.id,
  });

  // CLD3        Manage events types
  const canUserManageEventTags = rnpEnabled
    ? ACLStorage.getPermissionValueByContext(
        CLD3_CAN_MANAGE_CALENDAR_EVENT_TYPES_ACCOUNT_LEVEL_PERMISSION,
        []
      )
    : hasAdminAccess;

  const canUserManageEventTagsWithStaffAccessFallback = isNewEventCreationFlowEnabled()
    ? canUserManageEventTags
    : isStaffSchoolCalendarAdmin;

  return canUserManageEventTagsWithStaffAccessFallback;
};

export const canUserCreateEventOnSomeClass = ({ courseList }) => {
  let filteredCourses = [];
  const permissionsToCheck = [CLDC1_CAN_MANAGE_CALENDAR_CLASS_LEVEL_PERMISSION];

  const isRnPEnabled = ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION);

  if (isRnPEnabled) {
    filteredCourses = _.filter(
      courseList,
      ({ aclControlParameters = [] } = {}) => {
        if (_.isEmpty(aclControlParameters)) {
          return false;
        }

        const isViewOrManageAccessInAnyConsumingModule = _.some(
          aclControlParameters,
          ({ permission, value }) =>
            _.includes(permissionsToCheck, permission) && value
        );
        return isViewOrManageAccessInAnyConsumingModule;
      }
    );
  } else {
    /**
     * When RnP is disabled, teachers have the ability to create events.
     * Note: We return the permission value here instead of directly returning true
     * to support if we introduce any future view-only permission scenarios.
     */
    return ACLStorage.getPermissionValue(
      CLDC1_CAN_MANAGE_CALENDAR_CLASS_LEVEL_PERMISSION
    );
  }
  return !_.isEmpty(filteredCourses);
};

export const canUserCreateHolidaysAndWholeSchoolEvents = ({
  currentCurriculumProgramId,
}) => {
  const userAccessLevel = getUserEventCreationAccessLevel({
    currentCurriculumProgramId,
    alsoCheckClassLevelPermission: false,
  });

  return _.includes(["ACCOUNT_LEVEL", "PROGRAM_LEVEL"], userAccessLevel);
};

export const canUserCreateEventOnCalendar = ({
  isStaffSchoolCalendarAdmin,
  currentCurriculumProgramId,
  courseList,
}) => {
  //Fallback for old event creation flow
  if (!isNewEventCreationFlowEnabled()) return isStaffSchoolCalendarAdmin;

  // CLD4        Manage all holidays and events
  const canUserManageCalendarHolidayAndEventsAccountLevel = ACLStorage.getPermissionValueByContext(
    CLD4_CAN_MANAGE_CALENDAR_HOLIDAY_EVENTS_ACCOUNT_LEVEL_PERMISSION,
    []
  );
  // CLD2        Manage programme holidays and events
  const canUserManageCalendarHolidayAndEventsForProgram = ACLStorage.getPermissionValueByContext(
    CAN_MANAGE_CALENDAR_EVENTS_AND_MEETINGS_PERMISSION,
    [
      {
        entityId: currentCurriculumProgramId,
        entityType: "CURRICULUM_PROGRAM",
      },
    ]
  );
  // CLDC1        Manage events, assignment and video meeting  on calendar
  const canUserManageCalendarEventsInAnyClass = canUserCreateEventOnSomeClass({
    courseList,
  });

  return (
    canUserManageCalendarHolidayAndEventsAccountLevel ||
    canUserManageCalendarHolidayAndEventsForProgram ||
    canUserManageCalendarEventsInAnyClass
  );
};
/**
 * Determines the user's access level for creating calendar events.
 *
 * @param {Object} params - The parameters object
 * @param {string|number} params.currentCurriculumProgramId - The current curriculum program ID
 * @param {boolean} [params.alsoCheckClassLevelPermission=true] - Whether to check class-level permissions
 * @param {Array} [params.courseList=[]] - List of courses for class-level permission check
 * @returns {string} Access level: "ACCOUNT_LEVEL", "PROGRAM_LEVEL", "CLASS_LEVEL", or "NO_ACCESS"
 */
export const getUserEventCreationAccessLevel = ({
  currentCurriculumProgramId,
  alsoCheckClassLevelPermission = true,
  courseList = [],
}) => {
  // Check account-level permission (highest priority)
  const hasAccountLevelAccess = ACLStorage.getPermissionValueByContext(
    CLD4_CAN_MANAGE_CALENDAR_HOLIDAY_EVENTS_ACCOUNT_LEVEL_PERMISSION,
    []
  );

  if (hasAccountLevelAccess) {
    return "ACCOUNT_LEVEL";
  }

  // Check program-level permission
  const hasProgramLevelAccess = ACLStorage.getPermissionValueByContext(
    CAN_MANAGE_CALENDAR_EVENTS_AND_MEETINGS_PERMISSION,
    [
      {
        entityId: currentCurriculumProgramId,
        entityType: "CURRICULUM_PROGRAM",
      },
    ]
  );

  if (hasProgramLevelAccess) {
    return "PROGRAM_LEVEL";
  }

  // Check class-level permission (if enabled)
  if (alsoCheckClassLevelPermission) {
    const hasClassLevelAccess = canUserCreateEventOnSomeClass({ courseList });

    if (hasClassLevelAccess) {
      return "CLASS_LEVEL";
    }
  }

  return alsoCheckClassLevelPermission ? "NO_ACCESS" : "CLASS_LEVEL";
};

const getAssociatedEntities = ({
  associatedEntities = [],
  entityType,
  users,
}) => {
  if (entityType === "CUSTOM") {
    return users;
  }
  if (_.isEmpty(associatedEntities)) return [];

  let formattedEntities = associatedEntities;

  if (entityType === "CLASSES") {
    // Big-org staff with the new participant selector uses a lightweight V2 query
    // that only fetches Course { id }, so grades/title/counts are not available.
    // Skip the grades-presence filter in that case so selected courses aren't dropped.
    const isBigOrgStaffWithNewSelector =
      isNewParticipantSelectorEnabled() && isBigOrgFFEnabledAndStaffUser();
    const mappedEntities = _.map(associatedEntities, entity => ({
      id: entity?.id,
      title: entity?.title,
      grades: _.map(entity?.grades, grade => ({
        id: grade?.id,
        name: grade?.name,
      })),
      staffCount: _.get(entity, "collaborator.totalCount", 0),
      studentCount: _.get(entity, "students.totalCount", 0),
      familyMemberCount: _.get(entity, "familyMembers.totalCount", 0),
    }));
    formattedEntities = isBigOrgStaffWithNewSelector
      ? mappedEntities
      : _.filter(mappedEntities, ({ grades }) => !_.isEmpty(grades));
  }

  return _.map(formattedEntities, entity => ({
    ...entity,
    groupId: entity?.curriculumProgram?.id,
  }));
};

export const DEFAULT_REMINDER_VALUE_MAPPING = {
  scheduleTime: 10,
  sentVia: ["EMAIL", "IN_APP", "PUSH"],
};

export const getEndType = ({
  repeatEventSettings,
  academicYearEndDate,
  count,
}) => {
  let endType = END_TYPES.ACADEMIC_YEAR;
  if (count) {
    endType = END_TYPES.AFTER_OCCURRENCES;
  } else {
    const endDateValue = repeatEventSettings?.endDate;
    let repeatEndDate = null;

    if (endDateValue) {
      // Check if it's a numeric timestamp (convert string to number if needed)
      const numericValue = _.toNumber(endDateValue);
      if (_.isFinite(numericValue) && !_.isNaN(numericValue)) {
        // It's a valid number, treat as timestamp
        repeatEndDate = getDateMomentObject(numericValue);
      } else if (_.isString(endDateValue) && moment(endDateValue).isValid()) {
        // It's a valid date string, skip processing
        repeatEndDate = getDateMomentObject(endDateValue);
      }
    }
    const academicEndDate = getDateMomentObject(academicYearEndDate);

    if (repeatEndDate && academicEndDate) {
      endType = repeatEndDate.isSame(academicEndDate)
        ? END_TYPES.ACADEMIC_YEAR
        : END_TYPES.ON_DATE;
    } else {
      endType = END_TYPES.ACADEMIC_YEAR;
    }
  }
  return endType;
};

/**
 * Converts a time string in HH:MM format to total minutes.
 *
 * @param {string} timeString - The time string in "HH:MM" format (e.g., "14:30")
 * @returns {number} The total number of minutes, or 0 if the input is invalid
 *
 * @example
 * convertTimeToMinutes("14:30"); // returns 870 (14*60 + 30)
 * convertTimeToMinutes("00:15"); // returns 15
 * convertTimeToMinutes("invalid"); // returns 0
 * convertTimeToMinutes(null); // returns 0
 */
export const convertTimeToMinutes = timeString => {
  if (!timeString || typeof timeString !== "string") {
    return 0;
  }

  const [hours, minutes] = timeString.split(":").map(Number);

  if (isNaN(hours) || isNaN(minutes)) {
    return 0;
  }

  return hours * 60 + minutes;
};

const transformEventReminders = eventReminders => {
  return _.map(eventReminders, reminder => {
    return {
      id: nanoid(10),
      scheduleTime:
        reminder?.reminderOffset +
        convertTimeToMinutes(reminder?.triggerTimeOffset),
      sentVia: reminder?.channels,
      triggerDayOffset: reminder?.triggerDayOffset,
      triggerTimeOffset: reminder?.triggerTimeOffset,
    };
  });
};

export const getTransformedEventDataFromQuery = (eventDetails = {}) => {
  const {
    eventDescription,
    eventLocation,
    eventName,
    scheduleEndDate,
    scheduleStartDate,
    tag = {},
    id,
    attachments,
    sharedWith,
    associatedEntities,
    eventReminders,
    users = [],
    repeatEventSettings = null,
    metadata,
    academicYearEndDate,
  } = eventDetails;

  const ENTITY_TYPE_MAPPING = {
    Course: "CLASSES",
    Grade: "GRADES",
  };
  const entityType =
    ENTITY_TYPE_MAPPING[_.get(_.first(associatedEntities), "__typename")] ||
    "CUSTOM";
  const participants = {
    GRADES: [],
    CLASSES: [],
    CUSTOM: [],
    [entityType]: getAssociatedEntities({
      associatedEntities,
      entityType,
      users,
    }),
  };
  const isAllDayEvent = eventDetails?.isFullDayEvent;

  const startDateTime = getDateMomentObject(scheduleStartDate);
  const endDateTime = getDateMomentObject(scheduleEndDate);

  const updatedAttachments = _.map(attachments, attachment => {
    return _.omit(attachment, ["__typename"]);
  });
  const reminders = transformEventReminders(eventReminders);
  const { count } = repeatEventSettings || {};
  return {
    eventId: id,
    eventTitle: eventName,
    eventType: tag?.value,
    startDate: isAllDayEvent ? scheduleStartDate : startDateTime,
    endDate: isAllDayEvent ? scheduleEndDate : endDateTime,
    readOnlyStartDate: isAllDayEvent ? scheduleStartDate : startDateTime,
    readOnlyEndDate: isAllDayEvent ? scheduleEndDate : endDateTime,
    isAllDayEvent: isAllDayEvent,
    participants,
    location: eventLocation,
    description: eventDescription,
    attachments: updatedAttachments,
    initialAttachments: updatedAttachments,
    reminders: reminders,
    eventUID: tag?.uid,
    sharedWith: _.map(sharedWith, userType =>
      userType === "PARENT" ? "FAMILY_MEMBER" : userType
    ),
    entityType,
    totalParticipantUserCount: _.size(participants?.[entityType]),
    isCurrentEventIsRepeatEvent: !_.isEmpty(repeatEventSettings),
    readOnlyExistingRepeatEventSettings: !_.isEmpty(repeatEventSettings)
      ? {
          ..._.omit(repeatEventSettings, "__typename"),
          id: RECURRING_QUERY_TYPE_MAPPING[metadata?.recurrenceType],
          endDate: repeatEventSettings?.endDate,
          endType: getEndType({
            repeatEventSettings,
            academicYearEndDate,
            count,
          }),
        }
      : null,
    repeatEventSettings: !_.isEmpty(repeatEventSettings)
      ? {
          ..._.omit(repeatEventSettings, "__typename"),
          id: RECURRING_QUERY_TYPE_MAPPING[metadata?.recurrenceType],
          endDate: repeatEventSettings?.endDate,
          endType: getEndType({
            repeatEventSettings,
            academicYearEndDate,
            count,
          }),
        }
      : null,
    skipNonOperationalDays: metadata?.skipNonOperationalDays || false,
    readOnlySkipNonOperationalDays: metadata?.skipNonOperationalDays || false,
    isRepeatEvent: !_.isEmpty(repeatEventSettings),
  };
};

export const MEETING_SERVICE_OPTIONS = {
  OTHER: "OTHER",
  GOOGLE: "GOOGLE",
  ZOOM: "ZOOM",
  MICROSOFT: "MICROSOFT",
};

export const getTransformedVideoMeetingDataFromQuery = (
  videoMeetingDetails = {}
) => {
  const {
    id,
    item: videoMeetingBaseDetails,
    academicYearEndDate,
    startTime,
    endTime,
  } = videoMeetingDetails;

  const ENTITY_TYPE_MAPPING = {
    Course: "CLASSES",
    Grade: "GRADES",
  };

  const {
    label,
    isFullDayEvent,
    location,
    description,
    tag,
    meeting,
    repeatEventSettings,
    metadata,
    associatedEntities,
    sharedWith,
    attachments,
    eventReminders,
    users,
  } = videoMeetingBaseDetails || {};
  const entityType =
    ENTITY_TYPE_MAPPING[_.get(_.first(associatedEntities), "__typename")] ||
    "CUSTOM";
  const participants = {
    GRADES: [],
    CLASSES: [],
    CUSTOM: [],
    [entityType]: getAssociatedEntities({
      associatedEntities,
      entityType,
      users,
    }),
  };
  const isAllDayEvent = isFullDayEvent;

  const startDateTime = getDateMomentObject(startTime);
  const endDateTime = getDateMomentObject(endTime);

  const updatedAttachments = _.map(attachments, attachment => {
    return _.omit(attachment, ["__typename"]);
  });
  const reminders = transformEventReminders(eventReminders);
  const { count } = repeatEventSettings || {};
  const meetingService = meeting?.type || MEETING_SERVICE_OPTIONS.OTHER;
  const meetingUrls = { ...(meeting?.urls || {}) };
  delete meetingUrls.__typename;
  const isCustomMeetingLink = meetingService === MEETING_SERVICE_OPTIONS.OTHER;
  const thirdPartyMeetingLinkData = isCustomMeetingLink
    ? {}
    : {
        id: meeting?.id,
        meetingUrl: meeting?.meetingUrl,
        meetingData: {
          ...meetingUrls,
        },
        type: meeting?.type,
      };
  const meetingLink = isCustomMeetingLink ? meeting?.urls?.url : null;
  return {
    eventId: id,
    eventTitle: label,
    eventType: tag?.value,
    startDate: startDateTime,
    endDate: endDateTime,
    readOnlyStartDate: startDateTime,
    readOnlyEndDate: endDateTime,
    isAllDayEvent: isAllDayEvent,
    participants,
    location,
    description,
    meetingService,
    thirdPartyMeetingLinkData,
    attachments: updatedAttachments,
    initialAttachments: updatedAttachments,
    reminders: reminders,
    eventUID: tag?.uid,
    meetingLink,
    sharedWith: _.map(sharedWith, userType =>
      userType === "PARENT" ? "FAMILY_MEMBER" : userType
    ),
    entityType,
    totalParticipantUserCount: _.size(participants?.[entityType]),
    isCurrentEventIsRepeatEvent: !_.isEmpty(repeatEventSettings),
    readOnlyExistingRepeatEventSettings: !_.isEmpty(repeatEventSettings)
      ? {
          ..._.omit(repeatEventSettings, "__typename"),
          id: RECURRING_QUERY_TYPE_MAPPING[metadata?.recurrenceType],
          endDate: repeatEventSettings?.endDate,
          endType: getEndType({
            repeatEventSettings,
            academicYearEndDate,
            count,
          }),
        }
      : null,
    repeatEventSettings: !_.isEmpty(repeatEventSettings)
      ? {
          ..._.omit(repeatEventSettings, "__typename"),
          id: RECURRING_QUERY_TYPE_MAPPING[metadata?.recurrenceType],
          endDate: repeatEventSettings?.endDate,
          endType: getEndType({
            repeatEventSettings,
            academicYearEndDate,
            count,
          }),
        }
      : null,
    skipNonOperationalDays: metadata?.skipNonOperationalDays || false,
    readOnlySkipNonOperationalDays: metadata?.skipNonOperationalDays || false,
    isRepeatEvent: !_.isEmpty(repeatEventSettings),
  };
};

export const getDurationInMinutes = ({ start, end }) => {
  const startDay = getStartOfDate({ date: start });
  const endDay = getStartOfDate({ date: end });
  const durationDays = endDay.diff(startDay, "days") + 1;
  return durationDays * 1440;
};

export const getIsHolidayOrWholeSchoolEvent = tag => {
  return _.includes([HOLIDAYS_AND_VACATIONS, WHOLE_SCHOOL_EVENTS], tag?.uid);
};

export const canUserEditEventForProgram = ({ currentCurriculumProgramId }) => {
  return ACLStorage.getPermissionValueByContext(
    CAN_MANAGE_CALENDAR_EVENTS_AND_MEETINGS_PERMISSION,
    [
      {
        entityId: currentCurriculumProgramId,
        entityType: "CURRICULUM_PROGRAM",
      },
    ]
  );
};

export const canUserEditEventForAll = ({ currentCurriculumProgramId }) => {
  const isUserAdminByRole = getIsAdminByRole();
  const rnpEnabled = ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION);
  const hasAccountLevelAccess = ACLStorage.getPermissionValueByContext(
    CLD4_CAN_MANAGE_CALENDAR_HOLIDAY_EVENTS_ACCOUNT_LEVEL_PERMISSION,
    []
  );
  const hasProgramLevelAccess = canUserEditEventForProgram({
    currentCurriculumProgramId,
  });

  if (!hasProgramLevelAccess) {
    return false;
  }

  return rnpEnabled ? hasAccountLevelAccess : isUserAdminByRole;
};

export const isRecurringSchoolCalendarEventActionsEnabled = () => {
  return ACLStore.can("FeatureFlag:EnableRecurringSchoolCalendarEventActions");
};

export const isShowAllClassesInCalendarClassFilterEnabled = () => {
  return ACLStore.can("FeatureFlag:ShowAllClassesInCalendarClassFilter");
};

export const isCalendarEventAssessmentEnabled = curriculumProgramType => {
  const isUbDCurriculum = _.isEqual(curriculumProgramType, CURRICULUM_TYPE_UBD);
  return (
    ACLStore.can("FeatureFlag:EnableCalendarEventAssessment") && isUbDCurriculum
  );
};

export const isGcalSubscriptionTempfixEnabled = () => {
  return ACLStore.can("FeatureFlag:EnableGcalSubscriptionTempfix");
};

export const getAssessmentTypeOptions = ({
  t = () => {},
  getCurrentAssessmentTypes,
}) => {
  const isAssessmentTypeConfigurationEnabled = getIsAssessmentTypeConfigurationEnabled();
  const currentAssessmentTypes = getCurrentAssessmentTypes();
  const filteredAssessmentTypes = {};
  const assessmentTypeOptionsToShow = _.reduce(
    currentAssessmentTypes,
    (options, { localeLabel, label, isEnabled = false, ...rem }, uid) => {
      if (!isEnabled) {
        return options;
      }
      filteredAssessmentTypes[uid] = {
        typeLabel: localeLabel || label,
        label,
        isEnabled,
        localeLabel,
        color: isAssessmentTypeConfigurationEnabled
          ? _.get(rem, "color", colors.teal500)
          : _.get(
              UBD_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
              ["as", "color"],
              colors.teal500
            ),
        newColor: isAssessmentTypeConfigurationEnabled
          ? _.get(rem, "newColor", colors.teal900)
          : _.get(
              UBD_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
              ["as", "newColor"],
              colors.teal900
            ),
        dotColor: isAssessmentTypeConfigurationEnabled
          ? _.get(rem, "dotColor", colors.teal500)
          : _.get(
              UBD_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR,
              ["as", "dotColor"],
              colors.teal500
            ),
        ...rem,
      };
      const assessmentTypeLabel = localeLabel ? t(localeLabel) : label;
      return [
        ...options,
        {
          label: assessmentTypeLabel,
          value: isAssessmentTypeConfigurationEnabled ? _.get(rem, "uid") : uid,
        },
      ];
    },
    []
  );

  return { assessmentTypeOptionsToShow, filteredAssessmentTypes };
};

export const getStartWeekOfMonth = startDate => {
  return getDateMomentObject(startDate).startOf("month").startOf("week");
};

export const getEndWeekOfMonth = endDate => {
  // adding an extra day to endDate to handle the case because on backend endDate is considered as exclusive
  // but on frontend we are treating endDate as inclusive, so to align both we are adding an extra day here
  return getDateMomentObject(endDate)
    .endOf("month")
    .endOf("week")
    .add(1, "day");
};

export const isBigOrgFFEnabledAndStaffUser = () => {
  return ACLStore.can(COMBINE_CURRICULUM_HOME_PAGE_PERMISSION) && getIsStaff();
};

export const getEnabledProgramIds = () => {
  return _.get(
    getProgramListForModule(HOME_PAGE_FEATURE_CALENDAR),
    "enabledCurriculumProgramIds",
    []
  );
};

export const getCurrentAcademicYearForSelectedSchool = selectedSchool => {
  return _.chain(selectedSchool)
    .get("academicYears", [])
    .find({ isCurrentAcademicYear: true })
    .value();
};

export const getSelectedSchoolId = state =>
  _.get(state, "myCalendar.selectedSchool.selectedSchoolId");

export const getSelectedSchoolType = state =>
  _.get(state, "myCalendar.selectedSchool.selectedSchoolType");

export const getSelectedAcademicYearForSchool = state => {
  return getSelectedAcademicYear(state);
};

export const getSelectedAcademicYearIdForSchool = state => {
  return getSelectedAcademicYearId(state);
};

/**
 * Retrieves the selected school details for the calendar view
 * @param {Object} state - The application state
 * @returns {Object} An object containing:
 *   - currentCurriculumProgramId: ID of the current curriculum program
 *   - currentCurriculumProgramType: Type of the current curriculum program
 *   - currentAcademicYear: Current academic year details
 */
export const getSelectedSchoolDetailsForCalendar = state => {
  const orgPrograms = getOrganizationCurriculumPrograms(state);

  const selectedSchoolId =
    getSelectedSchoolId(state) || _.first(orgPrograms)?.id;
  const selectedSchoolType =
    getSelectedSchoolType(state) || _.first(orgPrograms)?.type;

  const currentAcademicYear = getCurrentAcademicYearForSelectedSchool(
    _.chain(orgPrograms)
      .find({
        id: selectedSchoolId,
      })
      .value()
  );

  const currentCurriculumProgramId = isBigOrgFFEnabledAndStaffUser()
    ? selectedSchoolId
    : state?.platform?.currentCurriculumProgram?.id;
  const currentCurriculumProgramType = isBigOrgFFEnabledAndStaffUser()
    ? selectedSchoolType
    : state?.platform?.currentCurriculumProgram?.type;

  return {
    currentCurriculumProgramId,
    currentCurriculumProgramType,
    currentAcademicYear,
  };
};

export const isNewParticipantSelectorEnabled = () => {
  return ACLStore.can("FeatureFlag:NewParticipantDetailsModal");
};
